// // import React, { useState, useRef } from 'react';
// // import {
// //   Button,
// //   Box,
// //   Typography,
// //   Paper,
// //   Table,
// //   TableBody,
// //   TableCell,
// //   TableContainer,
// //   TableHead,
// //   TableRow,
// //   Container,
// //   Grid,
// //   CircularProgress,
// //   Chip,
// //   Divider,
// //   Fade,
// //   Grow,
// //   Tooltip,
// //   IconButton,
// //   Alert,
// //   Snackbar
// // } from '@mui/material';
// // import {
// //   Dialog,
// //   DialogActions,
// //   DialogContent,
// //   DialogTitle
// // } from '@mui/material';
// // import CloudUploadIcon from '@mui/icons-material/CloudUpload';
// // import DeleteIcon from '@mui/icons-material/Delete';
// // import FileOpenIcon from '@mui/icons-material/FileOpen';
// // import InfoIcon from '@mui/icons-material/Info';
// // import TableChartIcon from '@mui/icons-material/TableChart';
// // import SendIcon from '@mui/icons-material/Send';
// // import ErrorOutlineIcon from '@mui/icons-material/ErrorOutline';
// // import * as XLSX from 'xlsx';
// // import { createTheme, ThemeProvider } from '@mui/material/styles';
// // import { FormControlLabel, Checkbox } from '@mui/material';
// // import Header from '../Header';


// // const theme = createTheme({
// //   palette: {
// //     primary: {
// //       main: '#1976d2',
// //     },
// //     secondary: {
// //       main: '#f50057',
// //     },
// //     background: {
// //       default: '#f5f7fa',
// //     },
// //   },
// //   typography: {
// //     h4: {
// //       fontWeight: 600,
// //     },
// //     button: {
// //       fontWeight: 500,
// //     },
// //   },
// //   components: {
// //     MuiPaper: {
// //       styleOverrides: {
// //         root: {
// //           borderRadius: 12,
// //           boxShadow: '0 4px 20px 0 rgba(0,0,0,0.1)',
// //         },
// //       },
// //     },
// //     MuiButton: {
// //       styleOverrides: {
// //         root: {
// //           borderRadius: 8,
// //           textTransform: 'none',
// //           padding: '10px 24px',
// //         },
// //       },
// //     },
// //     MuiTableCell: {
// //       styleOverrides: {
// //         head: {
// //           backgroundColor: '#f0f5ff',
// //           fontWeight: 'bold',
// //         },
// //       },
// //     },
// //   },
// // });

// // const RateUploadScreen = () => {
// //   const [file, setFile] = useState(null);
// //   const [fileName, setFileName] = useState('');
// //   const [isLoading, setIsLoading] = useState(false);
// //   const [isUploading, setIsUploading] = useState(false);
// //   const [excelData, setExcelData] = useState([]);
// //   const [notification, setNotification] = useState({ open: false, message: '', severity: 'info' });
// //   const [validatedData, setValidatedData] = useState(null);
// //   const [invalidRows, setInvalidRows] = useState([]);
// //   const [duplicateRows, setDuplicateRows] = useState([]);
// //   const [rateErrorRows, setRateErrorRows] = useState([]);
// //   const token = localStorage.getItem('AuthorizationToken');
// //   const [isMOCRateRequired, setIsMOCRateRequired] = useState(false);
// //   const [isVANRateRequired, setIsVANRateRequired] = useState(false);
// //   const fileInputRef = useRef(null);
// //   const [invalidRowsList, setInvalidRowsList] = useState([]); // Add this new state
// //   const [isMRPRateRequired, setIsMRPRateRequired] = useState(true); // Default to true unlike the others
// //   const [apiErrors, setApiErrors] = useState([]);
// //   const [showApiErrorsDialog, setShowApiErrorsDialog] = useState(false);






// //   const handleFileChange = (event) => {
// //     const selectedFile = event.target.files[0];
// //     if (selectedFile) {
// //       setFile(selectedFile);
// //       setFileName(selectedFile.name);
// //       setValidatedData(null);
// //       setInvalidRows([]);
// //       setDuplicateRows([]);
// //       setRateErrorRows([]);
// //       setNotification({
// //         open: true,
// //         message: `File "${selectedFile.name}" selected successfully`,
// //         severity: 'success'
// //       });
// //     }
// //   };




// //   const handleCheckboxChange = (type) => {
// //     if (type === 'MOC') {
// //       setIsMOCRateRequired(!isMOCRateRequired);
// //     } else if (type === 'VAN') {
// //       setIsVANRateRequired(!isVANRateRequired);
// //     } else if (type === 'MRP') {
// //       setIsMRPRateRequired(!isMRPRateRequired);
// //     }
// //     // Clear existing validation when checkbox state changes
// //     setValidatedData(null);
// //     setInvalidRows([]);
// //     setDuplicateRows([]);
// //     setRateErrorRows([]);
// //   };



// //   const handleImport = () => {
// //     if (!file) {
// //       setNotification({
// //         open: true,
// //         message: 'Please select a file first',
// //         severity: 'warning'
// //       });
// //       return;
// //     }

// //     setIsLoading(true);
// //     setInvalidRows([]);
// //     setDuplicateRows([]);
// //     setRateErrorRows([]);
// //     console.log('Import button pressed. File:', file.name);

// //     // Read the Excel file
// //     const reader = new FileReader();
// //     reader.onload = (e) => {
// //       try {
// //         const data = new Uint8Array(e.target.result);
// //         const workbook = XLSX.read(data, { type: 'array' });
// //         const firstSheetName = workbook.SheetNames[0];
// //         const worksheet = workbook.Sheets[firstSheetName];

// //         // Convert Excel data to JSON
// //         const jsonData = XLSX.utils.sheet_to_json(worksheet);

// //         // Check if data contains required columns
// //         // Modify the handleImport function validation section
// //         if (jsonData.length > 0) {
// //           const headers = Object.keys(jsonData[0]);
// //           const requiredColumns = ['AreaId', 'ItemCode', 'MRPRate'];

// //           // Add conditional required columns based on checkboxes
// //           if (isMOCRateRequired) requiredColumns.push('MOCRate');
// //           if (isVANRateRequired) requiredColumns.push('VANRate');

// //           const missingColumns = requiredColumns.filter(col =>
// //             !headers.some(header => header.toLowerCase() === col.toLowerCase())
// //           );

// //           if (missingColumns.length > 0) {
// //             setNotification({
// //               open: true,
// //               message: `Missing required columns: ${missingColumns.join(', ')}`,
// //               severity: 'error'
// //             });
// //             setIsLoading(false);
// //             return;
// //           }

// //           // Check for prohibited columns based on selection
// //           if ((isMOCRateRequired && !isVANRateRequired && headers.some(h => h.toLowerCase() === 'vanrate')) ||
// //             (isVANRateRequired && !isMOCRateRequired && headers.some(h => h.toLowerCase() === 'mocrate'))) {
// //             setNotification({
// //               open: true,
// //               message: isMOCRateRequired && !isVANRateRequired ?
// //                 'VANRate column is not allowed when only MOCRate is selected' :
// //                 'MOCRate column is not allowed when only VANRate is selected',
// //               severity: 'error'
// //             });
// //             setIsLoading(false);
// //             return;
// //           }

// //           if (!isMOCRateRequired && !isVANRateRequired && !isMRPRateRequired) {
// //             setNotification({
// //               open: true,
// //               message: 'Please select at least one rate type',
// //               severity: 'error'
// //             });
// //             setIsLoading(false);
// //             return;
// //           }

// //           // Track invalid rows and duplicate AreaId+ItemCode combinations
// //           const invalidRowsList = [];
// //           const rateErrorRowsList = [];
// //           const areaItemCombinations = new Map();
// //           const duplicateRowsList = [];


// //           // Validate data types and business rules
// //           // Replace the part where you validate data types and business rules
// //           // Look for the section around line 228 (in the handleImport function)
// //           // Replace the validation and error collection logic with this:

// //           // Validate data types and business rules
// //           const validData = jsonData.map((row, index) => {
// //             // Define specific error types for more detailed reporting
// //             const errors = [];

// //             // Check for empty values
// //             // Check for empty values
// //             if (!row.AreaId || !row.ItemCode) {
// //               errors.push('missing_identifier');
// //             }

// //             if ((isMOCRateRequired && (row.MOCRate === undefined || row.MOCRate === null || row.MOCRate === '')) ||
// //               (isVANRateRequired && (row.VANRate === undefined || row.VANRate === null || row.VANRate === '')) ||
// //               (isMRPRateRequired && (row.MRPRate === undefined || row.MRPRate === null || row.MRPRate === ''))) {
// //               errors.push('missing_rate');
// //             }

// //             // Check for negative values
// //             const vanRate = Number(row.VANRate);
// //             const mocRate = Number(row.MOCRate);
// //             const mrpRate = Number(row.MRPRate);

// //             if ((isVANRateRequired && vanRate < 0) ||
// //               (isMOCRateRequired && mocRate < 0) ||
// //               (isMRPRateRequired && mrpRate < 0)) {
// //               errors.push('negative_rate');
// //             }

// //             // Check for more than two decimal places
// //             if ((isVANRateRequired && !Number.isInteger(vanRate * 100) && !isNaN(vanRate)) ||
// //               (isMOCRateRequired && !Number.isInteger(mocRate * 100) && !isNaN(mocRate)) ||
// //               (isMRPRateRequired && !Number.isInteger(mrpRate * 100) && !isNaN(mrpRate))) {
// //               errors.push('invalid_decimals');
// //             }

// //             // Check for double decimal points
// //             if ((isVANRateRequired && String(row.VANRate).split('.').length > 2) ||
// //               (isMOCRateRequired && String(row.MOCRate).split('.').length > 2) ||
// //               (isMRPRateRequired && String(row.MRPRate).split('.').length > 2)) {
// //               errors.push('double_decimal');
// //             }

// //             // Check for non-numeric rates
// //             if ((isVANRateRequired && isNaN(vanRate)) ||
// //               (isMOCRateRequired && isNaN(mocRate)) ||
// //               (isMRPRateRequired && isNaN(mrpRate))) {
// //               errors.push('non_numeric_rate');
// //             }

// //             // Store error information for this row
// //             if (errors.length > 0) {
// //               invalidRowsList.push({
// //                 rowNumber: index + 1,
// //                 errors: errors
// //               });
// //             }

// //             // Check for rate errors (VANRate or MOCRate > MRPRate)
// //             const hasRateError = (isVANRateRequired && vanRate > mrpRate) || (isMOCRateRequired && mocRate > mrpRate);
// //             if (hasRateError) {
// //               rateErrorRowsList.push(index + 1);
// //             }

// //             // Check for duplicate AreaId + ItemCode combinations
// //             const key = `${row.AreaId}-${row.ItemCode}`;
// //             if (areaItemCombinations.has(key)) {
// //               duplicateRowsList.push(index + 1);
// //             } else {
// //               areaItemCombinations.set(key, index + 1);
// //             }

// //             return {
// //               AreaID: String(row.AreaId),
// //               ItemCode: row.ItemCode,
// //               VANRate: vanRate,
// //               MOCRate: mocRate,
// //               MRPRate: mrpRate,
// //               DML: "I" // Default to Insert
// //             };
// //           });

// //           // Then modify how invalidRows is set up - we need to extract just the row numbers
// //           setInvalidRows(invalidRowsList.map(item => item.rowNumber));
// //           setRateErrorRows(rateErrorRowsList);
// //           setDuplicateRows(duplicateRowsList);

// //           // Now update the error message section
// //           const allErrorsRows = [...new Set([...invalidRowsList.map(item => item.rowNumber), ...rateErrorRowsList, ...duplicateRowsList])];

// //           if (allErrorsRows.length > 0) {
// //             let errorMessage = '';

// //             if (invalidRowsList.length > 0) {
// //               // Group rows by error type for more specific feedback
// //               const errorsByType = {
// //                 missing_identifier: [],
// //                 missing_rate: [],
// //                 negative_rate: [],
// //                 invalid_decimals: [],
// //                 special_chars: [],
// //                 double_decimal: [],
// //                 non_numeric_rate: []
// //               };

// //               invalidRowsList.forEach(item => {
// //                 item.errors.forEach(errorType => {
// //                   errorsByType[errorType].push(item.rowNumber);
// //                 });
// //               });

// //               errorMessage += 'Data validation errors found: ';

// //               if (errorsByType.missing_identifier.length > 0) {
// //                 errorMessage += `Missing AreaId or ItemCode in rows: ${errorsByType.missing_identifier.join(', ')}. `;
// //               }
// //               if (errorsByType.missing_rate.length > 0) {
// //                 errorMessage += `Missing rate values in rows: ${errorsByType.missing_rate.join(', ')}. `;
// //               }
// //               if (errorsByType.negative_rate.length > 0) {
// //                 errorMessage += `Negative rate values in rows: ${errorsByType.negative_rate.join(', ')}. `;
// //               }
// //               if (errorsByType.invalid_decimals.length > 0) {
// //                 errorMessage += `More than 2 decimal places in rows: ${errorsByType.invalid_decimals.join(', ')}. `;
// //               }
// //               if (errorsByType.special_chars.length > 0) {
// //                 errorMessage += `Special characters in AreaId or ItemCode in rows: ${errorsByType.special_chars.join(', ')}. `;
// //               }
// //               if (errorsByType.double_decimal.length > 0) {
// //                 errorMessage += `Double decimal points in rows: ${errorsByType.double_decimal.join(', ')}. `;
// //               }
// //               if (errorsByType.non_numeric_rate.length > 0) {
// //                 errorMessage += `Non-numeric rate values in rows: ${errorsByType.non_numeric_rate.join(', ')}. `;
// //               }
// //             }

// //             if (rateErrorRowsList.length > 0) {
// //               errorMessage += `Rate errors in rows: ${rateErrorRowsList.join(', ')}. VANRate and MOCRate cannot be greater than MRPRate. `;
// //             }

// //             if (duplicateRowsList.length > 0) {
// //               errorMessage += `Duplicate AreaId+ItemCode combinations in rows: ${duplicateRowsList.join(', ')}. `;
// //             }

// //             setNotification({
// //               open: true,
// //               message: errorMessage,
// //               severity: 'error'
// //             });

// //             // Rest of the code stays the same...

// //             // Still set data for display but don't validate for upload
// //             setExcelData(jsonData);
// //             if (allErrorsRows.length === jsonData.length) {
// //               setValidatedData(null); // No valid data to upload
// //             } else {
// //               // Filter out invalid entries for upload
// //               const validatedEntries = validData.filter((_, index) =>
// //                 !allErrorsRows.includes(index + 1)
// //               );
// //               setValidatedData(validatedEntries);
// //             }
// //           } else {
// //             setExcelData(jsonData);
// //             setValidatedData(validData);
// //             setNotification({
// //               open: true,
// //               message: `Successfully imported ${jsonData.length} items. Ready to upload.`,
// //               severity: 'success'
// //             });
// //           }
// //         } else {
// //           setNotification({
// //             open: true,
// //             message: 'No data found in the Excel file',
// //             severity: 'error'
// //           });
// //         }
// //       } catch (error) {
// //         console.error('Error parsing Excel file:', error);
// //         setNotification({
// //           open: true,
// //           message: 'Error parsing the Excel file. Please make sure it is a valid Excel file.',
// //           severity: 'error'
// //         });
// //       }

// //       setIsLoading(false);
// //     };

// //     reader.onerror = () => {
// //       setIsLoading(false);
// //       setNotification({
// //         open: true,
// //         message: 'Error reading file',
// //         severity: 'error'
// //       });
// //     };

// //     reader.readAsArrayBuffer(file);
// //   };

// //   const handleUpload = async () => {
// //     // Check for validation errors before proceeding
// //     if (!validatedData || validatedData.length === 0) {
// //       setNotification({
// //         open: true,
// //         message: 'Please import and validate data before uploading',
// //         severity: 'warning'
// //       });
// //       return;
// //     }

// //     // Check if there are any validation errors
// //     if (invalidRows.length > 0 || duplicateRows.length > 0 || rateErrorRows.length > 0) {
// //       setNotification({
// //         open: true,
// //         message: 'Please fix all validation errors before uploading',
// //         severity: 'error'
// //       });
// //       return;
// //     }

// //     setIsUploading(true);

// //     try {
// //       const uniqueId = ''; // Generate a unique ID based on timestamp
// //       const currentDate = new Date().toISOString(); // Get current date in ISO format
// //       const userId = localStorage.getItem('userId') || 'UnknownUser'; // Get userId from localStorage

// //       const payload = {
// //         UniqueId: uniqueId,
// //         DateOfEntry: currentDate,
// //         CreatedUserCode: userId, // Use dynamic user ID
// //         details: validatedData
// //       };

// //       console.log('Sending payload:', payload);

// //       const response = await fetch('https://retailuat.abisibg.com/api/v1/insertchannelsalesrate', {
// //         method: 'POST',
// //         headers: {
// //           'Authorization': `Bearer ${token}`,
// //           'Content-Type': 'application/json',
// //         },
// //         body: JSON.stringify(payload)
// //       });

// //       if (!response.ok) {
// //         throw new Error(`API response error: ${response.status} ${response.statusText}`);
// //       }

// //       const result = await response.json();

// //       // Check if the API response contains error descriptions (using errdescr instead of rrdescr)
// //       if (result.errdescr && Array.isArray(result.errdescr) && result.errdescr.length > 0) {
// //         // Set state to store the API errors
// //         setApiErrors(result.errdescr);

// //         // Create an error message showing the API errors
// //         const errorCount = result.errdescr.length;
// //         const itemsWithErrors = result.errdescr.map(item => `${item.AreaID}-${item.itemCode}`).join(', ');
// //         const errorMessage = `Upload completed with ${errorCount} errors. Items not found: ${itemsWithErrors}`;

// //         setNotification({
// //           open: true,
// //           message: errorMessage,
// //           severity: 'warning'
// //         });

// //         // Show the API errors in the UI
// //         setShowApiErrorsDialog(true);
// //       }

// //       // Check for success status (this happens regardless of whether there are errors)
// //       if (result.res && Array.isArray(result.res) && result.res.length > 0 && result.res[0].Descr === "Success") {
// //         setNotification({
// //           open: true,
// //           message: `Data uploaded successfully! Some items may have validation errors.`,
// //           severity: 'success'
// //         });

// //         // Only clear the file if there are no errors
// //         if (!result.errdescr || !Array.isArray(result.errdescr) || result.errdescr.length === 0) {
// //           clearFile();
// //         }
// //       }

// //     } catch (error) {
// //       console.error('Error uploading data:', error);
// //       setNotification({
// //         open: true,
// //         message: `Error uploading data: ${error.message}`,
// //         severity: 'error'
// //       });
// //     } finally {
// //       setIsUploading(false);
// //     }
// //   };



// //   const ApiErrorsDialog = () => {
// //     return (
// //       <Dialog
// //         open={showApiErrorsDialog}
// //         onClose={() => setShowApiErrorsDialog(false)}
// //         maxWidth="md"
// //         fullWidth
// //       >
// //         <DialogTitle>
// //           <Box display="flex" alignItems="center">
// //             <ErrorOutlineIcon color="error" sx={{ mr: 1 }} />
// //             API Validation Errors
// //           </Box>
// //         </DialogTitle>
// //         <DialogContent>
// //           <TableContainer>
// //             <Table>
// //               <TableHead>
// //                 <TableRow>
// //                   <TableCell>Area ID</TableCell>
// //                   <TableCell>Item Code</TableCell>
// //                   <TableCell>Error Description</TableCell>
// //                 </TableRow>
// //               </TableHead>
// //               <TableBody>
// //                 {apiErrors.map((error, index) => (
// //                   <TableRow key={index}>
// //                     <TableCell>{error.AreaID}</TableCell>
// //                     <TableCell>{error.itemCode}</TableCell>
// //                     <TableCell>{error.ErrorDescr}</TableCell>
// //                   </TableRow>
// //                 ))}
// //               </TableBody>
// //             </Table>
// //           </TableContainer>
// //         </DialogContent>
// //         <DialogActions>
// //           <Button
// //             onClick={() => setShowApiErrorsDialog(false)}
// //             color="primary"
// //             variant="contained"
// //           >
// //             Close
// //           </Button>
// //         </DialogActions>
// //       </Dialog>
// //     );
// //   };


// //   const clearFile = () => {
// //     setFile(null);
// //     setFileName('');
// //     setExcelData([]);
// //     setValidatedData(null);
// //     setInvalidRows([]);
// //     setDuplicateRows([]);
// //     setRateErrorRows([]);

// //     // Reset the file input value if the ref is available
// //     if (fileInputRef.current) {
// //       fileInputRef.current.value = '';
// //     }
// //   };

// //   const handleCloseNotification = () => {
// //     setNotification({ ...notification, open: false });
// //   };

// //   // Helper function to determine row styling based on validation errors
// //   const getRowStyle = (index) => {
// //     const rowNum = index + 1;
// //     const isInvalidFormat = invalidRows.includes(rowNum);
// //     const isDuplicate = duplicateRows.includes(rowNum);
// //     const hasRateError = rateErrorRows.includes(rowNum);

// //     if (isInvalidFormat || isDuplicate || hasRateError) {
// //       return {
// //         backgroundColor: '#ffebee',
// //         '&:hover': { backgroundColor: '#ffcdd2' }
// //       };
// //     }

// //     return {
// //       '&:nth-of-type(odd)': { backgroundColor: '#fafafa' },
// //       '&:hover': { backgroundColor: '#f5f5f5' }
// //     };
// //   };

// //   // Helper function to get error tooltip message for a row
// //   // Update the getRowErrorMessage function
// //   const getRowErrorMessage = (index) => {
// //     const rowNum = index + 1;
// //     const errors = [];

// //     // Find specific error types for this row
// //     const invalidRow = invalidRowsList.find(item => item.rowNumber === rowNum);
// //     if (invalidRow) {
// //       if (invalidRow.errors.includes('missing_identifier')) errors.push("Missing AreaId or ItemCode");
// //       if (invalidRow.errors.includes('missing_rate')) errors.push("Missing rate value");
// //       if (invalidRow.errors.includes('negative_rate')) errors.push("Negative rate value");
// //       if (invalidRow.errors.includes('invalid_decimals')) errors.push("More than 2 decimal places");
// //       if (invalidRow.errors.includes('special_chars')) errors.push("Special characters in AreaId/ItemCode");
// //       if (invalidRow.errors.includes('double_decimal')) errors.push("Double decimal point");
// //       if (invalidRow.errors.includes('non_numeric_rate')) errors.push("Non-numeric rate value");
// //     }

// //     if (duplicateRows.includes(rowNum)) {
// //       errors.push("Duplicate AreaId+ItemCode combination");
// //     }

// //     if (rateErrorRows.includes(rowNum)) {
// //       errors.push("VANRate or MOCRate greater than MRPRate");
// //     }

// //     return errors.join(", ");
// //   };

// //   return (
// //     <>
// //       <Header />
// //       <ThemeProvider theme={theme}>
// //         <Box sx={{
// //           minHeight: '100vh',
// //           backgroundColor: 'background.default',
// //           pt: 4,
// //           pb: 6
// //         }}>
// //           <Container maxWidth="lg">
// //             <Grow in={true} timeout={800}>
// //               <Paper elevation={3} sx={{ p: 4, borderRadius: 3, overflow: 'hidden' }}>
// //                 <Box sx={{
// //                   display: 'flex',
// //                   alignItems: 'center',
// //                   mb: 3,
// //                   borderBottom: '1px solid #e0e0e0',
// //                   pb: 2
// //                 }}>
// //                   <TableChartIcon sx={{ fontSize: 32, mr: 2, color: 'primary.main' }} />
// //                   <Typography variant="h4" component="h1">
// //                     Rate Upload
// //                   </Typography>
// //                   <Tooltip title="Upload Excel files with AreaId, ItemCode, VANRate, MOCRate, and MRPRate columns">
// //                     <IconButton sx={{ ml: 2 }}>
// //                       <InfoIcon color="action" />
// //                     </IconButton>
// //                   </Tooltip>
// //                 </Box>

// //                 <Box sx={{
// //                   backgroundColor: '#f8faff',
// //                   p: 3,
// //                   borderRadius: 2,
// //                   mb: 4,
// //                   border: '1px solid #e3f2fd'
// //                 }}>
// //                   <Typography variant="subtitle1" sx={{ mb: 2, fontWeight: 500 }}>
// //                     Upload Excel Data
// //                   </Typography>



// //                   <Grid container spacing={2} sx={{ mt: 2 }}>
// //                     <Grid item xs={12}>
// //                       <Typography variant="subtitle2" sx={{ mb: 1 }}>
// //                         Select Required Rate Types:
// //                       </Typography>
// //                     </Grid>
// //                     <Grid item xs={6} md={3}>
// //                       <FormControlLabel
// //                         control={
// //                           <Checkbox
// //                             checked={isMOCRateRequired}
// //                             onChange={() => handleCheckboxChange('MOC')}
// //                             color="primary"
// //                           />
// //                         }
// //                         label="MOCRate"
// //                       />
// //                     </Grid>
// //                     <Grid item xs={6} md={3}>
// //                       <FormControlLabel
// //                         control={
// //                           <Checkbox
// //                             checked={isVANRateRequired}
// //                             onChange={() => handleCheckboxChange('VAN')}
// //                             color="primary"
// //                           />
// //                         }
// //                         label="VANRate"
// //                       />
// //                     </Grid>
// //                     <Grid item xs={6} md={3}>
// //                       <FormControlLabel
// //                         control={
// //                           <Checkbox
// //                             checked={isMRPRateRequired}
// //                             onChange={() => handleCheckboxChange('MRP')}
// //                             color="primary"
// //                           />
// //                         }
// //                         label="MRPRate"
// //                       />
// //                     </Grid>
// //                     <Grid item xs={12}>
// //                       <Alert severity="info" sx={{ mt: 1 }}>
// //                         {!isMOCRateRequired && !isVANRateRequired && !isMRPRateRequired ?
// //                           "Please select at least one rate type to enable upload" :
// //                           `Selected rate types: ${[
// //                             isMOCRateRequired ? "MOCRate" : "",
// //                             isVANRateRequired ? "VANRate" : "",
// //                             isMRPRateRequired ? "MRPRate" : ""
// //                           ].filter(Boolean).join(", ")}`
// //                         }
// //                       </Alert>
// //                     </Grid>
// //                   </Grid>


// //                   <Grid container spacing={3} alignItems="center">
// //                     <Grid item xs={12} md={4}>
// //                       <Box sx={{ display: 'flex', alignItems: 'center' }}>
// //                         <Button
// //                           variant="contained"
// //                           component="label"
// //                           startIcon={<FileOpenIcon />}
// //                           sx={{
// //                             mr: 2,
// //                             background: 'linear-gradient(45deg, #2196F3 30%, #21CBF3 90%)',
// //                             boxShadow: '0 3px 5px 2px rgba(33, 203, 243, .3)',
// //                             color: 'white',
// //                             '&:hover': {
// //                               background: 'linear-gradient(45deg, #1976d2 30%, #21a6f3 90%)',
// //                             }
// //                           }}
// //                         >
// //                           Choose File
// //                           <input
// //                             ref={fileInputRef}
// //                             type="file"
// //                             accept=".xlsx, .xls"
// //                             hidden
// //                             onChange={handleFileChange}
// //                           />
// //                         </Button>

// //                         {fileName && (
// //                           <Fade in={!!fileName}>
// //                             <Box sx={{ display: 'flex', alignItems: 'center' }}>
// //                               <Chip
// //                                 label={fileName}
// //                                 variant="outlined"
// //                                 color="primary"
// //                                 onDelete={clearFile}
// //                                 deleteIcon={<DeleteIcon />}
// //                                 sx={{ maxWidth: '250px' }}
// //                               />
// //                             </Box>
// //                           </Fade>
// //                         )}
// //                       </Box>
// //                     </Grid>

// //                     <Grid item xs={12} md={4}>
// //                       <Button
// //                         variant="contained"
// //                         color="primary"
// //                         onClick={handleImport}
// //                         disabled={!file || isLoading}
// //                         fullWidth
// //                         sx={{
// //                           py: 1.5,
// //                           background: file && !isLoading ? 'linear-gradient(45deg, #4CAF50 30%, #8BC34A 90%)' : '',
// //                           boxShadow: file && !isLoading ? '0 3px 5px 2px rgba(76, 175, 80, .3)' : '',
// //                           '&:hover': {
// //                             background: file && !isLoading ? 'linear-gradient(45deg, #43A047 30%, #7CB342 90%)' : ''
// //                           }
// //                         }}
// //                       >
// //                         {isLoading ? (
// //                           <Box sx={{ display: 'flex', alignItems: 'center' }}>
// //                             <CircularProgress size={24} color="inherit" sx={{ mr: 1 }} />
// //                             Processing...
// //                           </Box>
// //                         ) : (
// //                           <>
// //                             <CloudUploadIcon sx={{ mr: 1 }} /> Validate Data
// //                           </>
// //                         )}
// //                       </Button>
// //                     </Grid>

// //                     <Grid item xs={12} md={4}>
// //                       <Button
// //                         variant="contained"
// //                         color="secondary"
// //                         onClick={handleUpload}
// //                         disabled={
// //                           !validatedData ||
// //                           isUploading ||
// //                           (!isMOCRateRequired && !isVANRateRequired && !isMRPRateRequired) ||
// //                           invalidRows.length > 0 ||
// //                           duplicateRows.length > 0 ||
// //                           rateErrorRows.length > 0
// //                         }
// //                         fullWidth
// //                         sx={{
// //                           py: 1.5,
// //                           background: validatedData && !isUploading && invalidRows.length === 0 && duplicateRows.length === 0 && rateErrorRows.length === 0 ?
// //                             'linear-gradient(45deg, #FF5722 30%, #FF9800 90%)' : '',
// //                           boxShadow: validatedData && !isUploading && invalidRows.length === 0 && duplicateRows.length === 0 && rateErrorRows.length === 0 ?
// //                             '0 3px 5px 2px rgba(255, 87, 34, .3)' : '',
// //                           '&:hover': {
// //                             background: validatedData && !isUploading && invalidRows.length === 0 && duplicateRows.length === 0 && rateErrorRows.length === 0 ?
// //                               'linear-gradient(45deg, #E64A19 30%, #F57C00 90%)' : ''
// //                           }
// //                         }}
// //                       >
// //                         {isUploading ? (
// //                           <Box sx={{ display: 'flex', alignItems: 'center' }}>
// //                             <CircularProgress size={24} color="inherit" sx={{ mr: 1 }} />
// //                             Uploading...
// //                           </Box>
// //                         ) : (
// //                           <>
// //                             <SendIcon sx={{ mr: 1 }} /> Submit
// //                           </>
// //                         )}
// //                       </Button>
// //                     </Grid>
// //                   </Grid>
// //                 </Box>

// //                 {(invalidRows.length > 0 || duplicateRows.length > 0 || rateErrorRows.length > 0) && (
// //                   <Alert
// //                     severity="warning"
// //                     sx={{ mb: 3 }}
// //                     action={
// //                       <Tooltip title="Rows with errors are highlighted in red">
// //                         <IconButton size="small">
// //                           <InfoIcon />
// //                         </IconButton>
// //                       </Tooltip>
// //                     }
// //                   >
// //                     <Typography variant="subtitle2">Validation Errors Found:</Typography>
// //                     <Box component="ul" sx={{ mt: 1, pl: 2 }}>
// //                       {invalidRowsList && invalidRowsList.length > 0 ? (
// //                         <li>
// //                           Data validation errors:
// //                           <Box component="ul" sx={{ pl: 2 }}>
// //                             {invalidRowsList.map((item, idx) => (
// //                               <li key={idx}>
// //                                 Row {item.rowNumber}: {item.errors && Array.isArray(item.errors) ? item.errors.map(err => {
// //                                   switch (err) {
// //                                     case 'missing_identifier': return 'Missing AreaId or ItemCode';
// //                                     case 'missing_rate': return 'Missing rate value';
// //                                     case 'negative_rate': return 'Negative rate value';
// //                                     case 'invalid_decimals': return 'More than 2 decimal places';
// //                                     case 'special_chars': return 'Special characters in AreaId/ItemCode';
// //                                     case 'double_decimal': return 'Double decimal point';
// //                                     case 'non_numeric_rate': return 'Non-numeric rate value';
// //                                     default: return err;
// //                                   }
// //                                 }).join(', ') : 'Unknown error'}
// //                               </li>
// //                             ))}
// //                           </Box>
// //                         </li>
// //                       ) : (
// //                         invalidRows.length > 0 && <li>Invalid data format in rows: {invalidRows.join(', ')}</li>
// //                       )}
// //                       {rateErrorRows.length > 0 && (
// //                         <li>
// //                           Rate errors (VANRate or MOCRate greater than MRPRate) in rows: {rateErrorRows.join(', ')}
// //                         </li>
// //                       )}
// //                       {duplicateRows.length > 0 && (
// //                         <li>
// //                           Duplicate AreaId+ItemCode combinations in rows: {duplicateRows.join(', ')}
// //                         </li>
// //                       )}
// //                     </Box>
// //                   </Alert>
// //                 )}

// //                 <Divider sx={{ my: 3 }} />

// //                 <Box sx={{ mt: 2 }}>
// //                   <Typography variant="h6" sx={{ mb: 2, display: 'flex', alignItems: 'center' }}>
// //                     <TableChartIcon sx={{ mr: 1, fontSize: 20 }} /> Data Preview
// //                   </Typography>

// //                   {excelData.length > 0 ? (
// //                     <Fade in={excelData.length > 0} timeout={800}>
// //                       <TableContainer component={Paper} sx={{
// //                         mt: 2,
// //                         boxShadow: '0 2px 10px rgba(0,0,0,0.08)',
// //                         borderRadius: 2,
// //                         maxHeight: 400,
// //                         overflow: 'auto'
// //                       }}>
// //                         <Table aria-label="excel data table" stickyHeader>
// //                           <TableHead>
// //                             <TableRow>
// //                               <TableCell sx={{ fontWeight: 'bold' }}>Row</TableCell>
// //                               <TableCell sx={{ fontWeight: 'bold' }}>Area ID</TableCell>
// //                               <TableCell sx={{ fontWeight: 'bold' }}>Item Code</TableCell>
// //                               {isVANRateRequired && (
// //                                 <TableCell align="right" sx={{ fontWeight: 'bold' }}>VAN Rate</TableCell>
// //                               )}
// //                               {isMOCRateRequired && (
// //                                 <TableCell align="right" sx={{ fontWeight: 'bold' }}>MOC Rate</TableCell>
// //                               )}
// //                               {isMRPRateRequired && (
// //                                 <TableCell align="right" sx={{ fontWeight: 'bold' }}>MRP Rate</TableCell>
// //                               )}
// //                               <TableCell align="center" sx={{ fontWeight: 'bold' }}>Status</TableCell>
// //                             </TableRow>
// //                           </TableHead>

// //                           <TableBody>
// //                             {excelData.map((row, index) => {
// //                               const rowNum = index + 1;
// //                               const hasError = invalidRows.includes(rowNum) ||
// //                                 duplicateRows.includes(rowNum) ||
// //                                 rateErrorRows.includes(rowNum);
// //                               const errorMsg = getRowErrorMessage(index);

// //                               return (
// //                                 <TableRow
// //                                   key={index}
// //                                   sx={getRowStyle(index)}
// //                                 >
// //                                   <TableCell>{rowNum}</TableCell>
// //                                   <TableCell>{row.AreaId}</TableCell>
// //                                   <TableCell>{row.ItemCode}</TableCell>
// //                                   {isVANRateRequired && (
// //                                     <TableCell
// //                                       align="right"
// //                                       sx={rateErrorRows.includes(rowNum) && row.VANRate > row.MRPRate ? { color: 'error.main' } : {}}
// //                                     >
// //                                       {typeof row.VANRate === 'number'
// //                                         ? `${row.VANRate.toFixed(2)}`
// //                                         : row.VANRate}
// //                                     </TableCell>
// //                                   )}
// //                                   {isMOCRateRequired && (
// //                                     <TableCell
// //                                       align="right"
// //                                       sx={rateErrorRows.includes(rowNum) && row.MOCRate > row.MRPRate ? { color: 'error.main' } : {}}
// //                                     >
// //                                       {typeof row.MOCRate === 'number'
// //                                         ? `${row.MOCRate.toFixed(2)}`
// //                                         : row.MOCRate}
// //                                     </TableCell>
// //                                   )}
// //                                   {isMRPRateRequired && (
// //                                     <TableCell align="right">
// //                                       {typeof row.MRPRate === 'number'
// //                                         ? `${row.MRPRate.toFixed(2)}`
// //                                         : row.MRPRate}
// //                                     </TableCell>
// //                                   )}
// //                                   <TableCell align="center">
// //                                     {hasError ? (
// //                                       <Tooltip title={errorMsg}>
// //                                         <ErrorOutlineIcon color="error" />
// //                                       </Tooltip>
// //                                     ) : (
// //                                       <Chip
// //                                         label="Valid"
// //                                         size="small"
// //                                         color="success"
// //                                         variant="outlined"
// //                                         sx={{ fontSize: '0.7rem' }}
// //                                       />
// //                                     )}
// //                                   </TableCell>
// //                                 </TableRow>
// //                               );
// //                             })}
// //                           </TableBody>
// //                         </Table>
// //                       </TableContainer>
// //                     </Fade>
// //                   ) : (
// //                     <Fade in={!excelData.length} timeout={800}>
// //                       <Box
// //                         sx={{
// //                           p: 5,
// //                           textAlign: 'center',
// //                           bgcolor: '#fafafa',
// //                           borderRadius: 2,
// //                           border: '2px dashed #e0e0e0',
// //                           display: 'flex',
// //                           flexDirection: 'column',
// //                           alignItems: 'center',
// //                           justifyContent: 'center'
// //                         }}
// //                       >
// //                         <CloudUploadIcon sx={{ fontSize: 64, color: '#bdbdbd', mb: 2 }} />
// //                         <Typography variant="h6" color="text.secondary" sx={{ mb: 1 }}>
// //                           No Data Available
// //                         </Typography>
// //                         <Typography variant="body2" color="text.secondary">
// //                           Upload an Excel file to view your data here
// //                         </Typography>
// //                       </Box>
// //                     </Fade>
// //                   )}
// //                 </Box>

// //                 {validatedData && validatedData.length > 0 && (
// //                   <Box sx={{ mt: 3, p: 2, bgcolor: '#e8f5e9', borderRadius: 2, border: '1px solid #c8e6c9' }}>
// //                     <Typography variant="subtitle1" sx={{ color: '#2e7d32', fontWeight: 500, display: 'flex', alignItems: 'center' }}>
// //                       <InfoIcon sx={{ mr: 1, fontSize: 20 }} />
// //                       Data validated successfully. {validatedData.length} valid records ready to upload.
// //                       {invalidRows.length > 0 || duplicateRows.length > 0 || rateErrorRows.length > 0 ?
// //                         ` (${invalidRows.length + duplicateRows.length + rateErrorRows.length} invalid records will be skipped)` :
// //                         ''}
// //                     </Typography>
// //                   </Box>
// //                 )}

// //                 {apiErrors.length > 0 && (
// //                   <Box sx={{ mt: 3, p: 2, bgcolor: '#fff3e0', borderRadius: 2, border: '1px solid #ffe0b2' }}>
// //                     <Typography variant="subtitle1" sx={{ color: '#e65100', fontWeight: 500, display: 'flex', alignItems: 'center' }}>
// //                       <ErrorOutlineIcon sx={{ mr: 1, fontSize: 20 }} />
// //                       {apiErrors.length} items failed validation during upload.
// //                       <Button
// //                         color="warning"
// //                         variant="outlined"
// //                         size="small"
// //                         onClick={() => setShowApiErrorsDialog(true)}
// //                         sx={{ ml: 2 }}
// //                       >
// //                         View Errors
// //                       </Button>
// //                     </Typography>
// //                   </Box>
// //                 )}
// //               </Paper>
// //             </Grow>

// //             <Snackbar
// //               open={notification.open}
// //               autoHideDuration={6000}
// //               onClose={handleCloseNotification}
// //               anchorOrigin={{ vertical: 'bottom', horizontal: 'right' }}
// //             >
// //               <Alert
// //                 onClose={handleCloseNotification}
// //                 severity={notification.severity}
// //                 variant="filled"
// //                 sx={{ width: '100%' }}
// //               >
// //                 {notification.message}
// //               </Alert>
// //             </Snackbar>
// //           </Container>
// //         </Box>
// //         <ApiErrorsDialog />
// //       </ThemeProvider>
// //     </>
// //   );
// // };

// // export default RateUploadScreen;









































// import React, { useState, useRef } from 'react';
// import {
//   Button,
//   Box,
//   Typography,
//   Paper,
//   Table,
//   TableBody,
//   TableCell,
//   TableContainer,
//   TableHead,
//   TableRow,
//   Container,
//   Grid,
//   CircularProgress,
//   Chip,
//   Divider,
//   Fade,
//   Grow,
//   Tooltip,
//   IconButton,
//   Alert,
//   Snackbar
// } from '@mui/material';
// import {
//   Dialog,
//   DialogActions,
//   DialogContent,
//   DialogTitle
// } from '@mui/material';
// import CloudUploadIcon from '@mui/icons-material/CloudUpload';
// import DeleteIcon from '@mui/icons-material/Delete';
// import FileOpenIcon from '@mui/icons-material/FileOpen';
// import InfoIcon from '@mui/icons-material/Info';
// import TableChartIcon from '@mui/icons-material/TableChart';
// import SendIcon from '@mui/icons-material/Send';
// import ErrorOutlineIcon from '@mui/icons-material/ErrorOutline';
// import * as XLSX from 'xlsx';
// import { createTheme, ThemeProvider } from '@mui/material/styles';
// import { FormControlLabel, Checkbox } from '@mui/material';
// import Header from '../Header';
// import { local_signage } from '../Const';


// const theme = createTheme({
//   palette: {
//     primary: {
//       main: '#1976d2',
//     },
//     secondary: {
//       main: '#f50057',
//     },
//     background: {
//       default: '#f5f7fa',
//     },
//   },
//   typography: {
//     h4: {
//       fontWeight: 600,
//     },
//     button: {
//       fontWeight: 500,
//     },
//   },
//   components: {
//     MuiPaper: {
//       styleOverrides: {
//         root: {
//           borderRadius: 12,
//           boxShadow: '0 4px 20px 0 rgba(0,0,0,0.1)',
//         },
//       },
//     },
//     MuiButton: {
//       styleOverrides: {
//         root: {
//           borderRadius: 8,
//           textTransform: 'none',
//           padding: '10px 24px',
//         },
//       },
//     },
//     MuiTableCell: {
//       styleOverrides: {
//         head: {
//           backgroundColor: '#f0f5ff',
//           fontWeight: 'bold',
//         },
//       },
//     },
//   },
// });

// export const RateUpload = () => {
//   const [file, setFile] = useState(null);
//   const [fileName, setFileName] = useState('');
//   const [isLoading, setIsLoading] = useState(false);
//   const [isUploading, setIsUploading] = useState(false);
//   const [excelData, setExcelData] = useState([]);
//   const [notification, setNotification] = useState({ open: false, message: '', severity: 'info' });
//   const [validatedData, setValidatedData] = useState(null);
//   const [invalidRows, setInvalidRows] = useState([]);
//   const [duplicateRows, setDuplicateRows] = useState([]);
//   const [rateErrorRows, setRateErrorRows] = useState([]);
//   const token = localStorage.getItem('AuthorizationToken');
//   const [isMOCRateRequired, setIsMOCRateRequired] = useState(false);
//   const [isVANRateRequired, setIsVANRateRequired] = useState(false);
//   const [isHORECARateRequired, setIsHORECARateRequired] = useState(false);

//   const fileInputRef = useRef(null);
//   const [invalidRowsList, setInvalidRowsList] = useState([]); // Add this new state
//   const [isMRPRateRequired, setIsMRPRateRequired] = useState(true); // Default to true unlike the others
//   const [apiErrors, setApiErrors] = useState([]);
//   const [showApiErrorsDialog, setShowApiErrorsDialog] = useState(false);
//   const [showConfirmDialog, setShowConfirmDialog] = useState(false);
//   const [excelColumns, setExcelColumns] = useState([]);
//   const [pendingExcelData, setPendingExcelData] = useState(null);
//   const [pendingWorkbook, setPendingWorkbook] = useState(null);
  





//   const handleFileChange = (event) => {
//     const selectedFile = event.target.files[0];
//     if (selectedFile) {
//       setFile(selectedFile);
//       setFileName(selectedFile.name);
//       setValidatedData(null);
//       setInvalidRows([]);
//       setDuplicateRows([]);
//       setRateErrorRows([]);
//       setNotification({
//         open: true,
//         message: `File "${selectedFile.name}" selected successfully`,
//         severity: 'success'
//       });
//     }
//   };




//   const handleCheckboxChange = (type) => {
//     if (type === 'MOC') {
//       setIsMOCRateRequired(!isMOCRateRequired);
//     } else if (type === 'VAN') {
//       setIsVANRateRequired(!isVANRateRequired);
//     } else if (type === 'MRP') {
//       setIsMRPRateRequired(!isMRPRateRequired);
//     }
//     else if (type === 'HORECA') {
//       setIsHORECARateRequired(!isHORECARateRequired);
//     }
//     // Clear existing validation when checkbox state changes
//     setValidatedData(null);
//     setInvalidRows([]);
//     setDuplicateRows([]);
//     setRateErrorRows([]);
//   };



//   const handleImport = () => {
//     if (!file) {
//       setNotification({
//         open: true,
//         message: 'Please select a file first',
//         severity: 'warning'
//       });
//       return;
//     }
  
//     setIsLoading(true);
//     setInvalidRows([]);
//     setDuplicateRows([]);
//     setRateErrorRows([]);
//     console.log('Import button pressed. File:', file.name);
  
//     // Read the Excel file
//     const reader = new FileReader();
//     reader.onload = (e) => {
//       try {
//         const data = new Uint8Array(e.target.result);
//         const workbook = XLSX.read(data, { type: 'array' });
//         const firstSheetName = workbook.SheetNames[0];
//         const worksheet = workbook.Sheets[firstSheetName];
  
//         // Convert Excel data to JSON
//         const jsonData = XLSX.utils.sheet_to_json(worksheet);
  
//         // Check if data exists
//         if (jsonData.length === 0) {
//           setNotification({
//             open: true,
//             message: 'No data found in the Excel file',
//             severity: 'error'
//           });
//           setIsLoading(false);
//           return;
//         }
  
//         // Extract headers from the first row
//         const headers = Object.keys(jsonData[0]);
//         setExcelColumns(headers);
  
//         // Check for required columns
//         const requiredColumns = ['AreaId', 'ItemCode'];
//         const missingBasicColumns = requiredColumns.filter(col =>
//           !headers.some(header => header.toLowerCase() === col.toLowerCase())
//         );
  
//         if (missingBasicColumns.length > 0) {
//           setNotification({
//             open: true,
//             message: `Missing required columns: ${missingBasicColumns.join(', ')}`,
//             severity: 'error'
//           });
//           setIsLoading(false);
//           return;
//         }
  
//         // Check for rate selection
//         if (!isMOCRateRequired && !isVANRateRequired && !isMRPRateRequired && !isHORECARateRequired) {
//           setNotification({
//             open: true,
//             message: 'Please select at least one rate type',
//             severity: 'error'
//           });
//           setIsLoading(false);
//           return;
//         }
  
//         // Check for mismatch between selected rate types and Excel columns
//         const hasVANRateColumn = headers.some(h => h.toLowerCase() === 'vanrate');
//         const hasMOCRateColumn = headers.some(h => h.toLowerCase() === 'mocrate');
//         const hasMRPRateColumn = headers.some(h => h.toLowerCase() === 'mrprate');
//         const hasHORECARateColumn = headers.some(h => h.toLowerCase() === 'horecarate');
//         // Add this alongside other Excel column checking variables
// const hasQualifyQtyColumn = headers.some(h => h.toLowerCase() === 'qualifyqty');

//         // Store the Excel data and workbook for further processing
//         setPendingExcelData(jsonData);
//         setPendingWorkbook(workbook);
  
//         // Check for column mismatches
//         if ((hasVANRateColumn && !isVANRateRequired) || 
//             (hasMOCRateColumn && !isMOCRateRequired) || 
//             (hasHORECARateColumn && !isHORECARateRequired) || 
//             (hasMRPRateColumn && !isMRPRateRequired)) {
          
//           // Show confirmation dialog instead of error
//           setShowConfirmDialog(true);
//           setIsLoading(false);
//           return;
//         }
  
//         // Check if required rate columns are present
//         const missingRateColumns = [];
//         if (isMOCRateRequired && !hasMOCRateColumn) missingRateColumns.push('MOCRate');
//         if (isVANRateRequired && !hasVANRateColumn) missingRateColumns.push('VANRate');
//         if (isMRPRateRequired && !hasMRPRateColumn) missingRateColumns.push('MRPRate');
//         if (isHORECARateRequired && !hasHORECARateColumn) missingRateColumns.push('HORECARate');
// // Add this to the "missing rate columns" validation section
// if (isHORECARateRequired && !hasQualifyQtyColumn) missingRateColumns.push('QualifyQty');

//         if (missingRateColumns.length > 0) {
//           setNotification({
//             open: true,
//             message: `Missing required rate columns: ${missingRateColumns.join(', ')}`,
//             severity: 'error'
//           });
//           setIsLoading(false);
//           return;
//         }
  
//         // If we reach here, proceed with validation
//         processExcelData(jsonData);
  
//       } catch (error) {
//         console.error('Error parsing Excel file:', error);
//         setNotification({
//           open: true,
//           message: 'Error parsing the Excel file. Please make sure it is a valid Excel file.',
//           severity: 'error'
//         });
//         setIsLoading(false);
//       }
//     };
  
//     reader.onerror = () => {
//       setIsLoading(false);
//       setNotification({
//         open: true,
//         message: 'Error reading file',
//         severity: 'error'
//       });
//     };
  
//     reader.readAsArrayBuffer(file);
//   };



//   const processExcelData = (jsonData) => {
//     setIsLoading(true);
    
//     // Track invalid rows and duplicate AreaId+ItemCode combinations
//     const invalidRowsList = [];
//     const rateErrorRowsList = [];
//     const areaItemCombinations = new Map();
//     const duplicateRowsList = [];
  
//     // Validate data types and business rules
//     const validData = jsonData.map((row, index) => {
//       // Define specific error types for more detailed reporting
//       const errors = [];
  
//       // Check for empty values
//       if (!row.AreaId || !row.ItemCode) {
//         errors.push('missing_identifier');
//       }
  
//       if ((isMOCRateRequired && (row.MOCRate === undefined || row.MOCRate === null || row.MOCRate === '')) ||
//       (isHORECARateRequired && (row.HORECARate === undefined || row.HORECARate === null || row.HORECARate === '')) ||

//         (isVANRateRequired && (row.VANRate === undefined || row.VANRate === null || row.VANRate === '')) ||
//         (isMRPRateRequired && (row.MRPRate === undefined || row.MRPRate === null || row.MRPRate === ''))) {
//         errors.push('missing_rate');
//       }
//       if (isHORECARateRequired && (row.QualifyQty === undefined || row.QualifyQty === null || row.QualifyQty === '')) {
//         errors.push('missing_qualify_qty');
//       }
  
//       // Check for negative values
//       const vanRate = isVANRateRequired ? Number(row.VANRate) : 0;
//       const mocRate = isMOCRateRequired ? Number(row.MOCRate) : 0;
//       const horecaRate = isHORECARateRequired ? Number(row.HORECARate) : 0;

//       const mrpRate = isMRPRateRequired ? Number(row.MRPRate) : 0;
  
//       if ((isVANRateRequired && vanRate < 0) ||
//         (isMOCRateRequired && mocRate < 0) ||
//         (isHORECARateRequired && horecaRate < 0) ||
//         (isMRPRateRequired && mrpRate < 0)) {
//         errors.push('negative_rate');
//       }
  
//       // Check for more than two decimal places
//       if ((isVANRateRequired && String(row.VANRate).includes('.') && String(row.VANRate).split('.')[1].length > 2) ||
//         (isMOCRateRequired && String(row.MOCRate).includes('.') && String(row.MOCRate).split('.')[1].length > 2) ||
//         (isHORECARateRequired && String(row.HORECARate).includes('.') && String(row.HORECARate).split('.')[1].length > 2) ||

//         (isMRPRateRequired && String(row.MRPRate).includes('.') && String(row.MRPRate).split('.')[1].length > 2)) {
//         errors.push('invalid_decimals');
//       }
  
//       // Check for double decimal points
//       if ((isVANRateRequired && String(row.VANRate).split('.').length > 2) ||
//         (isMOCRateRequired && String(row.MOCRate).split('.').length > 2) ||
//         (isHORECARateRequired && String(row.HORECARate).split('.').length > 2) ||
//         (isMRPRateRequired && String(row.MRPRate).split('.').length > 2)) {
//         errors.push('double_decimal');
//       }
  
//       // Check for non-numeric rates
//       if ((isVANRateRequired && isNaN(vanRate)) ||
//         (isMOCRateRequired && isNaN(mocRate)) ||
//         (isHORECARateRequired && isNaN(horecaRate)) ||

//         (isMRPRateRequired && isNaN(mrpRate))) {
//         errors.push('non_numeric_rate');
//       }
  
//       if (isHORECARateRequired && isNaN(Number(row.QualifyQty))) {
//         errors.push('non_numeric_qualify_qty');
//       }

//       // Store error information for this row
//       if (errors.length > 0) {
//         invalidRowsList.push({
//           rowNumber: index + 1,
//           errors: errors
//         });
//       }
  
//       // Check for rate errors (VANRate or MOCRate > MRPRate)
//       const hasRateError = (isVANRateRequired && vanRate > mrpRate) || (isMOCRateRequired && mocRate > mrpRate) || (isHORECARateRequired && horecaRate > mrpRate);
//       if (hasRateError) {
//         rateErrorRowsList.push(index + 1);
//       }
  
//       // Check for duplicate AreaId + ItemCode combinations
//       const key = `${row.AreaId}-${row.ItemCode}`;
//       if (areaItemCombinations.has(key)) {
//         duplicateRowsList.push(index + 1);
//       } else {
//         areaItemCombinations.set(key, index + 1);
//       }
  
//       return {
      //   AreaID: String(row.AreaId),
      //   ItemCode: String(row.ItemCode),
      //   VANRate: isVANRateRequired ? vanRate : 0,
      //   MOCRate: isMOCRateRequired ? mocRate : 0,
      //   HRCRate: isHORECARateRequired ? horecaRate : 0,
      //   MRPRate: isMRPRateRequired ? mrpRate : 0,
      //   HRCQualifyQty: isHORECARateRequired ? Number(row.QualifyQty) : 0,
      //   DML: "I" // Default to Insert
      // };
//     });
  
//     // Set the validated rows and errors
//     setInvalidRowsList(invalidRowsList);
//     setInvalidRows(invalidRowsList.map(item => item.rowNumber));
//     setRateErrorRows(rateErrorRowsList);
//     setDuplicateRows(duplicateRowsList);
  
//     // Calculate all error rows
//     const allErrorsRows = [...new Set([...invalidRowsList.map(item => item.rowNumber), ...rateErrorRowsList, ...duplicateRowsList])];
  
//     if (allErrorsRows.length > 0) {
//       let errorMessage = '';
  
//       if (invalidRowsList.length > 0) {
//         // Group rows by error type for more specific feedback
//         const errorsByType = {
//           missing_identifier: [],
//           missing_rate: [],
//           negative_rate: [],
//           invalid_decimals: [],
//           special_chars: [],
//           double_decimal: [],
//           non_numeric_rate: [],
//           missing_qualify_qty: [],
//           non_numeric_qualify_qty: [],
//         };
  
//         invalidRowsList.forEach(item => {
//           item.errors.forEach(errorType => {
//             errorsByType[errorType].push(item.rowNumber);
//           });
//         });
  
//         errorMessage += 'Data validation errors found: ';
  
//         if (errorsByType.missing_identifier.length > 0) {
//           errorMessage += `Missing AreaId or ItemCode in rows: ${errorsByType.missing_identifier.join(', ')}. `;
//         }
//         if (errorsByType.missing_rate.length > 0) {
//           errorMessage += `Missing rate values in rows: ${errorsByType.missing_rate.join(', ')}. `;
//         }
//         if (errorsByType.negative_rate.length > 0) {
//           errorMessage += `Negative rate values in rows: ${errorsByType.negative_rate.join(', ')}. `;
//         }
//         if (errorsByType.invalid_decimals.length > 0) {
//           errorMessage += `More than 2 decimal places in rows: ${errorsByType.invalid_decimals.join(', ')}. `;
//         }
//         if (errorsByType.special_chars.length > 0) {
//           errorMessage += `Special characters in AreaId or ItemCode in rows: ${errorsByType.special_chars.join(', ')}. `;
//         }
//         if (errorsByType.double_decimal.length > 0) {
//           errorMessage += `Double decimal points in rows: ${errorsByType.double_decimal.join(', ')}. `;
//         }
//         if (errorsByType.non_numeric_rate.length > 0) {
//           errorMessage += `Non-numeric rate values in rows: ${errorsByType.non_numeric_rate.join(', ')}. `;
//         }
//         if (errorsByType.missing_qualify_qty.length > 0) {
//           errorMessage += `Missing QualifyQty in rows: ${errorsByType.missing_qualify_qty.join(', ')}. `;
//         }
//         if (errorsByType.non_numeric_qualify_qty.length > 0) {
//           errorMessage += `Non-numeric QualifyQty in rows: ${errorsByType.non_numeric_qualify_qty.join(', ')}. `;
//         }
//       }
  
//       if (rateErrorRowsList.length > 0) {
//         errorMessage += `Rate errors in rows: ${rateErrorRowsList.join(', ')}. VANRate, MOCRate and HORECArate cannot be greater than MRPRate. `;
//       }
  
//       if (duplicateRowsList.length > 0) {
//         errorMessage += `Duplicate AreaId+ItemCode combinations in rows: ${duplicateRowsList.join(', ')}. `;
//       }
  
//       setNotification({
//         open: true,
//         message: errorMessage,
//         severity: 'error'
//       });
  
//       // Still set data for display but don't validate for upload
//       setExcelData(jsonData);
//       if (allErrorsRows.length === jsonData.length) {
//         setValidatedData(null); // No valid data to upload
//       } else {
//         // Filter out invalid entries for upload
//         const validatedEntries = validData.filter((_, index) =>
//           !allErrorsRows.includes(index + 1)
//         );
//         setValidatedData(validatedEntries);
//       }
//     } else {
//       setExcelData(jsonData);
//       setValidatedData(validData);
//       setNotification({
//         open: true,
//         message: `Successfully imported ${jsonData.length} items. Ready to upload.`,
//         severity: 'success'
//       });
//     }
    
//     setIsLoading(false);
//   };

  

  

//   const handleUpload = async () => {
//     // Check for validation errors before proceeding
//     if (!validatedData || validatedData.length === 0) {
//       setNotification({
//         open: true,
//         message: 'Please import and validate data before uploading',
//         severity: 'warning'
//       });
//       return;
//     }
  
//     // Check if there are any validation errors
//     if (invalidRows.length > 0 || duplicateRows.length > 0 || rateErrorRows.length > 0) {
//       setNotification({
//         open: true,
//         message: 'Please fix all validation errors before uploading',
//         severity: 'error'
//       });
//       return;
//     }
  
//     setIsUploading(true);
  
//     try {
//       const uniqueId = ''; // Generate a unique ID based on timestamp
//       const currentDate = new Date().toISOString(); // Get current date in ISO format
//       const userId = localStorage.getItem('userId') || 'UnknownUser'; // Get userId from localStorage
  
//       const payload = {
//         UniqueId: uniqueId,
//         DateOfEntry: currentDate,
//         CreatedUserCode: userId, // Use dynamic user ID
//         VANRateExists: isVANRateRequired ? 1 : 0,
//         MOCRateExists: isMOCRateRequired ? 1 : 0,
//         HRCRateExists: isHORECARateRequired ? 1 : 0,
//         MRPRateExists: isMRPRateRequired ? 1 : 0,
//         // QualifyQtyExists: isHORECARateRequired ? 1 : 0,
//         details: validatedData
//       };
  
//       console.log('Sending payload:', payload);
  
//       const response = await fetch(`${local_signage}/api/v1/insertchannelsalesrate`, {
//         method: 'POST',
//         headers: {
//           'Authorization': `Bearer ${token}`,
//           'Content-Type': 'application/json',
//         },
//         body: JSON.stringify(payload)
//       });
      
//       if (!response.ok) {
//         throw new Error(`API response error: ${response.status} ${response.statusText}`);
//       }

//       const result = await response.json();

//       // Check if the API response contains error descriptions (using errdescr instead of rrdescr)
//       if (result.errdescr && Array.isArray(result.errdescr) && result.errdescr.length > 0) {
//         // Set state to store the API errors
//         setApiErrors(result.errdescr);

//         // Create an error message showing the API errors
//         const errorCount = result.errdescr.length;
//         const itemsWithErrors = result.errdescr.map(item => `${item.AreaID}-${item.itemCode}`).join(', ');
//         const errorMessage = `Upload completed with ${errorCount} errors. Items not found: ${itemsWithErrors}`;

//         setNotification({
//           open: true,
//           message: errorMessage,
//           severity: 'warning'
//         });

//         // Show the API errors in the UI
//         setShowApiErrorsDialog(true);
//       }

//       // Check for success status (this happens regardless of whether there are errors)
//       if (result.res && Array.isArray(result.res) && result.res.length > 0) {
//         const uniqueId = result.res[0].UniqueId;
        
//         setNotification({
//           open: true,
//           message: `Data uploaded successfully! Reference ID: ${uniqueId}`,
//           severity: 'success'
//         });
      
//         // Only clear the file if there are no errors
//         if (!result.errdescr || !Array.isArray(result.errdescr) || result.errdescr.length === 0) {
//           clearFile();
//         }
//       }

//     } catch (error) {
//       console.error('Error uploading data:', error);
//       setNotification({
//         open: true,
//         message: `Error uploading data: ${error.message}`,
//         severity: 'error'
//       });
//     } finally {
//       setIsUploading(false);
//     }
//   };


  
//   const handleConfirmSkipColumns = (confirm) => {
//     setShowConfirmDialog(false);
    
//     if (confirm) {
//       // User confirmed to skip columns, proceed with validation
//       processExcelData(pendingExcelData);
//     } else {
//       // User canceled, reset
//       setPendingExcelData(null);
//       setPendingWorkbook(null);
//       setNotification({
//         open: true,
//         message: 'Please adjust your rate type selection to match the Excel columns',
//         severity: 'info'
//       });
//     }
//   };
  
//   // Add a new confirmation dialog component
//   const ColumnMismatchDialog = () => {
//     if (!excelColumns || excelColumns.length === 0) return null;
    
//     // Determine which columns are in the Excel but not selected
//     const extraColumns = [];
//     if (excelColumns.some(h => h.toLowerCase() === 'vanrate') && !isVANRateRequired) {
//       extraColumns.push('VANRate');
//     }
//     if (excelColumns.some(h => h.toLowerCase() === 'mocrate') && !isMOCRateRequired) {
//       extraColumns.push('MOCRate');
//     }
//     if (excelColumns.some(h => h.toLowerCase() === 'horecarate') && !isHORECARateRequired) {
//       extraColumns.push('HORECARate');
//     }
//     if (excelColumns.some(h => h.toLowerCase() === 'mrprate') && !isMRPRateRequired) {
//       extraColumns.push('MRPRate');
//     }
    
//     // Determine what is selected currently
//     const selectedRates = [
//       isMOCRateRequired ? "MOCRate" : "",
//       isVANRateRequired ? "VANRate" : "",
//       isHORECARateRequired ? "HORECARate" : "",
//       isMRPRateRequired ? "MRPRate" : ""
//     ].filter(Boolean).join(", ");
    
//     return (
//       <Dialog
//         open={showConfirmDialog}
//         onClose={() => handleConfirmSkipColumns(false)}
//         maxWidth="sm"
//         fullWidth
//       >
//         <DialogTitle>
//           <Box display="flex" alignItems="center">
//             <InfoIcon color="warning" sx={{ mr: 1 }} />
//             Column Mismatch Detected
//           </Box>
//         </DialogTitle>
//         <DialogContent>
//           <Typography variant="body1" sx={{ mb: 2 }}>
//             You have selected to upload {selectedRates}, but your Excel file contains additional rate columns: {extraColumns.join(', ')}.
//           </Typography>
//           <Typography variant="body1" sx={{ mb: 2 }}>
//             Would you like to skip the unselected rate columns and proceed with only the selected ones?
//           </Typography>
//           <Alert severity="info">
//             Clicking "Yes" will ignore the {extraColumns.join(', ')} column{extraColumns.length > 1 ? 's' : ''} during processing.
//           </Alert>
//         </DialogContent>
//         <DialogActions>
//           <Button onClick={() => handleConfirmSkipColumns(false)} color="primary">
//             Cancel
//           </Button>
//           <Button onClick={() => handleConfirmSkipColumns(true)} color="warning" variant="contained">
//             Yes, Skip Unselected Columns
//           </Button>
//         </DialogActions>
//       </Dialog>
//     );
//   };
  


//   const ApiErrorsDialog = () => {
//     return (
//       <Dialog
//         open={showApiErrorsDialog}
//         onClose={() => setShowApiErrorsDialog(false)}
//         maxWidth="md"
//         fullWidth
//       >
//         <DialogTitle>
//           <Box display="flex" alignItems="center">
//             <ErrorOutlineIcon color="error" sx={{ mr: 1 }} />
//             API Validation Errors
//           </Box>
//         </DialogTitle>
//         <DialogContent>
//           <TableContainer>
//             <Table>
//               <TableHead>
//                 <TableRow>
//                   <TableCell>Area ID</TableCell>
//                   <TableCell>Item Code</TableCell>
//                   <TableCell>Error Description</TableCell>
//                 </TableRow>
//               </TableHead>
//               <TableBody>
//                 {apiErrors.map((error, index) => (
//                   <TableRow key={index}>
//                     <TableCell>{error.AreaID}</TableCell>
//                     <TableCell>{error.itemCode}</TableCell>
//                     <TableCell>{error.ErrorDescr}</TableCell>
//                   </TableRow>
//                 ))}
//               </TableBody>
//             </Table>
//           </TableContainer>
//         </DialogContent>
//         <DialogActions>
//           <Button
//             onClick={() => setShowApiErrorsDialog(false)}
//             color="primary"
//             variant="contained"
//           >
//             Close
//           </Button>
//         </DialogActions>
//       </Dialog>
//     );
//   };


//   const clearFile = () => {
//     setFile(null);
//     setFileName('');
//     setExcelData([]);
//     setValidatedData(null);
//     setInvalidRows([]);
//     setDuplicateRows([]);
//     setRateErrorRows([]);

//     // Reset the file input value if the ref is available
//     if (fileInputRef.current) {
//       fileInputRef.current.value = '';
//     }
//   };

//   const handleCloseNotification = () => {
//     setNotification({ ...notification, open: false });
//   };

//   // Helper function to determine row styling based on validation errors
//   const getRowStyle = (index) => {
//     const rowNum = index + 1;
//     const isInvalidFormat = invalidRows.includes(rowNum);
//     const isDuplicate = duplicateRows.includes(rowNum);
//     const hasRateError = rateErrorRows.includes(rowNum);

//     if (isInvalidFormat || isDuplicate || hasRateError) {
//       return {
//         backgroundColor: '#ffebee',
//         '&:hover': { backgroundColor: '#ffcdd2' }
//       };
//     }

//     return {
//       '&:nth-of-type(odd)': { backgroundColor: '#fafafa' },
//       '&:hover': { backgroundColor: '#f5f5f5' }
//     };
//   };

//   // Helper function to get error tooltip message for a row
//   // Update the getRowErrorMessage function
//   const getRowErrorMessage = (index) => {
//     const rowNum = index + 1;
//     const errors = [];

//     // Find specific error types for this row
//     const invalidRow = invalidRowsList.find(item => item.rowNumber === rowNum);
//     if (invalidRow) {
//       if (invalidRow.errors.includes('missing_identifier')) errors.push("Missing AreaId or ItemCode");
//       if (invalidRow.errors.includes('missing_rate')) errors.push("Missing rate value");
//       if (invalidRow.errors.includes('negative_rate')) errors.push("Negative rate value");
//       if (invalidRow.errors.includes('invalid_decimals')) errors.push("More than 2 decimal places");
//       if (invalidRow.errors.includes('special_chars')) errors.push("Special characters in AreaId/ItemCode");
//       if (invalidRow.errors.includes('double_decimal')) errors.push("Double decimal point");
//       if (invalidRow.errors.includes('non_numeric_rate')) errors.push("Non-numeric rate value");
//     }

//     if (duplicateRows.includes(rowNum)) {
//       errors.push("Duplicate AreaId+ItemCode combination");
//     }

//     if (rateErrorRows.includes(rowNum)) {
//       errors.push("VANRate , MOCRate or HORECARATE greater than MRPRate");
//     }

//     return errors.join(", ");
//   };

//   return (
//     <>
//       <Header />
//       <ThemeProvider theme={theme}>
//         <Box sx={{
//           minHeight: '100vh',
//           backgroundColor: 'background.default',
//           pt: 4,
//           pb: 6
//         }}>
//           <Container maxWidth="lg">
//             <Grow in={true} timeout={800}>
//               <Paper elevation={3} sx={{ p: 4, borderRadius: 3, overflow: 'hidden' }}>
//                 <Box sx={{
//                   display: 'flex',
//                   alignItems: 'center',
//                   mb: 3,
//                   borderBottom: '1px solid #e0e0e0',
//                   pb: 2
//                 }}>
//                   <TableChartIcon sx={{ fontSize: 32, mr: 2, color: 'primary.main' }} />
//                   <Typography variant="h4" component="h1">
//                     Rate Upload
//                   </Typography>
//                   <Tooltip title="Upload Excel files with AreaId, ItemCode, VANRate, MOCRate, HORECARate,and MRPRate columns">
//                     <IconButton sx={{ ml: 2 }}>
//                       <InfoIcon color="action" />
//                     </IconButton>
//                   </Tooltip>
//                 </Box>

//                 <Box sx={{
//                   backgroundColor: '#f8faff',
//                   p: 3,
//                   borderRadius: 2,
//                   mb: 4,
//                   border: '1px solid #e3f2fd'
//                 }}>
//                   <Typography variant="subtitle1" sx={{ mb: 2, fontWeight: 500 }}>
//                     Upload Excel Data
//                   </Typography>



//                   <Grid container spacing={2} sx={{ mt: 2 }}>
//                     <Grid item xs={12}>
//                       <Typography variant="subtitle2" sx={{ mb: 1 }}>
//                         Select Required Rate Types:
//                       </Typography>
//                     </Grid>
//                     <Grid item xs={6} md={3}>
//                       <FormControlLabel
//                         control={
//                           <Checkbox
//                             checked={isMOCRateRequired}
//                             onChange={() => handleCheckboxChange('MOC')}
//                             color="primary"
//                           />
//                         }
//                         label="MOCRate"
//                       />
//                     </Grid>
//                     <Grid item xs={6} md={3}>
//                       <FormControlLabel
//                         control={
//                           <Checkbox
//                             checked={isHORECARateRequired}
//                             onChange={() => handleCheckboxChange('HORECA')}
//                             color="primary"
//                           />
//                         }
//                         label="HORECARate"
//                       />
//                     </Grid>
//                     <Grid item xs={6} md={3}>
//                       <FormControlLabel
//                         control={
//                           <Checkbox
//                             checked={isVANRateRequired}
//                             onChange={() => handleCheckboxChange('VAN')}
//                             color="primary"
//                           />
//                         }
//                         label="VANRate"
//                       />
//                     </Grid>
//                     <Grid item xs={6} md={3}>
//                       <FormControlLabel
//                         control={
//                           <Checkbox
//                             checked={isMRPRateRequired}
//                             onChange={() => handleCheckboxChange('MRP')}
//                             color="primary"
//                           />
//                         }
//                         label="MRPRate"
//                       />
//                     </Grid>
//                     <Grid item xs={12}>
//                       <Alert severity="info" sx={{ mt: 1 }}>
//                         {!isMOCRateRequired && !isVANRateRequired && !isHORECARateRequired && !isMRPRateRequired ?
//                           "Please select at least one rate type to enable upload" :
//                           `Selected rate types: ${[
//                             isMOCRateRequired ? "MOCRate" : "",
//                             isHORECARateRequired ? "HORECARate" : "",
//                             isVANRateRequired ? "VANRate" : "",
//                             isMRPRateRequired ? "MRPRate" : ""
//                           ].filter(Boolean).join(", ")}`
//                         }
//                       </Alert>
//                     </Grid>
//                   </Grid>


//                   <Grid container spacing={3} alignItems="center">
//                     <Grid item xs={12} md={4}>
//                       <Box sx={{ display: 'flex', alignItems: 'center' }}>
//                         <Button
//                           variant="contained"
//                           component="label"
//                           startIcon={<FileOpenIcon />}
//                           sx={{
//                             mr: 2,
//                             background: 'linear-gradient(45deg, #2196F3 30%, #21CBF3 90%)',
//                             boxShadow: '0 3px 5px 2px rgba(33, 203, 243, .3)',
//                             color: 'white',
//                             '&:hover': {
//                               background: 'linear-gradient(45deg, #1976d2 30%, #21a6f3 90%)',
//                             }
//                           }}
//                         >
//                           Choose File
//                           <input
//                             ref={fileInputRef}
//                             type="file"
//                             accept=".xlsx, .xls"
//                             hidden
//                             onChange={handleFileChange}
//                           />
//                         </Button>

//                         {fileName && (
//                           <Fade in={!!fileName}>
//                             <Box sx={{ display: 'flex', alignItems: 'center' }}>
//                               <Chip
//                                 label={fileName}
//                                 variant="outlined"
//                                 color="primary"
//                                 onDelete={clearFile}
//                                 deleteIcon={<DeleteIcon />}
//                                 sx={{ maxWidth: '250px' }}
//                               />
//                             </Box>
//                           </Fade>
//                         )}
//                       </Box>
//                     </Grid>

//                     <Grid item xs={12} md={4}>
//                       <Button
//                         variant="contained"
//                         color="primary"
//                         onClick={handleImport}
//                         disabled={!file || isLoading}
//                         fullWidth
//                         sx={{
//                           py: 1.5,
//                           background: file && !isLoading ? 'linear-gradient(45deg, #4CAF50 30%, #8BC34A 90%)' : '',
//                           boxShadow: file && !isLoading ? '0 3px 5px 2px rgba(76, 175, 80, .3)' : '',
//                           '&:hover': {
//                             background: file && !isLoading ? 'linear-gradient(45deg, #43A047 30%, #7CB342 90%)' : ''
//                           }
//                         }}
//                       >
//                         {isLoading ? (
//                           <Box sx={{ display: 'flex', alignItems: 'center' }}>
//                             <CircularProgress size={24} color="inherit" sx={{ mr: 1 }} />
//                             Processing...
//                           </Box>
//                         ) : (
//                           <>
//                             <CloudUploadIcon sx={{ mr: 1 }} /> Validate Data
//                           </>
//                         )}
//                       </Button>
//                     </Grid>

//                     <Grid item xs={12} md={4}>
//                       <Button
//                         variant="contained"
//                         color="secondary"
//                         onClick={handleUpload}
//                         disabled={
//                           !validatedData ||
//                           isUploading ||
//                           (!isMOCRateRequired && !isVANRateRequired && !isMRPRateRequired && !isHORECARateRequired) ||
//                           invalidRows.length > 0 ||
//                           duplicateRows.length > 0 ||
//                           rateErrorRows.length > 0
//                         }
//                         fullWidth
//                         sx={{
//                           py: 1.5,
//                           background: validatedData && !isUploading && invalidRows.length === 0 && duplicateRows.length === 0 && rateErrorRows.length === 0 ?
//                             'linear-gradient(45deg, #FF5722 30%, #FF9800 90%)' : '',
//                           boxShadow: validatedData && !isUploading && invalidRows.length === 0 && duplicateRows.length === 0 && rateErrorRows.length === 0 ?
//                             '0 3px 5px 2px rgba(255, 87, 34, .3)' : '',
//                           '&:hover': {
//                             background: validatedData && !isUploading && invalidRows.length === 0 && duplicateRows.length === 0 && rateErrorRows.length === 0 ?
//                               'linear-gradient(45deg, #E64A19 30%, #F57C00 90%)' : ''
//                           }
//                         }}
//                       >
//                         {isUploading ? (
//                           <Box sx={{ display: 'flex', alignItems: 'center' }}>
//                             <CircularProgress size={24} color="inherit" sx={{ mr: 1 }} />
//                             Uploading...
//                           </Box>
//                         ) : (
//                           <>
//                             <SendIcon sx={{ mr: 1 }} /> Submit
//                           </>
//                         )}
//                       </Button>
//                     </Grid>
//                   </Grid>
//                 </Box>

//                 {(invalidRows.length > 0 || duplicateRows.length > 0 || rateErrorRows.length > 0) && (
//                   <Alert
//                     severity="warning"
//                     sx={{ mb: 3 }}
//                     action={
//                       <Tooltip title="Rows with errors are highlighted in red">
//                         <IconButton size="small">
//                           <InfoIcon />
//                         </IconButton>
//                       </Tooltip>
//                     }
//                   >
//                     <Typography variant="subtitle2">Validation Errors Found:</Typography>
//                     <Box component="ul" sx={{ mt: 1, pl: 2 }}>
//                       {invalidRowsList && invalidRowsList.length > 0 ? (
//                         <li>
//                           Data validation errors:
//                           <Box component="ul" sx={{ pl: 2 }}>
//                             {invalidRowsList.map((item, idx) => (
//                               <li key={idx}>
//                                 Row {item.rowNumber}: {item.errors && Array.isArray(item.errors) ? item.errors.map(err => {
//                                   switch (err) {
//                                     case 'missing_identifier': return 'Missing AreaId or ItemCode';
//                                     case 'missing_rate': return 'Missing rate value';
//                                     case 'negative_rate': return 'Negative rate value';
//                                     case 'invalid_decimals': return 'More than 2 decimal places';
//                                     case 'special_chars': return 'Special characters in AreaId/ItemCode';
//                                     case 'double_decimal': return 'Double decimal point';
//                                     case 'non_numeric_rate': return 'Non-numeric rate value';
//                                     default: return err;
//                                   }
//                                 }).join(', ') : 'Unknown error'}
//                               </li>
//                             ))}
//                           </Box>
//                         </li>
//                       ) : (
//                         invalidRows.length > 0 && <li>Invalid data format in rows: {invalidRows.join(', ')}</li>
//                       )}
//                       {rateErrorRows.length > 0 && (
//                         <li>
//                           Rate errors (VANRate, MOCRate or HORECARate greater than MRPRate) in rows: {rateErrorRows.join(', ')}
//                         </li>
//                       )}
//                       {duplicateRows.length > 0 && (
//                         <li>
//                           Duplicate AreaId+ItemCode combinations in rows: {duplicateRows.join(', ')}
//                         </li>
//                       )}
//                     </Box>
//                   </Alert>
//                 )}

//                 <Divider sx={{ my: 3 }} />

//                 <Box sx={{ mt: 2 }}>
//                   <Typography variant="h6" sx={{ mb: 2, display: 'flex', alignItems: 'center' }}>
//                     <TableChartIcon sx={{ mr: 1, fontSize: 20 }} /> Data Preview
//                   </Typography>

//                   {excelData.length > 0 ? (
//                     <Fade in={excelData.length > 0} timeout={800}>
//                       <TableContainer component={Paper} sx={{
//                         mt: 2,
//                         boxShadow: '0 2px 10px rgba(0,0,0,0.08)',
//                         borderRadius: 2,
//                         maxHeight: 400,
//                         overflow: 'auto'
//                       }}>
//                         <Table aria-label="excel data table" stickyHeader>
//                           <TableHead>
//                             <TableRow>
//                               <TableCell sx={{ fontWeight: 'bold' }}>Row</TableCell>
//                               <TableCell sx={{ fontWeight: 'bold' }}>Area ID</TableCell>
//                               <TableCell sx={{ fontWeight: 'bold' }}>Item Code</TableCell>
//                               {isVANRateRequired && (
//                                 <TableCell align="right" sx={{ fontWeight: 'bold' }}>VAN Rate</TableCell>
//                               )}
//                               {isMOCRateRequired && (
//                                 <TableCell align="right" sx={{ fontWeight: 'bold' }}>MOC Rate</TableCell>
//                               )}
//                                 {isHORECARateRequired && (
//                                 <TableCell align="right" sx={{ fontWeight: 'bold' }}>HORECA Rate</TableCell>
//                               )}
//                               {isHORECARateRequired && (
//   <TableCell align="right" sx={{ fontWeight: 'bold' }}>Qualify Qty</TableCell>
// )}
//                               {isMRPRateRequired && (
//                                 <TableCell align="right" sx={{ fontWeight: 'bold' }}>MRP Rate</TableCell>
//                               )}
//                               <TableCell align="center" sx={{ fontWeight: 'bold' }}>Status</TableCell>
//                             </TableRow>
//                           </TableHead>

//                           <TableBody>
//                             {excelData.map((row, index) => {
//                               const rowNum = index + 1;
//                               const hasError = invalidRows.includes(rowNum) ||
//                                 duplicateRows.includes(rowNum) ||
//                                 rateErrorRows.includes(rowNum);
//                               const errorMsg = getRowErrorMessage(index);

//                               return (
//                                 <TableRow
//                                   key={index}
//                                   sx={getRowStyle(index)}
//                                 >
//                                   <TableCell>{rowNum}</TableCell>
//                                   <TableCell>{row.AreaId}</TableCell>
//                                   <TableCell>{row.ItemCode}</TableCell>
//                                   {isVANRateRequired && (
//                                     <TableCell
//                                       align="right"
//                                       sx={rateErrorRows.includes(rowNum) && row.VANRate > row.MRPRate ? { color: 'error.main' } : {}}
//                                     >
//                                       {typeof row.VANRate === 'number'
//                                         ? `${row.VANRate.toFixed(2)}`
//                                         : row.VANRate}
//                                     </TableCell>
//                                   )}
//                                   {isMOCRateRequired && (
//                                     <TableCell
//                                       align="right"
//                                       sx={rateErrorRows.includes(rowNum) && row.MOCRate > row.MRPRate ? { color: 'error.main' } : {}}
//                                     >
//                                       {typeof row.MOCRate === 'number'
//                                         ? `${row.MOCRate.toFixed(2)}`
//                                         : row.MOCRate}
//                                     </TableCell>
//                                   )}
//                                    {isHORECARateRequired && (
//                                     <TableCell
//                                       align="right"
//                                       sx={rateErrorRows.includes(rowNum) && row.HORECARate > row.MRPRate ? { color: 'error.main' } : {}}
//                                     >
//                                       {typeof row.HORECARate === 'number'
//                                         ? `${row.HORECARate.toFixed(2)}`
//                                         : row.HORECARate}
//                                     </TableCell>
//                                   )}

// {isHORECARateRequired && (
//   <TableCell align="right">
//     {typeof row.QualifyQty === 'number' ? `${row.QualifyQty}` : row.QualifyQty}
//   </TableCell>
// )}

//                                   {isMRPRateRequired && (
//                                     <TableCell align="right">
//                                       {typeof row.MRPRate === 'number'
//                                         ? `${row.MRPRate.toFixed(2)}`
//                                         : row.MRPRate}
//                                     </TableCell>
//                                   )}
//                                   <TableCell align="center">
//                                     {hasError ? (
//                                       <Tooltip title={errorMsg}>
//                                         <ErrorOutlineIcon color="error" />
//                                       </Tooltip>
//                                     ) : (
//                                       <Chip
//                                         label="Valid"
//                                         size="small"
//                                         color="success"
//                                         variant="outlined"
//                                         sx={{ fontSize: '0.7rem' }}
//                                       />
//                                     )}
//                                   </TableCell>
//                                 </TableRow>
//                               );
//                             })}
//                           </TableBody>
//                         </Table>
//                       </TableContainer>
//                     </Fade>
//                   ) : (
//                     <Fade in={!excelData.length} timeout={800}>
//                       <Box
//                         sx={{
//                           p: 5,
//                           textAlign: 'center',
//                           bgcolor: '#fafafa',
//                           borderRadius: 2,
//                           border: '2px dashed #e0e0e0',
//                           display: 'flex',
//                           flexDirection: 'column',
//                           alignItems: 'center',
//                           justifyContent: 'center'
//                         }}
//                       >
//                         <CloudUploadIcon sx={{ fontSize: 64, color: '#bdbdbd', mb: 2 }} />
//                         <Typography variant="h6" color="text.secondary" sx={{ mb: 1 }}>
//                           No Data Available
//                         </Typography>
//                         <Typography variant="body2" color="text.secondary">
//                           Upload an Excel file to view your data here
//                         </Typography>
//                       </Box>
//                     </Fade>
//                   )}
//                 </Box>

//                 {validatedData && validatedData.length > 0 && (
//                   <Box sx={{ mt: 3, p: 2, bgcolor: '#e8f5e9', borderRadius: 2, border: '1px solid #c8e6c9' }}>
//                     <Typography variant="subtitle1" sx={{ color: '#2e7d32', fontWeight: 500, display: 'flex', alignItems: 'center' }}>
//                       <InfoIcon sx={{ mr: 1, fontSize: 20 }} />
//                       Data validated successfully. {validatedData.length} valid records ready to upload.
//                       {invalidRows.length > 0 || duplicateRows.length > 0 || rateErrorRows.length > 0 ?
//                         ` (${invalidRows.length + duplicateRows.length + rateErrorRows.length} invalid records will be skipped)` :
//                         ''}
//                     </Typography>
//                   </Box>
//                 )}

//                 {apiErrors.length > 0 && (
//                   <Box sx={{ mt: 3, p: 2, bgcolor: '#fff3e0', borderRadius: 2, border: '1px solid #ffe0b2' }}>
//                     <Typography variant="subtitle1" sx={{ color: '#e65100', fontWeight: 500, display: 'flex', alignItems: 'center' }}>
//                       <ErrorOutlineIcon sx={{ mr: 1, fontSize: 20 }} />
//                       {apiErrors.length} items failed validation during upload.
//                       <Button
//                         color="warning"
//                         variant="outlined"
//                         size="small"
//                         onClick={() => setShowApiErrorsDialog(true)}
//                         sx={{ ml: 2 }}
//                       >
//                         View Errors
//                       </Button>
//                     </Typography>
//                   </Box>
//                 )}
//               </Paper>
//             </Grow>

//             <Snackbar
//               open={notification.open}
//               autoHideDuration={6000}
//               onClose={handleCloseNotification}
//               anchorOrigin={{ vertical: 'bottom', horizontal: 'right' }}
//             >
//               <Alert
//                 onClose={handleCloseNotification}
//                 severity={notification.severity}
//                 variant="filled"
//                 sx={{ width: '100%' }}
//               >
//                 {notification.message}
//               </Alert>
//             </Snackbar>
//           </Container>
//         </Box>
//         <ColumnMismatchDialog />
//         <ApiErrorsDialog />
//       </ThemeProvider>
//     </>
//   );
// };

// export default RateUpload;
































// // import React, { useState, useEffect } from 'react';
// // import {
// //   Container,
// //   Grid,
// //   FormControl,
// //   InputLabel,
// //   Select,
// //   MenuItem,
// //   Button,
// //   Paper,
// //   Box,
// //   TextField,
// //   InputAdornment,
// //   CircularProgress,
// //   Typography
// // } from '@mui/material';
// // import SearchIcon from '@mui/icons-material/Search';
// // import FileDownloadIcon from '@mui/icons-material/FileDownload';
// // import ReportTable from './ReportTable';
// // import './ReportStules.css'; // Ensure you have the CSS classes updated to match
// // import Header from '../Header';
// // import { local_signage, local_url } from '../Const';
// // import * as XLSX from 'xlsx';


// // const ReportPage = () => {
// //   const [area, setArea] = useState('');  // Area selected by user
// //   const [expiryCriteria, setExpiryCriteria] = useState('');
// //   const [criteriaValue, setCriteriaValue] = useState('');
// //   const [branch, setBranch] = useState('');
// //   const [itemGroup, setItemGroup] = useState('');
// //   const [showTable, setShowTable] = useState(false);
// //   const [loading, setLoading] = useState(false);
// //   const [searchQuery, setSearchQuery] = useState('');
// //   const [areas, setAreas] = useState([]);
// //   const [branches, setBranches] = useState([]);
// //   const [areasLoading, setAreasLoading] = useState(false);
// //   const [error, setError] = useState(null);
// //   const [tableData, setTableData] = useState([]);
// //   const [criteriaValueError, setCriteriaValueError] = useState('');

// //   const local_api = `${local_url}`;  // Make sure to set your actual URL
// //   const local_signapi = `${local_signage}`;
// //   const userId = localStorage.getItem('userId');
// //   // Your userId or any other identifier for the API

// //   // Fetch Areas using useEffect
// //   useEffect(() => {
// //     const fetchAreas = async () => {
// //       setAreasLoading(true);
// //       setError(null);

// //       try {
// //         const response = await fetch(`${local_api}/api/SFArea/${userId}`);
// //         if (!response.ok) throw new Error(`HTTP error! status: ${response.status}`);
// //         const data = await response.json();
// //         setAreas(Array.isArray(data) ? data : []);
// //       } catch (error) {
// //         setError(`Failed to fetch areas: ${error.message}`);
// //       } finally {
// //         setAreasLoading(false);
// //       }
// //     };

// //     fetchAreas();
// //   }, [local_api, userId]);

// //   // Fetch Branch List function when area changes
// //   const fetchBranchList = async (sfAreaId) => {
// //     const token = localStorage.getItem('AuthorizationToken');

// //     if (!token) {
// //       console.error('Authentication token is missing');
// //       alert("Authentication token is missing. Please log in again.");
// //       localStorage.clear();
// //       sessionStorage.clear();
// //       window.location.href = "/login";
// //       return;
// //     }

// //     try {
// //       const url = `${local_api}/api/Company/GetBranchList/ALL/AREA/${sfAreaId}`;
// //       const response = await fetch(url, {
// //         headers: { Authorization: `Bearer ${token}` },
// //       });
// //       if (!response.ok) throw new Error(`HTTP error! status: ${response.status}`);
// //       const data = await response.json();
// //       setBranches(Array.isArray(data) ? data : []);
// //     } catch (error) {
// //       setError(`Failed to fetch branches: ${error.message}`);
// //     }
// //   };

// //   // Fetch Branch List when the area changes
// //   useEffect(() => {
// //     if (area && area !== "ALL") {
// //       fetchBranchList(area);  // Call the function to fetch branches using the selected sfAreaId
// //     }
// //   }, [area]);

// //   // Validate criteria value based on selected expiry criteria
// //   const validateCriteriaValue = (value) => {
// //     if (!value) return true; // Empty value is allowed initially
    
// //     const numValue = Number(value);
    
// //     if (isNaN(numValue)) return false; // Not a number
    
// //     if (expiryCriteria === 'PERCENTAGE') {
// //       return numValue >= 1 && numValue <= 100;
// //     } else if (expiryCriteria === 'DAYS') {
// //       return numValue >= 1;
// //     }
    
// //     return true;
// //   };

// //   // Handle criteria value change
// //   const handleCriteriaValueChange = (e) => {
// //     const value = e.target.value;
// //     setCriteriaValue(value);
    
// //     if (!validateCriteriaValue(value)) {
// //       if (expiryCriteria === 'PERCENTAGE') {
// //         setCriteriaValueError('Value must be a number between 1 and 100');
// //       } else if (expiryCriteria === 'DAYS') {
// //         setCriteriaValueError('Value must be a number greater than or equal to 1');
// //       } else {
// //         setCriteriaValueError('Invalid value');
// //       }
// //     } else {
// //       setCriteriaValueError('');
// //     }
// //   };

// //   // Handle expiry criteria change
// //   const handleExpiryCriteriaChange = (e) => {
// //     setExpiryCriteria(e.target.value);
// //     setCriteriaValue(''); // Reset criteria value when criteria changes
// //     setCriteriaValueError(''); // Reset error when criteria changes
// //   };

// //   // Handle submit
// //   const handleSubmit = async () => {
// //     if (!area || !branch || !expiryCriteria || !criteriaValue || !itemGroup) {
// //       alert("Please fill in all required fields before generating the report.");
// //       return;
// //     }

// //     if (criteriaValueError) {
// //       alert("Please fix the criteria value error before generating the report.");
// //       return;
// //     }
  
// //     const token = localStorage.getItem('AuthorizationToken');
  
// //     if (!token) {
// //       alert("Authentication token is missing. Please log in again.");
// //       localStorage.clear();
// //       sessionStorage.clear();
// //       window.location.href = "/login";
// //       return;
// //     }
  
// //     setError(null);
// //     setLoading(true);
// //     setShowTable(false); // Hide table while loading
    
// //     try {
// //       const url = `https://retailuat.abisibg.com/api/v1/batchitemmovement?AreaId=${area}&OriginBranchId=${branch}&ItemGroupId=${itemGroup}&ExpiryCriteria=${expiryCriteria}&ExpiryValue=${criteriaValue}`;
  
// //       const response = await fetch(url, {
// //         method: 'GET',
// //         headers: {
// //           Authorization: `Bearer ${token}`,
// //           'Content-Type': 'application/json',
// //         },
// //       });
  
// //       if (!response.ok) {
// //         throw new Error(`HTTP error! status: ${response.status}`);
// //       }
  
// //       const data = await response.json();
  
// //       if (!Array.isArray(data)) {
// //         throw new Error("Unexpected response format");
// //       }
  
// //       // Transform API response to match table structure
// //       // In your handleSubmit function, update the transformation to handle potential nulls:
// // const transformedData = data.map((item, index) => ({
// //   id: index + 1,
// //   plantCode: item.BranchID || '',
// //   itemCode: item.ItemId || '',
// //   itemName: item.ItemName || '',
// //   batchNumber: item.BatchNumber || '',
// //   shelfLife: item.BestForDays ? `${item.BestForDays} days` : '',
// //   producedQty: item.ProdQty || 0,
// //   currentQty: item.BalQty || 0,
// //   mfgDate: item.BatchDate ? item.BatchDate.split("T")[0] : '',
// //   expiryDate: item.BatchDate && item.BestForDays ? 
// //     new Date(new Date(item.BatchDate).getTime() + item.BestForDays * 24 * 60 * 60 * 1000).toISOString().split("T")[0] : '',
// //   remainingShelfLife: (item.BestForDays && item.Age) ? (item.BestForDays - item.Age) : 0,
// //   autoWeight: item.ProdSerialNo || '',
// // }));
  
// //       setTableData(transformedData);
// //       setShowTable(true);
// //     } catch (error) {
// //       setError(`Failed to fetch data: ${error.message}`);
// //     } finally {
// //       setLoading(false);
// //     }
// //   };

// //   // Handle export
// //   const handleExport = () => {
// //     if (!tableData || tableData.length === 0) {
// //       alert('No data available to export.');
// //       return;
// //     }
  
// //     // Convert the data to a worksheet
// //     const worksheet = XLSX.utils.json_to_sheet(tableData);
  
// //     // Create a new workbook and append the worksheet
// //     const workbook = XLSX.utils.book_new();
// //     XLSX.utils.book_append_sheet(workbook, worksheet, "ReportData");
  
// //     // Generate and trigger download
// //     XLSX.writeFile(workbook, "ReportData.xlsx");
// //   };

// //   // Filter data based on search query
// //   const filteredData = tableData.filter(row => {
// //     if (!searchQuery) return true;
// //     const query = searchQuery.toLowerCase();
// //     return (
// //       row.plantCode.toLowerCase().includes(query) ||
// //       row.itemCode.toLowerCase().includes(query) ||
// //       row.itemName.toLowerCase().includes(query) ||
// //       row.batchNumber.toLowerCase().includes(query) ||
// //       String(row.producedQty).includes(query) ||
// //       String(row.currentQty).includes(query)
// //     );
// //   });

// //   return (
// //     <Container maxWidth={false} className="reportexpiry-container">
// //       <Header />
// //       <Paper elevation={3} className="reportexpiry-paper">
// //         <Box className="reportexpiry-filters-container">
// //           <Grid container spacing={3}>
// //             <Grid item xs={12} sm={6} md={2}>
// //               <FormControl fullWidth variant="outlined" className="reportexpiry-form-control">
// //                 <InputLabel>Area</InputLabel>
// //                 <Select
// //                   value={area}
// //                   onChange={(e) => setArea(e.target.value)}
// //                   label="Area"
// //                   disabled={areasLoading} // Disable the dropdown while the areas are loading
// //                 >
// //                   <MenuItem value="ALL">ALL</MenuItem>
// //                   {areas.map((areaOption) => (
// //                     <MenuItem key={areaOption.sfAreaId} value={areaOption.sfAreaId}>
// //                       {areaOption.sfAreaName}
// //                     </MenuItem>
// //                   ))}
// //                 </Select>
// //               </FormControl>
// //             </Grid>

// //             <Grid item xs={12} sm={6} md={3}>
// //               <FormControl fullWidth variant="outlined" className="reportexpiry-form-control">
// //                 <InputLabel>Branch</InputLabel>
// //                 <Select
// //                   value={branch}
// //                   onChange={(e) => setBranch(e.target.value)}
// //                   label="Branch"
// //                 >
// //                   {branches.length === 0 ? (
// //                     <MenuItem>Loading...</MenuItem>
// //                   ) : (
// //                     branches.map((branchOption) => (
// //                       <MenuItem key={branchOption.branchID} value={branchOption.branchID}>
// //                         {branchOption.branchName}
// //                       </MenuItem>
// //                     ))
// //                   )}
// //                 </Select>
// //               </FormControl>
// //             </Grid>

// //             <Grid item xs={12} sm={6} md={2}>
// //               <FormControl fullWidth variant="outlined" className="reportexpiry-form-control">
// //                 <InputLabel>Item Group</InputLabel>
// //                 <Select
// //                   value={itemGroup}
// //                   onChange={(e) => setItemGroup(e.target.value)}
// //                   label="Item Group"
// //                 >
// //                   <MenuItem value="ALL">ALL</MenuItem>
// //                   <MenuItem value="MASALA">Masala</MenuItem>
// //                   <MenuItem value="RTC">Ready to Cook</MenuItem>
// //                 </Select>
// //               </FormControl>
// //             </Grid>

// //             <Grid item xs={12} sm={6} md={2}>
// //               <FormControl fullWidth variant="outlined" className="reportexpiry-form-control">
// //                 <InputLabel>Expiry Criteria</InputLabel>
// //                 <Select
// //                   value={expiryCriteria}
// //                   onChange={handleExpiryCriteriaChange}
// //                   label="Expiry Criteria"
// //                 >
// //                   <MenuItem value="PERCENTAGE">Percentage</MenuItem>
// //                   <MenuItem value="DAYS">Days</MenuItem>
// //                 </Select>
// //               </FormControl>
// //             </Grid>

// //             <Grid item xs={12} sm={6} md={2}>
// //               <TextField
// //                 fullWidth
// //                 label="Criteria Value"
// //                 variant="outlined"
// //                 className="reportexpiry-form-control"
// //                 value={criteriaValue}
// //                 onChange={handleCriteriaValueChange}
// //                 error={!!criteriaValueError}
// //                 helperText={criteriaValueError}
// //                 disabled={!expiryCriteria} // Disable until expiry criteria is selected
// //                 type="number"
// //                 InputProps={{
// //                   inputProps: { 
// //                     min: 1,
// //                     max: expiryCriteria === 'PERCENTAGE' ? 100 : undefined
// //                   }
// //                 }}
// //               />
// //             </Grid>
// //           </Grid>

// //           <Box className="reportexpiry-action-buttons-container">
// //             <Button
// //               variant="contained"
// //               color="primary"
// //               onClick={handleSubmit}
// //               className="reportexpiry-action-button"
// //               disabled={loading}
// //             >
// //               {loading ? 'Generating...' : 'Generate Report'}
// //             </Button>

// //             <Button
// //   variant="outlined"
// //   color="primary"
// //   onClick={handleExport}
// //   className="reportexpiry-action-button"
// //   startIcon={<FileDownloadIcon />}
// //   disabled={!showTable || loading}
// // >
// //   Export to Excel
// // </Button>


// //             <TextField
// //               placeholder="Search..."
// //               variant="outlined"
// //               size="small"
// //               className="reportexpiry-search-field"
// //               value={searchQuery}
// //               onChange={(e) => setSearchQuery(e.target.value)}
// //               InputProps={{
// //                 startAdornment: (
// //                   <InputAdornment position="start">
// //                     <SearchIcon />
// //                   </InputAdornment>
// //                 ),
// //               }}
// //               disabled={!showTable}
// //             />
// //           </Box>
// //         </Box>

// //         {loading && (
// //           <Box 
// //             className="reportexpiry-loading-container" 
// //             sx={{ 
// //               display: 'flex', 
// //               justifyContent: 'center', 
// //               alignItems: 'center', 
// //               flexDirection: 'column',
// //               p: 5,
// //               minHeight: '200px'
// //             }}
// //           >
// //             <CircularProgress size={60} />
// //             <Typography variant="h6" mt={2} color="primary">
// //               Loading data, please wait...
// //             </Typography>
// //           </Box>
// //         )}

// //         {showTable && !loading && (
// //           <Box className="reportexpiry-fixed-table-container">
// //             <ReportTable data={filteredData} />
// //           </Box>
// //         )}

// //         {error && !loading && (
// //           <Box mt={2} p={2} bgcolor="error.light" color="error.main">
// //             {error}
// //           </Box>
// //         )}
// //       </Paper>
// //     </Container>
// //   );
// // };

// // export default ReportPage;








































// import React, { useState, useRef } from 'react';
// import {
//   Button,
//   Box,
//   Typography,
//   Paper,
//   Table,
//   TableBody,
//   TableCell,
//   TableContainer,
//   TableHead,
//   TableRow,
//   Container,
//   Grid,
//   CircularProgress,
//   Chip,
//   Divider,
//   Fade,
//   Grow,
//   Tooltip,
//   IconButton,
//   Alert,
//   Snackbar
// } from '@mui/material';
// import {
//   Dialog,
//   DialogActions,
//   DialogContent,
//   DialogTitle
// } from '@mui/material';
// import CloudUploadIcon from '@mui/icons-material/CloudUpload';
// import DeleteIcon from '@mui/icons-material/Delete';
// import FileOpenIcon from '@mui/icons-material/FileOpen';
// import InfoIcon from '@mui/icons-material/Info';
// import TableChartIcon from '@mui/icons-material/TableChart';
// import SendIcon from '@mui/icons-material/Send';
// import ErrorOutlineIcon from '@mui/icons-material/ErrorOutline';
// import * as XLSX from 'xlsx';
// import { createTheme, ThemeProvider } from '@mui/material/styles';
// import { FormControlLabel, Checkbox } from '@mui/material';
// import Header from '../Header';


// const theme = createTheme({
//   palette: {
//     primary: {
//       main: '#1976d2',
//     },
//     secondary: {
//       main: '#f50057',
//     },
//     background: {
//       default: '#f5f7fa',
//     },
//   },
//   typography: {
//     h4: {
//       fontWeight: 600,
//     },
//     button: {
//       fontWeight: 500,
//     },
//   },
//   components: {
//     MuiPaper: {
//       styleOverrides: {
//         root: {
//           borderRadius: 12,
//           boxShadow: '0 4px 20px 0 rgba(0,0,0,0.1)',
//         },
//       },
//     },
//     MuiButton: {
//       styleOverrides: {
//         root: {
//           borderRadius: 8,
//           textTransform: 'none',
//           padding: '10px 24px',
//         },
//       },
//     },
//     MuiTableCell: {
//       styleOverrides: {
//         head: {
//           backgroundColor: '#f0f5ff',
//           fontWeight: 'bold',
//         },
//       },
//     },
//   },
// });

// const RateUploadScreen = () => {
//   const [file, setFile] = useState(null);
//   const [fileName, setFileName] = useState('');
//   const [isLoading, setIsLoading] = useState(false);
//   const [isUploading, setIsUploading] = useState(false);
//   const [excelData, setExcelData] = useState([]);
//   const [notification, setNotification] = useState({ open: false, message: '', severity: 'info' });
//   const [validatedData, setValidatedData] = useState(null);
//   const [invalidRows, setInvalidRows] = useState([]);
//   const [duplicateRows, setDuplicateRows] = useState([]);
//   const [rateErrorRows, setRateErrorRows] = useState([]);
//   const token = localStorage.getItem('AuthorizationToken');
//   const [isMOCRateRequired, setIsMOCRateRequired] = useState(false);
//   const [isVANRateRequired, setIsVANRateRequired] = useState(false);
//   const fileInputRef = useRef(null);
//   const [invalidRowsList, setInvalidRowsList] = useState([]); // Add this new state
//   const [isMRPRateRequired, setIsMRPRateRequired] = useState(true); // Default to true unlike the others
//   const [apiErrors, setApiErrors] = useState([]);
//   const [showApiErrorsDialog, setShowApiErrorsDialog] = useState(false);






//   const handleFileChange = (event) => {
//     const selectedFile = event.target.files[0];
//     if (selectedFile) {
//       setFile(selectedFile);
//       setFileName(selectedFile.name);
//       setValidatedData(null);
//       setInvalidRows([]);
//       setDuplicateRows([]);
//       setRateErrorRows([]);
//       setNotification({
//         open: true,
//         message: `File "${selectedFile.name}" selected successfully`,
//         severity: 'success'
//       });
//     }
//   };




//   const handleCheckboxChange = (type) => {
//     if (type === 'MOC') {
//       setIsMOCRateRequired(!isMOCRateRequired);
//     } else if (type === 'VAN') {
//       setIsVANRateRequired(!isVANRateRequired);
//     } else if (type === 'MRP') {
//       setIsMRPRateRequired(!isMRPRateRequired);
//     }
//     // Clear existing validation when checkbox state changes
//     setValidatedData(null);
//     setInvalidRows([]);
//     setDuplicateRows([]);
//     setRateErrorRows([]);
//   };



//   const handleImport = () => {
//     if (!file) {
//       setNotification({
//         open: true,
//         message: 'Please select a file first',
//         severity: 'warning'
//       });
//       return;
//     }

//     setIsLoading(true);
//     setInvalidRows([]);
//     setDuplicateRows([]);
//     setRateErrorRows([]);
//     console.log('Import button pressed. File:', file.name);

//     // Read the Excel file
//     const reader = new FileReader();
//     reader.onload = (e) => {
//       try {
//         const data = new Uint8Array(e.target.result);
//         const workbook = XLSX.read(data, { type: 'array' });
//         const firstSheetName = workbook.SheetNames[0];
//         const worksheet = workbook.Sheets[firstSheetName];

//         // Convert Excel data to JSON
//         const jsonData = XLSX.utils.sheet_to_json(worksheet);

//         // Check if data contains required columns
//         // Modify the handleImport function validation section
//         if (jsonData.length > 0) {
//           const headers = Object.keys(jsonData[0]);
//           const requiredColumns = ['AreaId', 'ItemCode', 'MRPRate'];

//           // Add conditional required columns based on checkboxes
//           if (isMOCRateRequired) requiredColumns.push('MOCRate');
//           if (isVANRateRequired) requiredColumns.push('VANRate');

//           const missingColumns = requiredColumns.filter(col =>
//             !headers.some(header => header.toLowerCase() === col.toLowerCase())
//           );

//           if (missingColumns.length > 0) {
//             setNotification({
//               open: true,
//               message: `Missing required columns: ${missingColumns.join(', ')}`,
//               severity: 'error'
//             });
//             setIsLoading(false);
//             return;
//           }

//           // Check for prohibited columns based on selection
//           if ((isMOCRateRequired && !isVANRateRequired && headers.some(h => h.toLowerCase() === 'vanrate')) ||
//             (isVANRateRequired && !isMOCRateRequired && headers.some(h => h.toLowerCase() === 'mocrate'))) {
//             setNotification({
//               open: true,
//               message: isMOCRateRequired && !isVANRateRequired ?
//                 'VANRate column is not allowed when only MOCRate is selected' :
//                 'MOCRate column is not allowed when only VANRate is selected',
//               severity: 'error'
//             });
//             setIsLoading(false);
//             return;
//           }

//           if (!isMOCRateRequired && !isVANRateRequired && !isMRPRateRequired) {
//             setNotification({
//               open: true,
//               message: 'Please select at least one rate type',
//               severity: 'error'
//             });
//             setIsLoading(false);
//             return;
//           }

//           // Track invalid rows and duplicate AreaId+ItemCode combinations
//           const invalidRowsList = [];
//           const rateErrorRowsList = [];
//           const areaItemCombinations = new Map();
//           const duplicateRowsList = [];


//           // Validate data types and business rules
//           // Replace the part where you validate data types and business rules
//           // Look for the section around line 228 (in the handleImport function)
//           // Replace the validation and error collection logic with this:

//           // Validate data types and business rules
//           const validData = jsonData.map((row, index) => {
//             // Define specific error types for more detailed reporting
//             const errors = [];

//             // Check for empty values
//             // Check for empty values
//             if (!row.AreaId || !row.ItemCode) {
//               errors.push('missing_identifier');
//             }

//             if ((isMOCRateRequired && (row.MOCRate === undefined || row.MOCRate === null || row.MOCRate === '')) ||
//               (isVANRateRequired && (row.VANRate === undefined || row.VANRate === null || row.VANRate === '')) ||
//               (isMRPRateRequired && (row.MRPRate === undefined || row.MRPRate === null || row.MRPRate === ''))) {
//               errors.push('missing_rate');
//             }

//             // Check for negative values
//             const vanRate = Number(row.VANRate);
//             const mocRate = Number(row.MOCRate);
//             const mrpRate = Number(row.MRPRate);

//             if ((isVANRateRequired && vanRate < 0) ||
//               (isMOCRateRequired && mocRate < 0) ||
//               (isMRPRateRequired && mrpRate < 0)) {
//               errors.push('negative_rate');
//             }

//             // Check for more than two decimal places
//             if ((isVANRateRequired && !Number.isInteger(vanRate * 100) && !isNaN(vanRate)) ||
//               (isMOCRateRequired && !Number.isInteger(mocRate * 100) && !isNaN(mocRate)) ||
//               (isMRPRateRequired && !Number.isInteger(mrpRate * 100) && !isNaN(mrpRate))) {
//               errors.push('invalid_decimals');
//             }

//             // Check for double decimal points
//             if ((isVANRateRequired && String(row.VANRate).split('.').length > 2) ||
//               (isMOCRateRequired && String(row.MOCRate).split('.').length > 2) ||
//               (isMRPRateRequired && String(row.MRPRate).split('.').length > 2)) {
//               errors.push('double_decimal');
//             }

//             // Check for non-numeric rates
//             if ((isVANRateRequired && isNaN(vanRate)) ||
//               (isMOCRateRequired && isNaN(mocRate)) ||
//               (isMRPRateRequired && isNaN(mrpRate))) {
//               errors.push('non_numeric_rate');
//             }

//             // Store error information for this row
//             if (errors.length > 0) {
//               invalidRowsList.push({
//                 rowNumber: index + 1,
//                 errors: errors
//               });
//             }

//             // Check for rate errors (VANRate or MOCRate > MRPRate)
//             const hasRateError = (isVANRateRequired && vanRate > mrpRate) || (isMOCRateRequired && mocRate > mrpRate);
//             if (hasRateError) {
//               rateErrorRowsList.push(index + 1);
//             }

//             // Check for duplicate AreaId + ItemCode combinations
//             const key = `${row.AreaId}-${row.ItemCode}`;
//             if (areaItemCombinations.has(key)) {
//               duplicateRowsList.push(index + 1);
//             } else {
//               areaItemCombinations.set(key, index + 1);
//             }

//             return {
//               AreaID: String(row.AreaId),
//               ItemCode: row.ItemCode,
//               VANRate: vanRate,
//               MOCRate: mocRate,
//               MRPRate: mrpRate,
//               DML: "I" // Default to Insert
//             };
//           });

//           // Then modify how invalidRows is set up - we need to extract just the row numbers
//           setInvalidRows(invalidRowsList.map(item => item.rowNumber));
//           setRateErrorRows(rateErrorRowsList);
//           setDuplicateRows(duplicateRowsList);

//           // Now update the error message section
//           const allErrorsRows = [...new Set([...invalidRowsList.map(item => item.rowNumber), ...rateErrorRowsList, ...duplicateRowsList])];

//           if (allErrorsRows.length > 0) {
//             let errorMessage = '';

//             if (invalidRowsList.length > 0) {
//               // Group rows by error type for more specific feedback
//               const errorsByType = {
//                 missing_identifier: [],
//                 missing_rate: [],
//                 negative_rate: [],
//                 invalid_decimals: [],
//                 special_chars: [],
//                 double_decimal: [],
//                 non_numeric_rate: []
//               };

//               invalidRowsList.forEach(item => {
//                 item.errors.forEach(errorType => {
//                   errorsByType[errorType].push(item.rowNumber);
//                 });
//               });

//               errorMessage += 'Data validation errors found: ';

//               if (errorsByType.missing_identifier.length > 0) {
//                 errorMessage += `Missing AreaId or ItemCode in rows: ${errorsByType.missing_identifier.join(', ')}. `;
//               }
//               if (errorsByType.missing_rate.length > 0) {
//                 errorMessage += `Missing rate values in rows: ${errorsByType.missing_rate.join(', ')}. `;
//               }
//               if (errorsByType.negative_rate.length > 0) {
//                 errorMessage += `Negative rate values in rows: ${errorsByType.negative_rate.join(', ')}. `;
//               }
//               if (errorsByType.invalid_decimals.length > 0) {
//                 errorMessage += `More than 2 decimal places in rows: ${errorsByType.invalid_decimals.join(', ')}. `;
//               }
//               if (errorsByType.special_chars.length > 0) {
//                 errorMessage += `Special characters in AreaId or ItemCode in rows: ${errorsByType.special_chars.join(', ')}. `;
//               }
//               if (errorsByType.double_decimal.length > 0) {
//                 errorMessage += `Double decimal points in rows: ${errorsByType.double_decimal.join(', ')}. `;
//               }
//               if (errorsByType.non_numeric_rate.length > 0) {
//                 errorMessage += `Non-numeric rate values in rows: ${errorsByType.non_numeric_rate.join(', ')}. `;
//               }
//             }

//             if (rateErrorRowsList.length > 0) {
//               errorMessage += `Rate errors in rows: ${rateErrorRowsList.join(', ')}. VANRate and MOCRate cannot be greater than MRPRate. `;
//             }

//             if (duplicateRowsList.length > 0) {
//               errorMessage += `Duplicate AreaId+ItemCode combinations in rows: ${duplicateRowsList.join(', ')}. `;
//             }

//             setNotification({
//               open: true,
//               message: errorMessage,
//               severity: 'error'
//             });

//             // Rest of the code stays the same...

//             // Still set data for display but don't validate for upload
//             setExcelData(jsonData);
//             if (allErrorsRows.length === jsonData.length) {
//               setValidatedData(null); // No valid data to upload
//             } else {
//               // Filter out invalid entries for upload
//               const validatedEntries = validData.filter((_, index) =>
//                 !allErrorsRows.includes(index + 1)
//               );
//               setValidatedData(validatedEntries);
//             }
//           } else {
//             setExcelData(jsonData);
//             setValidatedData(validData);
//             setNotification({
//               open: true,
//               message: `Successfully imported ${jsonData.length} items. Ready to upload.`,
//               severity: 'success'
//             });
//           }
//         } else {
//           setNotification({
//             open: true,
//             message: 'No data found in the Excel file',
//             severity: 'error'
//           });
//         }
//       } catch (error) {
//         console.error('Error parsing Excel file:', error);
//         setNotification({
//           open: true,
//           message: 'Error parsing the Excel file. Please make sure it is a valid Excel file.',
//           severity: 'error'
//         });
//       }

//       setIsLoading(false);
//     };

//     reader.onerror = () => {
//       setIsLoading(false);
//       setNotification({
//         open: true,
//         message: 'Error reading file',
//         severity: 'error'
//       });
//     };

//     reader.readAsArrayBuffer(file);
//   };

//   const handleUpload = async () => {
//     // Check for validation errors before proceeding
//     if (!validatedData || validatedData.length === 0) {
//       setNotification({
//         open: true,
//         message: 'Please import and validate data before uploading',
//         severity: 'warning'
//       });
//       return;
//     }

//     // Check if there are any validation errors
//     if (invalidRows.length > 0 || duplicateRows.length > 0 || rateErrorRows.length > 0) {
//       setNotification({
//         open: true,
//         message: 'Please fix all validation errors before uploading',
//         severity: 'error'
//       });
//       return;
//     }

//     setIsUploading(true);

//     try {
//       const uniqueId = ''; // Generate a unique ID based on timestamp
//       const currentDate = new Date().toISOString(); // Get current date in ISO format
//       const userId = localStorage.getItem('userId') || 'UnknownUser'; // Get userId from localStorage

//       const payload = {
//         UniqueId: uniqueId,
//         DateOfEntry: currentDate,
//         CreatedUserCode: userId, // Use dynamic user ID
//         details: validatedData
//       };

//       console.log('Sending payload:', payload);

//       const response = await fetch('https://retailuat.abisibg.com/api/v1/insertchannelsalesrate', {
//         method: 'POST',
//         headers: {
//           'Authorization': `Bearer ${token}`,
//           'Content-Type': 'application/json',
//         },
//         body: JSON.stringify(payload)
//       });

//       if (!response.ok) {
//         throw new Error(`API response error: ${response.status} ${response.statusText}`);
//       }

//       const result = await response.json();

//       // Check if the API response contains error descriptions (using errdescr instead of rrdescr)
//       if (result.errdescr && Array.isArray(result.errdescr) && result.errdescr.length > 0) {
//         // Set state to store the API errors
//         setApiErrors(result.errdescr);

//         // Create an error message showing the API errors
//         const errorCount = result.errdescr.length;
//         const itemsWithErrors = result.errdescr.map(item => `${item.AreaID}-${item.itemCode}`).join(', ');
//         const errorMessage = `Upload completed with ${errorCount} errors. Items not found: ${itemsWithErrors}`;

//         setNotification({
//           open: true,
//           message: errorMessage,
//           severity: 'warning'
//         });

//         // Show the API errors in the UI
//         setShowApiErrorsDialog(true);
//       }

//       // Check for success status (this happens regardless of whether there are errors)
//       if (result.res && Array.isArray(result.res) && result.res.length > 0 && result.res[0].Descr === "Success") {
//         setNotification({
//           open: true,
//           message: `Data uploaded successfully! Some items may have validation errors.`,
//           severity: 'success'
//         });

//         // Only clear the file if there are no errors
//         if (!result.errdescr || !Array.isArray(result.errdescr) || result.errdescr.length === 0) {
//           clearFile();
//         }
//       }

//     } catch (error) {
//       console.error('Error uploading data:', error);
//       setNotification({
//         open: true,
//         message: `Error uploading data: ${error.message}`,
//         severity: 'error'
//       });
//     } finally {
//       setIsUploading(false);
//     }
//   };



//   const ApiErrorsDialog = () => {
//     return (
//       <Dialog
//         open={showApiErrorsDialog}
//         onClose={() => setShowApiErrorsDialog(false)}
//         maxWidth="md"
//         fullWidth
//       >
//         <DialogTitle>
//           <Box display="flex" alignItems="center">
//             <ErrorOutlineIcon color="error" sx={{ mr: 1 }} />
//             API Validation Errors
//           </Box>
//         </DialogTitle>
//         <DialogContent>
//           <TableContainer>
//             <Table>
//               <TableHead>
//                 <TableRow>
//                   <TableCell>Area ID</TableCell>
//                   <TableCell>Item Code</TableCell>
//                   <TableCell>Error Description</TableCell>
//                 </TableRow>
//               </TableHead>
//               <TableBody>
//                 {apiErrors.map((error, index) => (
//                   <TableRow key={index}>
//                     <TableCell>{error.AreaID}</TableCell>
//                     <TableCell>{error.itemCode}</TableCell>
//                     <TableCell>{error.ErrorDescr}</TableCell>
//                   </TableRow>
//                 ))}
//               </TableBody>
//             </Table>
//           </TableContainer>
//         </DialogContent>
//         <DialogActions>
//           <Button
//             onClick={() => setShowApiErrorsDialog(false)}
//             color="primary"
//             variant="contained"
//           >
//             Close
//           </Button>
//         </DialogActions>
//       </Dialog>
//     );
//   };


//   const clearFile = () => {
//     setFile(null);
//     setFileName('');
//     setExcelData([]);
//     setValidatedData(null);
//     setInvalidRows([]);
//     setDuplicateRows([]);
//     setRateErrorRows([]);

//     // Reset the file input value if the ref is available
//     if (fileInputRef.current) {
//       fileInputRef.current.value = '';
//     }
//   };

//   const handleCloseNotification = () => {
//     setNotification({ ...notification, open: false });
//   };

//   // Helper function to determine row styling based on validation errors
//   const getRowStyle = (index) => {
//     const rowNum = index + 1;
//     const isInvalidFormat = invalidRows.includes(rowNum);
//     const isDuplicate = duplicateRows.includes(rowNum);
//     const hasRateError = rateErrorRows.includes(rowNum);

//     if (isInvalidFormat || isDuplicate || hasRateError) {
//       return {
//         backgroundColor: '#ffebee',
//         '&:hover': { backgroundColor: '#ffcdd2' }
//       };
//     }

//     return {
//       '&:nth-of-type(odd)': { backgroundColor: '#fafafa' },
//       '&:hover': { backgroundColor: '#f5f5f5' }
//     };
//   };

//   // Helper function to get error tooltip message for a row
//   // Update the getRowErrorMessage function
//   const getRowErrorMessage = (index) => {
//     const rowNum = index + 1;
//     const errors = [];

//     // Find specific error types for this row
//     const invalidRow = invalidRowsList.find(item => item.rowNumber === rowNum);
//     if (invalidRow) {
//       if (invalidRow.errors.includes('missing_identifier')) errors.push("Missing AreaId or ItemCode");
//       if (invalidRow.errors.includes('missing_rate')) errors.push("Missing rate value");
//       if (invalidRow.errors.includes('negative_rate')) errors.push("Negative rate value");
//       if (invalidRow.errors.includes('invalid_decimals')) errors.push("More than 2 decimal places");
//       if (invalidRow.errors.includes('special_chars')) errors.push("Special characters in AreaId/ItemCode");
//       if (invalidRow.errors.includes('double_decimal')) errors.push("Double decimal point");
//       if (invalidRow.errors.includes('non_numeric_rate')) errors.push("Non-numeric rate value");
//     }

//     if (duplicateRows.includes(rowNum)) {
//       errors.push("Duplicate AreaId+ItemCode combination");
//     }

//     if (rateErrorRows.includes(rowNum)) {
//       errors.push("VANRate or MOCRate greater than MRPRate");
//     }

//     return errors.join(", ");
//   };

//   return (
//     <>
//       <Header />
//       <ThemeProvider theme={theme}>
//         <Box sx={{
//           minHeight: '100vh',
//           backgroundColor: 'background.default',
//           pt: 4,
//           pb: 6
//         }}>
//           <Container maxWidth="lg">
//             <Grow in={true} timeout={800}>
//               <Paper elevation={3} sx={{ p: 4, borderRadius: 3, overflow: 'hidden' }}>
//                 <Box sx={{
//                   display: 'flex',
//                   alignItems: 'center',
//                   mb: 3,
//                   borderBottom: '1px solid #e0e0e0',
//                   pb: 2
//                 }}>
//                   <TableChartIcon sx={{ fontSize: 32, mr: 2, color: 'primary.main' }} />
//                   <Typography variant="h4" component="h1">
//                     Rate Upload
//                   </Typography>
//                   <Tooltip title="Upload Excel files with AreaId, ItemCode, VANRate, MOCRate, and MRPRate columns">
//                     <IconButton sx={{ ml: 2 }}>
//                       <InfoIcon color="action" />
//                     </IconButton>
//                   </Tooltip>
//                 </Box>

//                 <Box sx={{
//                   backgroundColor: '#f8faff',
//                   p: 3,
//                   borderRadius: 2,
//                   mb: 4,
//                   border: '1px solid #e3f2fd'
//                 }}>
//                   <Typography variant="subtitle1" sx={{ mb: 2, fontWeight: 500 }}>
//                     Upload Excel Data
//                   </Typography>



//                   <Grid container spacing={2} sx={{ mt: 2 }}>
//                     <Grid item xs={12}>
//                       <Typography variant="subtitle2" sx={{ mb: 1 }}>
//                         Select Required Rate Types:
//                       </Typography>
//                     </Grid>
//                     <Grid item xs={6} md={3}>
//                       <FormControlLabel
//                         control={
//                           <Checkbox
//                             checked={isMOCRateRequired}
//                             onChange={() => handleCheckboxChange('MOC')}
//                             color="primary"
//                           />
//                         }
//                         label="MOCRate"
//                       />
//                     </Grid>
//                     <Grid item xs={6} md={3}>
//                       <FormControlLabel
//                         control={
//                           <Checkbox
//                             checked={isVANRateRequired}
//                             onChange={() => handleCheckboxChange('VAN')}
//                             color="primary"
//                           />
//                         }
//                         label="VANRate"
//                       />
//                     </Grid>
//                     <Grid item xs={6} md={3}>
//                       <FormControlLabel
//                         control={
//                           <Checkbox
//                             checked={isMRPRateRequired}
//                             onChange={() => handleCheckboxChange('MRP')}
//                             color="primary"
//                           />
//                         }
//                         label="MRPRate"
//                       />
//                     </Grid>
//                     <Grid item xs={12}>
//                       <Alert severity="info" sx={{ mt: 1 }}>
//                         {!isMOCRateRequired && !isVANRateRequired && !isMRPRateRequired ?
//                           "Please select at least one rate type to enable upload" :
//                           `Selected rate types: ${[
//                             isMOCRateRequired ? "MOCRate" : "",
//                             isVANRateRequired ? "VANRate" : "",
//                             isMRPRateRequired ? "MRPRate" : ""
//                           ].filter(Boolean).join(", ")}`
//                         }
//                       </Alert>
//                     </Grid>
//                   </Grid>


//                   <Grid container spacing={3} alignItems="center">
//                     <Grid item xs={12} md={4}>
//                       <Box sx={{ display: 'flex', alignItems: 'center' }}>
//                         <Button
//                           variant="contained"
//                           component="label"
//                           startIcon={<FileOpenIcon />}
//                           sx={{
//                             mr: 2,
//                             background: 'linear-gradient(45deg, #2196F3 30%, #21CBF3 90%)',
//                             boxShadow: '0 3px 5px 2px rgba(33, 203, 243, .3)',
//                             color: 'white',
//                             '&:hover': {
//                               background: 'linear-gradient(45deg, #1976d2 30%, #21a6f3 90%)',
//                             }
//                           }}
//                         >
//                           Choose File
//                           <input
//                             ref={fileInputRef}
//                             type="file"
//                             accept=".xlsx, .xls"
//                             hidden
//                             onChange={handleFileChange}
//                           />
//                         </Button>

//                         {fileName && (
//                           <Fade in={!!fileName}>
//                             <Box sx={{ display: 'flex', alignItems: 'center' }}>
//                               <Chip
//                                 label={fileName}
//                                 variant="outlined"
//                                 color="primary"
//                                 onDelete={clearFile}
//                                 deleteIcon={<DeleteIcon />}
//                                 sx={{ maxWidth: '250px' }}
//                               />
//                             </Box>
//                           </Fade>
//                         )}
//                       </Box>
//                     </Grid>

//                     <Grid item xs={12} md={4}>
//                       <Button
//                         variant="contained"
//                         color="primary"
//                         onClick={handleImport}
//                         disabled={!file || isLoading}
//                         fullWidth
//                         sx={{
//                           py: 1.5,
//                           background: file && !isLoading ? 'linear-gradient(45deg, #4CAF50 30%, #8BC34A 90%)' : '',
//                           boxShadow: file && !isLoading ? '0 3px 5px 2px rgba(76, 175, 80, .3)' : '',
//                           '&:hover': {
//                             background: file && !isLoading ? 'linear-gradient(45deg, #43A047 30%, #7CB342 90%)' : ''
//                           }
//                         }}
//                       >
//                         {isLoading ? (
//                           <Box sx={{ display: 'flex', alignItems: 'center' }}>
//                             <CircularProgress size={24} color="inherit" sx={{ mr: 1 }} />
//                             Processing...
//                           </Box>
//                         ) : (
//                           <>
//                             <CloudUploadIcon sx={{ mr: 1 }} /> Validate Data
//                           </>
//                         )}
//                       </Button>
//                     </Grid>

//                     <Grid item xs={12} md={4}>
//                       <Button
//                         variant="contained"
//                         color="secondary"
//                         onClick={handleUpload}
//                         disabled={
//                           !validatedData ||
//                           isUploading ||
//                           (!isMOCRateRequired && !isVANRateRequired && !isMRPRateRequired) ||
//                           invalidRows.length > 0 ||
//                           duplicateRows.length > 0 ||
//                           rateErrorRows.length > 0
//                         }
//                         fullWidth
//                         sx={{
//                           py: 1.5,
//                           background: validatedData && !isUploading && invalidRows.length === 0 && duplicateRows.length === 0 && rateErrorRows.length === 0 ?
//                             'linear-gradient(45deg, #FF5722 30%, #FF9800 90%)' : '',
//                           boxShadow: validatedData && !isUploading && invalidRows.length === 0 && duplicateRows.length === 0 && rateErrorRows.length === 0 ?
//                             '0 3px 5px 2px rgba(255, 87, 34, .3)' : '',
//                           '&:hover': {
//                             background: validatedData && !isUploading && invalidRows.length === 0 && duplicateRows.length === 0 && rateErrorRows.length === 0 ?
//                               'linear-gradient(45deg, #E64A19 30%, #F57C00 90%)' : ''
//                           }
//                         }}
//                       >
//                         {isUploading ? (
//                           <Box sx={{ display: 'flex', alignItems: 'center' }}>
//                             <CircularProgress size={24} color="inherit" sx={{ mr: 1 }} />
//                             Uploading...
//                           </Box>
//                         ) : (
//                           <>
//                             <SendIcon sx={{ mr: 1 }} /> Submit
//                           </>
//                         )}
//                       </Button>
//                     </Grid>
//                   </Grid>
//                 </Box>

//                 {(invalidRows.length > 0 || duplicateRows.length > 0 || rateErrorRows.length > 0) && (
//                   <Alert
//                     severity="warning"
//                     sx={{ mb: 3 }}
//                     action={
//                       <Tooltip title="Rows with errors are highlighted in red">
//                         <IconButton size="small">
//                           <InfoIcon />
//                         </IconButton>
//                       </Tooltip>
//                     }
//                   >
//                     <Typography variant="subtitle2">Validation Errors Found:</Typography>
//                     <Box component="ul" sx={{ mt: 1, pl: 2 }}>
//                       {invalidRowsList && invalidRowsList.length > 0 ? (
//                         <li>
//                           Data validation errors:
//                           <Box component="ul" sx={{ pl: 2 }}>
//                             {invalidRowsList.map((item, idx) => (
//                               <li key={idx}>
//                                 Row {item.rowNumber}: {item.errors && Array.isArray(item.errors) ? item.errors.map(err => {
//                                   switch (err) {
//                                     case 'missing_identifier': return 'Missing AreaId or ItemCode';
//                                     case 'missing_rate': return 'Missing rate value';
//                                     case 'negative_rate': return 'Negative rate value';
//                                     case 'invalid_decimals': return 'More than 2 decimal places';
//                                     case 'special_chars': return 'Special characters in AreaId/ItemCode';
//                                     case 'double_decimal': return 'Double decimal point';
//                                     case 'non_numeric_rate': return 'Non-numeric rate value';
//                                     default: return err;
//                                   }
//                                 }).join(', ') : 'Unknown error'}
//                               </li>
//                             ))}
//                           </Box>
//                         </li>
//                       ) : (
//                         invalidRows.length > 0 && <li>Invalid data format in rows: {invalidRows.join(', ')}</li>
//                       )}
//                       {rateErrorRows.length > 0 && (
//                         <li>
//                           Rate errors (VANRate or MOCRate greater than MRPRate) in rows: {rateErrorRows.join(', ')}
//                         </li>
//                       )}
//                       {duplicateRows.length > 0 && (
//                         <li>
//                           Duplicate AreaId+ItemCode combinations in rows: {duplicateRows.join(', ')}
//                         </li>
//                       )}
//                     </Box>
//                   </Alert>
//                 )}

//                 <Divider sx={{ my: 3 }} />

//                 <Box sx={{ mt: 2 }}>
//                   <Typography variant="h6" sx={{ mb: 2, display: 'flex', alignItems: 'center' }}>
//                     <TableChartIcon sx={{ mr: 1, fontSize: 20 }} /> Data Preview
//                   </Typography>

//                   {excelData.length > 0 ? (
//                     <Fade in={excelData.length > 0} timeout={800}>
//                       <TableContainer component={Paper} sx={{
//                         mt: 2,
//                         boxShadow: '0 2px 10px rgba(0,0,0,0.08)',
//                         borderRadius: 2,
//                         maxHeight: 400,
//                         overflow: 'auto'
//                       }}>
//                         <Table aria-label="excel data table" stickyHeader>
//                           <TableHead>
//                             <TableRow>
//                               <TableCell sx={{ fontWeight: 'bold' }}>Row</TableCell>
//                               <TableCell sx={{ fontWeight: 'bold' }}>Area ID</TableCell>
//                               <TableCell sx={{ fontWeight: 'bold' }}>Item Code</TableCell>
//                               {isVANRateRequired && (
//                                 <TableCell align="right" sx={{ fontWeight: 'bold' }}>VAN Rate</TableCell>
//                               )}
//                               {isMOCRateRequired && (
//                                 <TableCell align="right" sx={{ fontWeight: 'bold' }}>MOC Rate</TableCell>
//                               )}
//                               {isMRPRateRequired && (
//                                 <TableCell align="right" sx={{ fontWeight: 'bold' }}>MRP Rate</TableCell>
//                               )}
//                               <TableCell align="center" sx={{ fontWeight: 'bold' }}>Status</TableCell>
//                             </TableRow>
//                           </TableHead>

//                           <TableBody>
//                             {excelData.map((row, index) => {
//                               const rowNum = index + 1;
//                               const hasError = invalidRows.includes(rowNum) ||
//                                 duplicateRows.includes(rowNum) ||
//                                 rateErrorRows.includes(rowNum);
//                               const errorMsg = getRowErrorMessage(index);

//                               return (
//                                 <TableRow
//                                   key={index}
//                                   sx={getRowStyle(index)}
//                                 >
//                                   <TableCell>{rowNum}</TableCell>
//                                   <TableCell>{row.AreaId}</TableCell>
//                                   <TableCell>{row.ItemCode}</TableCell>
//                                   {isVANRateRequired && (
//                                     <TableCell
//                                       align="right"
//                                       sx={rateErrorRows.includes(rowNum) && row.VANRate > row.MRPRate ? { color: 'error.main' } : {}}
//                                     >
//                                       {typeof row.VANRate === 'number'
//                                         ? `${row.VANRate.toFixed(2)}`
//                                         : row.VANRate}
//                                     </TableCell>
//                                   )}
//                                   {isMOCRateRequired && (
//                                     <TableCell
//                                       align="right"
//                                       sx={rateErrorRows.includes(rowNum) && row.MOCRate > row.MRPRate ? { color: 'error.main' } : {}}
//                                     >
//                                       {typeof row.MOCRate === 'number'
//                                         ? `${row.MOCRate.toFixed(2)}`
//                                         : row.MOCRate}
//                                     </TableCell>
//                                   )}
//                                   {isMRPRateRequired && (
//                                     <TableCell align="right">
//                                       {typeof row.MRPRate === 'number'
//                                         ? `${row.MRPRate.toFixed(2)}`
//                                         : row.MRPRate}
//                                     </TableCell>
//                                   )}
//                                   <TableCell align="center">
//                                     {hasError ? (
//                                       <Tooltip title={errorMsg}>
//                                         <ErrorOutlineIcon color="error" />
//                                       </Tooltip>
//                                     ) : (
//                                       <Chip
//                                         label="Valid"
//                                         size="small"
//                                         color="success"
//                                         variant="outlined"
//                                         sx={{ fontSize: '0.7rem' }}
//                                       />
//                                     )}
//                                   </TableCell>
//                                 </TableRow>
//                               );
//                             })}
//                           </TableBody>
//                         </Table>
//                       </TableContainer>
//                     </Fade>
//                   ) : (
//                     <Fade in={!excelData.length} timeout={800}>
//                       <Box
//                         sx={{
//                           p: 5,
//                           textAlign: 'center',
//                           bgcolor: '#fafafa',
//                           borderRadius: 2,
//                           border: '2px dashed #e0e0e0',
//                           display: 'flex',
//                           flexDirection: 'column',
//                           alignItems: 'center',
//                           justifyContent: 'center'
//                         }}
//                       >
//                         <CloudUploadIcon sx={{ fontSize: 64, color: '#bdbdbd', mb: 2 }} />
//                         <Typography variant="h6" color="text.secondary" sx={{ mb: 1 }}>
//                           No Data Available
//                         </Typography>
//                         <Typography variant="body2" color="text.secondary">
//                           Upload an Excel file to view your data here
//                         </Typography>
//                       </Box>
//                     </Fade>
//                   )}
//                 </Box>

//                 {validatedData && validatedData.length > 0 && (
//                   <Box sx={{ mt: 3, p: 2, bgcolor: '#e8f5e9', borderRadius: 2, border: '1px solid #c8e6c9' }}>
//                     <Typography variant="subtitle1" sx={{ color: '#2e7d32', fontWeight: 500, display: 'flex', alignItems: 'center' }}>
//                       <InfoIcon sx={{ mr: 1, fontSize: 20 }} />
//                       Data validated successfully. {validatedData.length} valid records ready to upload.
//                       {invalidRows.length > 0 || duplicateRows.length > 0 || rateErrorRows.length > 0 ?
//                         ` (${invalidRows.length + duplicateRows.length + rateErrorRows.length} invalid records will be skipped)` :
//                         ''}
//                     </Typography>
//                   </Box>
//                 )}

//                 {apiErrors.length > 0 && (
//                   <Box sx={{ mt: 3, p: 2, bgcolor: '#fff3e0', borderRadius: 2, border: '1px solid #ffe0b2' }}>
//                     <Typography variant="subtitle1" sx={{ color: '#e65100', fontWeight: 500, display: 'flex', alignItems: 'center' }}>
//                       <ErrorOutlineIcon sx={{ mr: 1, fontSize: 20 }} />
//                       {apiErrors.length} items failed validation during upload.
//                       <Button
//                         color="warning"
//                         variant="outlined"
//                         size="small"
//                         onClick={() => setShowApiErrorsDialog(true)}
//                         sx={{ ml: 2 }}
//                       >
//                         View Errors
//                       </Button>
//                     </Typography>
//                   </Box>
//                 )}
//               </Paper>
//             </Grow>

//             <Snackbar
//               open={notification.open}
//               autoHideDuration={6000}
//               onClose={handleCloseNotification}
//               anchorOrigin={{ vertical: 'bottom', horizontal: 'right' }}
//             >
//               <Alert
//                 onClose={handleCloseNotification}
//                 severity={notification.severity}
//                 variant="filled"
//                 sx={{ width: '100%' }}
//               >
//                 {notification.message}
//               </Alert>
//             </Snackbar>
//           </Container>
//         </Box>
//         <ApiErrorsDialog />
//       </ThemeProvider>
//     </>
//   );
// };

// export default RateUploadScreen;









































import React, { useState, useRef } from 'react';
import {
  Button,
  Box,
  Typography,
  Paper,
  Table,
  TableBody,
  TableCell,
  TableContainer,
  TableHead,
  TableRow,
  Container,
  Grid,
  CircularProgress,
  Chip,
  Divider,
  Fade,
  Grow,
  Tooltip,
  IconButton,
  Alert,
  Snackbar
} from '@mui/material';
import {
  Dialog,
  DialogActions,
  DialogContent,
  DialogTitle
} from '@mui/material';
import CloudUploadIcon from '@mui/icons-material/CloudUpload';
import DeleteIcon from '@mui/icons-material/Delete';
import FileOpenIcon from '@mui/icons-material/FileOpen';
import InfoIcon from '@mui/icons-material/Info';
import TableChartIcon from '@mui/icons-material/TableChart';
import SendIcon from '@mui/icons-material/Send';
import ErrorOutlineIcon from '@mui/icons-material/ErrorOutline';
import * as XLSX from 'xlsx';
import { createTheme, ThemeProvider } from '@mui/material/styles';
import { FormControlLabel, Checkbox } from '@mui/material';
import Header from '../Header';
import { local_signage } from '../Const';


const theme = createTheme({
  palette: {
    primary: {
      main: '#1976d2',
    },
    secondary: {
      main: '#f50057',
    },
    background: {
      default: '#f5f7fa',
    },
  },
  typography: {
    h4: {
      fontWeight: 600,
    },
    button: {
      fontWeight: 500,
    },
  },
  components: {
    MuiPaper: {
      styleOverrides: {
        root: {
          borderRadius: 12,
          boxShadow: '0 4px 20px 0 rgba(0,0,0,0.1)',
        },
      },
    },
    MuiButton: {
      styleOverrides: {
        root: {
          borderRadius: 8,
          textTransform: 'none',
          padding: '10px 24px',
        },
      },
    },
    MuiTableCell: {
      styleOverrides: {
        head: {
          backgroundColor: '#f0f5ff',
          fontWeight: 'bold',
        },
      },
    },
  },
});

export const RateUpload = () => {
  const [file, setFile] = useState(null);
  const [fileName, setFileName] = useState('');
  const [isLoading, setIsLoading] = useState(false);
  const [isUploading, setIsUploading] = useState(false);
  const [excelData, setExcelData] = useState([]);
  const [notification, setNotification] = useState({ open: false, message: '', severity: 'info' });
  const [validatedData, setValidatedData] = useState(null);
  const [invalidRows, setInvalidRows] = useState([]);
  const [duplicateRows, setDuplicateRows] = useState([]);
  const [rateErrorRows, setRateErrorRows] = useState([]);
  const token = localStorage.getItem('AuthorizationToken');
  const [isMOCRateRequired, setIsMOCRateRequired] = useState(false);
  const [isVANRateRequired, setIsVANRateRequired] = useState(false);
  const fileInputRef = useRef(null);
  const [invalidRowsList, setInvalidRowsList] = useState([]); // Add this new state
  const [isMRPRateRequired, setIsMRPRateRequired] = useState(true); // Default to true unlike the others
  const [apiErrors, setApiErrors] = useState([]);
  const [showApiErrorsDialog, setShowApiErrorsDialog] = useState(false);
  const [showConfirmDialog, setShowConfirmDialog] = useState(false);
  const [excelColumns, setExcelColumns] = useState([]);
  const [pendingExcelData, setPendingExcelData] = useState(null);
  const [pendingWorkbook, setPendingWorkbook] = useState(null);
  





  const handleFileChange = (event) => {
    const selectedFile = event.target.files[0];
    if (selectedFile) {
      setFile(selectedFile);
      setFileName(selectedFile.name);
      setValidatedData(null);
      setInvalidRows([]);
      setDuplicateRows([]);
      setRateErrorRows([]);
      setNotification({
        open: true,
        message: `File "${selectedFile.name}" selected successfully`,
        severity: 'success'
      });
    }
  };




  const handleCheckboxChange = (type) => {
    if (type === 'MOC') {
      setIsMOCRateRequired(!isMOCRateRequired);
    } else if (type === 'VAN') {
      setIsVANRateRequired(!isVANRateRequired);
    } else if (type === 'MRP') {
      setIsMRPRateRequired(!isMRPRateRequired);
    }
    // Clear existing validation when checkbox state changes
    setValidatedData(null);
    setInvalidRows([]);
    setDuplicateRows([]);
    setRateErrorRows([]);
  };



  const handleImport = () => {
    if (!file) {
      setNotification({
        open: true,
        message: 'Please select a file first',
        severity: 'warning'
      });
      return;
    }
  
    setIsLoading(true);
    setInvalidRows([]);
    setDuplicateRows([]);
    setRateErrorRows([]);
    console.log('Import button pressed. File:', file.name);
  
    // Read the Excel file
    const reader = new FileReader();
    reader.onload = (e) => {
      try {
        const data = new Uint8Array(e.target.result);
        const workbook = XLSX.read(data, { type: 'array' });
        const firstSheetName = workbook.SheetNames[0];
        const worksheet = workbook.Sheets[firstSheetName];
  
        // Convert Excel data to JSON
        const jsonData = XLSX.utils.sheet_to_json(worksheet);
  
        // Check if data exists
        if (jsonData.length === 0) {
          setNotification({
            open: true,
            message: 'No data found in the Excel file',
            severity: 'error'
          });
          setIsLoading(false);
          return;
        }
  
        // Extract headers from the first row
        const headers = Object.keys(jsonData[0]);
        setExcelColumns(headers);
  
        // Check for required columns
        const requiredColumns = ['AreaId', 'ItemCode'];
        const missingBasicColumns = requiredColumns.filter(col =>
          !headers.some(header => header.toLowerCase() === col.toLowerCase())
        );
  
        if (missingBasicColumns.length > 0) {
          setNotification({
            open: true,
            message: `Missing required columns: ${missingBasicColumns.join(', ')}`,
            severity: 'error'
          });
          setIsLoading(false);
          return;
        }
  
        // Check for rate selection
        if (!isMOCRateRequired && !isVANRateRequired && !isMRPRateRequired) {
          setNotification({
            open: true,
            message: 'Please select at least one rate type',
            severity: 'error'
          });
          setIsLoading(false);
          return;
        }
  
        // Check for mismatch between selected rate types and Excel columns
        const hasVANRateColumn = headers.some(h => h.toLowerCase() === 'vanrate');
        const hasMOCRateColumn = headers.some(h => h.toLowerCase() === 'mocrate');
        const hasMRPRateColumn = headers.some(h => h.toLowerCase() === 'mrprate');
  
        // Store the Excel data and workbook for further processing
        setPendingExcelData(jsonData);
        setPendingWorkbook(workbook);
  
        // Check for column mismatches
        if ((hasVANRateColumn && !isVANRateRequired) || 
            (hasMOCRateColumn && !isMOCRateRequired) || 
            (hasMRPRateColumn && !isMRPRateRequired)) {
          
          // Show confirmation dialog instead of error
          setShowConfirmDialog(true);
          setIsLoading(false);
          return;
        }
  
        // Check if required rate columns are present
        const missingRateColumns = [];
        if (isMOCRateRequired && !hasMOCRateColumn) missingRateColumns.push('MOCRate');
        if (isVANRateRequired && !hasVANRateColumn) missingRateColumns.push('VANRate');
        if (isMRPRateRequired && !hasMRPRateColumn) missingRateColumns.push('MRPRate');
  
        if (missingRateColumns.length > 0) {
          setNotification({
            open: true,
            message: `Missing required rate columns: ${missingRateColumns.join(', ')}`,
            severity: 'error'
          });
          setIsLoading(false);
          return;
        }
  
        // If we reach here, proceed with validation
        processExcelData(jsonData);
  
      } catch (error) {
        console.error('Error parsing Excel file:', error);
        setNotification({
          open: true,
          message: 'Error parsing the Excel file. Please make sure it is a valid Excel file.',
          severity: 'error'
        });
        setIsLoading(false);
      }
    };
  
    reader.onerror = () => {
      setIsLoading(false);
      setNotification({
        open: true,
        message: 'Error reading file',
        severity: 'error'
      });
    };
  
    reader.readAsArrayBuffer(file);
  };



  const processExcelData = (jsonData) => {
    setIsLoading(true);
    
    // Track invalid rows and duplicate AreaId+ItemCode combinations
    const invalidRowsList = [];
    const rateErrorRowsList = [];
    const areaItemCombinations = new Map();
    const duplicateRowsList = [];
  
    // Validate data types and business rules
    const validData = jsonData.map((row, index) => {
      // Define specific error types for more detailed reporting
      const errors = [];
  
      // Check for empty values
      if (!row.AreaId || !row.ItemCode) {
        errors.push('missing_identifier');
      }
  
      if ((isMOCRateRequired && (row.MOCRate === undefined || row.MOCRate === null || row.MOCRate === '')) ||
        (isVANRateRequired && (row.VANRate === undefined || row.VANRate === null || row.VANRate === '')) ||
        (isMRPRateRequired && (row.MRPRate === undefined || row.MRPRate === null || row.MRPRate === ''))) {
        errors.push('missing_rate');
      }
  
      // Check for negative values
      const vanRate = isVANRateRequired ? Number(row.VANRate) : 0;
      const mocRate = isMOCRateRequired ? Number(row.MOCRate) : 0;
      const mrpRate = isMRPRateRequired ? Number(row.MRPRate) : 0;
  
      if ((isVANRateRequired && vanRate < 0) ||
        (isMOCRateRequired && mocRate < 0) ||
        (isMRPRateRequired && mrpRate < 0)) {
        errors.push('negative_rate');
      }
  
      // Check for more than two decimal places
      if ((isVANRateRequired && String(row.VANRate).includes('.') && String(row.VANRate).split('.')[1].length > 2) ||
        (isMOCRateRequired && String(row.MOCRate).includes('.') && String(row.MOCRate).split('.')[1].length > 2) ||
        (isMRPRateRequired && String(row.MRPRate).includes('.') && String(row.MRPRate).split('.')[1].length > 2)) {
        errors.push('invalid_decimals');
      }
  
      // Check for double decimal points
      if ((isVANRateRequired && String(row.VANRate).split('.').length > 2) ||
        (isMOCRateRequired && String(row.MOCRate).split('.').length > 2) ||
        (isMRPRateRequired && String(row.MRPRate).split('.').length > 2)) {
        errors.push('double_decimal');
      }
  
      // Check for non-numeric rates
      if ((isVANRateRequired && isNaN(vanRate)) ||
        (isMOCRateRequired && isNaN(mocRate)) ||
        (isMRPRateRequired && isNaN(mrpRate))) {
        errors.push('non_numeric_rate');
      }
  
      // Store error information for this row
      if (errors.length > 0) {
        invalidRowsList.push({
          rowNumber: index + 1,
          errors: errors
        });
      }
  
      // Check for rate errors (VANRate or MOCRate > MRPRate)
      const hasRateError = (isVANRateRequired && vanRate > mrpRate) || (isMOCRateRequired && mocRate > mrpRate);
      if (hasRateError) {
        rateErrorRowsList.push(index + 1);
      }
  
      // Check for duplicate AreaId + ItemCode combinations
      const key = `${row.AreaId}-${row.ItemCode}`;
      if (areaItemCombinations.has(key)) {
        duplicateRowsList.push(index + 1);
      } else {
        areaItemCombinations.set(key, index + 1);
      }
  
      return {
        AreaID: String(row.AreaId),
        ItemCode: String(row.ItemCode),
        VANRate: isVANRateRequired ? vanRate : 0,
        MOCRate: isMOCRateRequired ? mocRate : 0,
        MRPRate: isMRPRateRequired ? mrpRate : 0,
        DML: "I" // Default to Insert
      };
    });
  
    // Set the validated rows and errors
    setInvalidRowsList(invalidRowsList);
    setInvalidRows(invalidRowsList.map(item => item.rowNumber));
    setRateErrorRows(rateErrorRowsList);
    setDuplicateRows(duplicateRowsList);
  
    // Calculate all error rows
    const allErrorsRows = [...new Set([...invalidRowsList.map(item => item.rowNumber), ...rateErrorRowsList, ...duplicateRowsList])];
  
    if (allErrorsRows.length > 0) {
      let errorMessage = '';
  
      if (invalidRowsList.length > 0) {
        // Group rows by error type for more specific feedback
        const errorsByType = {
          missing_identifier: [],
          missing_rate: [],
          negative_rate: [],
          invalid_decimals: [],
          special_chars: [],
          double_decimal: [],
          non_numeric_rate: []
        };
  
        invalidRowsList.forEach(item => {
          item.errors.forEach(errorType => {
            errorsByType[errorType].push(item.rowNumber);
          });
        });
  
        errorMessage += 'Data validation errors found: ';
  
        if (errorsByType.missing_identifier.length > 0) {
          errorMessage += `Missing AreaId or ItemCode in rows: ${errorsByType.missing_identifier.join(', ')}. `;
        }
        if (errorsByType.missing_rate.length > 0) {
          errorMessage += `Missing rate values in rows: ${errorsByType.missing_rate.join(', ')}. `;
        }
        if (errorsByType.negative_rate.length > 0) {
          errorMessage += `Negative rate values in rows: ${errorsByType.negative_rate.join(', ')}. `;
        }
        if (errorsByType.invalid_decimals.length > 0) {
          errorMessage += `More than 2 decimal places in rows: ${errorsByType.invalid_decimals.join(', ')}. `;
        }
        if (errorsByType.special_chars.length > 0) {
          errorMessage += `Special characters in AreaId or ItemCode in rows: ${errorsByType.special_chars.join(', ')}. `;
        }
        if (errorsByType.double_decimal.length > 0) {
          errorMessage += `Double decimal points in rows: ${errorsByType.double_decimal.join(', ')}. `;
        }
        if (errorsByType.non_numeric_rate.length > 0) {
          errorMessage += `Non-numeric rate values in rows: ${errorsByType.non_numeric_rate.join(', ')}. `;
        }
      }
  
      if (rateErrorRowsList.length > 0) {
        errorMessage += `Rate errors in rows: ${rateErrorRowsList.join(', ')}. VANRate and MOCRate cannot be greater than MRPRate. `;
      }
  
      if (duplicateRowsList.length > 0) {
        errorMessage += `Duplicate AreaId+ItemCode combinations in rows: ${duplicateRowsList.join(', ')}. `;
      }
  
      setNotification({
        open: true,
        message: errorMessage,
        severity: 'error'
      });
  
      // Still set data for display but don't validate for upload
      setExcelData(jsonData);
      if (allErrorsRows.length === jsonData.length) {
        setValidatedData(null); // No valid data to upload
      } else {
        // Filter out invalid entries for upload
        const validatedEntries = validData.filter((_, index) =>
          !allErrorsRows.includes(index + 1)
        );
        setValidatedData(validatedEntries);
      }
    } else {
      setExcelData(jsonData);
      setValidatedData(validData);
      setNotification({
        open: true,
        message: `Successfully imported ${jsonData.length} items. Ready to upload.`,
        severity: 'success'
      });
    }
    
    setIsLoading(false);
  };

  

  

  const handleUpload = async () => {
    // Check for validation errors before proceeding
    if (!validatedData || validatedData.length === 0) {
      setNotification({
        open: true,
        message: 'Please import and validate data before uploading',
        severity: 'warning'
      });
      return;
    }
  
    // Check if there are any validation errors
    if (invalidRows.length > 0 || duplicateRows.length > 0 || rateErrorRows.length > 0) {
      setNotification({
        open: true,
        message: 'Please fix all validation errors before uploading',
        severity: 'error'
      });
      return;
    }
  
    setIsUploading(true);
  
    try {
      const uniqueId = ''; // Generate a unique ID based on timestamp
      // Convert to IST (UTC+5:30)
      const now = new Date();
      const istOffset = 5.5 * 60 * 60 * 1000; // 5.5 hours in milliseconds
      const istDate = new Date(now.getTime() + istOffset);
      const currentDate = istDate.toISOString();
      const userId = localStorage.getItem('userId') || 'UnknownUser'; // Get userId from localStorage
  
      const payload = {
        Option:'1',
        UniqueId: uniqueId,
        DateOfEntry: currentDate,
        CreatedUserCode: userId, // Use dynamic user ID
        VANRateExists: isVANRateRequired ? 1 : 0,
        MOCRateExists: isMOCRateRequired ? 1 : 0,
        MRPRateExists: isMRPRateRequired ? 1 : 0,
        details: validatedData
      };
  
      console.log('Sending payload:', payload);
  
      const response = await fetch(`${local_signage}/api/v1/insertchannelsalesrate`, {
        method: 'POST',
        headers: {
          'Authorization': `Bearer ${token}`,
          'Content-Type': 'application/json',
        },
        body: JSON.stringify(payload)
      });
      
      if (!response.ok) {
        throw new Error(`API response error: ${response.status} ${response.statusText}`);
      }

      const result = await response.json();

      // Check if the API response contains error descriptions (using errdescr instead of rrdescr)
      if (result.errdescr && Array.isArray(result.errdescr) && result.errdescr.length > 0) {
        // Set state to store the API errors
        setApiErrors(result.errdescr);

        // Create an error message showing the API errors
        const errorCount = result.errdescr.length;
        const itemsWithErrors = result.errdescr.map(item => `${item.AreaID}-${item.itemCode}`).join(', ');
        const errorMessage = `Upload completed with ${errorCount} errors. Items not found: ${itemsWithErrors}`;

        setNotification({
          open: true,
          message: errorMessage,
          severity: 'warning'
        });

        // Show the API errors in the UI
        setShowApiErrorsDialog(true);
      }

      // Check for success status - handle both old and new API response formats
      if (result.success === true || (result.res && Array.isArray(result.res) && result.res.length > 0)) {
        // Handle new API response format
        let uniqueId = '';
        if (result.success === true) {
          // New format: {"success":true,"data":[{"UniqueId":"0000012394"}],"UniqueId":"0000012394"}
          uniqueId = result.UniqueId || (result.data && result.data[0] && result.data[0].UniqueId) || 'N/A';
        } else if (result.res && result.res[0]) {
          // Old format fallback
          uniqueId = result.res[0].UniqueId || 'N/A';
        }
        
        setNotification({
          open: true,
          message: `✅ Data uploaded successfully! Reference ID: ${uniqueId}`,
          severity: 'success'
        });
      
        // Only clear the file if there are no errors
        if (!result.errdescr || !Array.isArray(result.errdescr) || result.errdescr.length === 0) {
          clearFile();
        }
      } else if (result.success === false) {
        // Handle explicit failure in new API format
        setNotification({
          open: true,
          message: `❌ Upload failed. Please check your data and try again.`,
          severity: 'error'
        });
      }

    } catch (error) {
      console.error('Error uploading data:', error);
      setNotification({
        open: true,
        message: `Error uploading data: ${error.message}`,
        severity: 'error'
      });
    } finally {
      setIsUploading(false);
    }
  };


  
  const handleConfirmSkipColumns = (confirm) => {
    setShowConfirmDialog(false);
    
    if (confirm) {
      // User confirmed to skip columns, proceed with validation
      processExcelData(pendingExcelData);
    } else {
      // User canceled, reset
      setPendingExcelData(null);
      setPendingWorkbook(null);
      setNotification({
        open: true,
        message: 'Please adjust your rate type selection to match the Excel columns',
        severity: 'info'
      });
    }
  };
  
  // Add a new confirmation dialog component
  const ColumnMismatchDialog = () => {
    if (!excelColumns || excelColumns.length === 0) return null;
    
    // Determine which columns are in the Excel but not selected
    const extraColumns = [];
    if (excelColumns.some(h => h.toLowerCase() === 'vanrate') && !isVANRateRequired) {
      extraColumns.push('VANRate');
    }
    if (excelColumns.some(h => h.toLowerCase() === 'mocrate') && !isMOCRateRequired) {
      extraColumns.push('MOCRate');
    }
    if (excelColumns.some(h => h.toLowerCase() === 'mrprate') && !isMRPRateRequired) {
      extraColumns.push('MRPRate');
    }
    
    // Determine what is selected currently
    const selectedRates = [
      isMOCRateRequired ? "MOCRate" : "",
      isVANRateRequired ? "VANRate" : "",
      isMRPRateRequired ? "MRPRate" : ""
    ].filter(Boolean).join(", ");
    
    return (
      <Dialog
        open={showConfirmDialog}
        onClose={() => handleConfirmSkipColumns(false)}
        maxWidth="sm"
        fullWidth
      >
        <DialogTitle>
          <Box display="flex" alignItems="center">
            <InfoIcon color="warning" sx={{ mr: 1 }} />
            Column Mismatch Detected
          </Box>
        </DialogTitle>
        <DialogContent>
          <Typography variant="body1" sx={{ mb: 2 }}>
            You have selected to upload {selectedRates}, but your Excel file contains additional rate columns: {extraColumns.join(', ')}.
          </Typography>
          <Typography variant="body1" sx={{ mb: 2 }}>
            Would you like to skip the unselected rate columns and proceed with only the selected ones?
          </Typography>
          <Alert severity="info">
            Clicking "Yes" will ignore the {extraColumns.join(', ')} column{extraColumns.length > 1 ? 's' : ''} during processing.
          </Alert>
        </DialogContent>
        <DialogActions>
          <Button onClick={() => handleConfirmSkipColumns(false)} color="primary">
            Cancel
          </Button>
          <Button onClick={() => handleConfirmSkipColumns(true)} color="warning" variant="contained">
            Yes, Skip Unselected Columns
          </Button>
        </DialogActions>
      </Dialog>
    );
  };
  


  const ApiErrorsDialog = () => {
    return (
      <Dialog
        open={showApiErrorsDialog}
        onClose={() => setShowApiErrorsDialog(false)}
        maxWidth="md"
        fullWidth
      >
        <DialogTitle>
          <Box display="flex" alignItems="center">
            <ErrorOutlineIcon color="error" sx={{ mr: 1 }} />
            API Validation Errors
          </Box>
        </DialogTitle>
        <DialogContent>
          <TableContainer>
            <Table>
              <TableHead>
                <TableRow>
                  <TableCell>Area ID</TableCell>
                  <TableCell>Item Code</TableCell>
                  <TableCell>Error Description</TableCell>
                </TableRow>
              </TableHead>
              <TableBody>
                {apiErrors.map((error, index) => (
                  <TableRow key={index}>
                    <TableCell>{error.AreaID}</TableCell>
                    <TableCell>{error.itemCode}</TableCell>
                    <TableCell>{error.ErrorDescr}</TableCell>
                  </TableRow>
                ))}
              </TableBody>
            </Table>
          </TableContainer>
        </DialogContent>
        <DialogActions>
          <Button
            onClick={() => setShowApiErrorsDialog(false)}
            color="primary"
            variant="contained"
          >
            Close
          </Button>
        </DialogActions>
      </Dialog>
    );
  };


  const clearFile = () => {
    setFile(null);
    setFileName('');
    setExcelData([]);
    setValidatedData(null);
    setInvalidRows([]);
    setDuplicateRows([]);
    setRateErrorRows([]);

    // Reset the file input value if the ref is available
    if (fileInputRef.current) {
      fileInputRef.current.value = '';
    }
  };

  const handleCloseNotification = () => {
    setNotification({ ...notification, open: false });
  };

  // Helper function to determine row styling based on validation errors
  const getRowStyle = (index) => {
    const rowNum = index + 1;
    const isInvalidFormat = invalidRows.includes(rowNum);
    const isDuplicate = duplicateRows.includes(rowNum);
    const hasRateError = rateErrorRows.includes(rowNum);

    if (isInvalidFormat || isDuplicate || hasRateError) {
      return {
        backgroundColor: '#ffebee',
        '&:hover': { backgroundColor: '#ffcdd2' }
      };
    }

    return {
      '&:nth-of-type(odd)': { backgroundColor: '#fafafa' },
      '&:hover': { backgroundColor: '#f5f5f5' }
    };
  };

  // Helper function to get error tooltip message for a row
  // Update the getRowErrorMessage function
  const getRowErrorMessage = (index) => {
    const rowNum = index + 1;
    const errors = [];

    // Find specific error types for this row
    const invalidRow = invalidRowsList.find(item => item.rowNumber === rowNum);
    if (invalidRow) {
      if (invalidRow.errors.includes('missing_identifier')) errors.push("Missing AreaId or ItemCode");
      if (invalidRow.errors.includes('missing_rate')) errors.push("Missing rate value");
      if (invalidRow.errors.includes('negative_rate')) errors.push("Negative rate value");
      if (invalidRow.errors.includes('invalid_decimals')) errors.push("More than 2 decimal places");
      if (invalidRow.errors.includes('special_chars')) errors.push("Special characters in AreaId/ItemCode");
      if (invalidRow.errors.includes('double_decimal')) errors.push("Double decimal point");
      if (invalidRow.errors.includes('non_numeric_rate')) errors.push("Non-numeric rate value");
    }

    if (duplicateRows.includes(rowNum)) {
      errors.push("Duplicate AreaId+ItemCode combination");
    }

    if (rateErrorRows.includes(rowNum)) {
      errors.push("VANRate or MOCRate greater than MRPRate");
    }

    return errors.join(", ");
  };

  return (
    <>
      <Header />
      <ThemeProvider theme={theme}>
        <Box sx={{
          backgroundColor: 'background.default',
          pt: 1,
          pb: 1
        }}>
          <Container maxWidth="xl">
            <Grow in={true} timeout={800}>
              <Paper elevation={3} sx={{ p: 1, borderRadius: 3, overflow: 'hidden' }}>
                <Box sx={{
                  display: 'flex',
                  alignItems: 'center',
                  mb: 3,
                  borderBottom: '1px solid #e0e0e0',
                  pb: 2
                }}>
                  <TableChartIcon sx={{ fontSize: 32, mr: 2, color: 'primary.main' }} />
                  <Typography variant="h4" component="h1">
                    Rate Upload
                  </Typography>
                  <Tooltip title="Upload Excel files with AreaId, ItemCode, VANRate, MOCRate, and MRPRate columns">
                    <IconButton sx={{ ml: 2 }}>
                      <InfoIcon color="action" />
                    </IconButton>
                  </Tooltip>
                </Box>

                <Box sx={{
                  backgroundColor: '#f8faff',
                  p: 1,
                  borderRadius: 2,
                  mb: 1,
                  border: '1px solid #e3f2fd'
                }}>
                  {/* <Typography variant="subtitle1" sx={{ mb: 1, fontWeight: 500 }}>
                    Upload Excel Data
                  </Typography> */}



                  <Grid container spacing={2} sx={{ mt: 1 }}>
                    <Grid item xs={12}>
                      <Typography variant="subtitle2" sx={{ mb: 1 }}>
                        Select Required Rate Types:
                      </Typography>
                    </Grid>
                    <Grid item xs={6} md={3}>
                      <FormControlLabel
                        control={
                          <Checkbox
                            checked={isMOCRateRequired}
                            onChange={() => handleCheckboxChange('MOC')}
                            color="primary"
                          />
                        }
                        label="MOCRate"
                      />
                    </Grid>
                    <Grid item xs={6} md={3}>
                      <FormControlLabel
                        control={
                          <Checkbox
                            checked={isVANRateRequired}
                            onChange={() => handleCheckboxChange('VAN')}
                            color="primary"
                          />
                        }
                        label="VANRate"
                      />
                    </Grid>
                    <Grid item xs={6} md={3}>
                      <FormControlLabel
                        control={
                          <Checkbox
                            checked={isMRPRateRequired}
                            onChange={() => handleCheckboxChange('MRP')}
                            color="primary"
                          />
                        }
                        label="MRPRate"
                      />
                    </Grid>
                    {/* <Grid item xs={12}>
                      <Alert severity="info" sx={{ mt: 1 }}>
                        {!isMOCRateRequired && !isVANRateRequired && !isMRPRateRequired ?
                          "Please select at least one rate type to enable upload" :
                          `Selected rate types: ${[
                            isMOCRateRequired ? "MOCRate" : "",
                            isVANRateRequired ? "VANRate" : "",
                            isMRPRateRequired ? "MRPRate" : ""
                          ].filter(Boolean).join(", ")}`
                        }
                      </Alert>
                    </Grid> */}
                  </Grid>


                  <Grid container spacing={3} alignItems="center">
                    <Grid item xs={12} md={4}>
                      <Box sx={{ display: 'flex', alignItems: 'center' }}>
                        <Button
                          variant="contained"
                          component="label"
                          startIcon={<FileOpenIcon />}
                          sx={{
                            mr: 2,
                            background: 'linear-gradient(45deg, #2196F3 30%, #21CBF3 90%)',
                            boxShadow: '0 3px 5px 2px rgba(33, 203, 243, .3)',
                            color: 'white',
                            '&:hover': {
                              background: 'linear-gradient(45deg, #1976d2 30%, #21a6f3 90%)',
                            }
                          }}
                        >
                          Choose File
                          <input
                            ref={fileInputRef}
                            type="file"
                            accept=".xlsx, .xls"
                            hidden
                            onChange={handleFileChange}
                          />
                        </Button>

                        {fileName && (
                          <Fade in={!!fileName}>
                            <Box sx={{ display: 'flex', alignItems: 'center' }}>
                              <Chip
                                label={fileName}
                                variant="outlined"
                                color="primary"
                                onDelete={clearFile}
                                deleteIcon={<DeleteIcon />}
                                sx={{ maxWidth: '250px' }}
                              />
                            </Box>
                          </Fade>
                        )}
                      </Box>
                    </Grid>

                    <Grid item xs={12} md={4}>
                      <Button
                        variant="contained"
                        color="primary"
                        onClick={handleImport}
                        disabled={!file || isLoading}
                        fullWidth
                        sx={{
                          py: 1.5,
                          background: file && !isLoading ? 'linear-gradient(45deg, #4CAF50 30%, #8BC34A 90%)' : '',
                          boxShadow: file && !isLoading ? '0 3px 5px 2px rgba(76, 175, 80, .3)' : '',
                          '&:hover': {
                            background: file && !isLoading ? 'linear-gradient(45deg, #43A047 30%, #7CB342 90%)' : ''
                          }
                        }}
                      >
                        {isLoading ? (
                          <Box sx={{ display: 'flex', alignItems: 'center' }}>
                            <CircularProgress size={24} color="inherit" sx={{ mr: 1 }} />
                            Processing...
                          </Box>
                        ) : (
                          <>
                            <CloudUploadIcon sx={{ mr: 1 }} /> Validate Data
                          </>
                        )}
                      </Button>
                    </Grid>

                    <Grid item xs={12} md={4}>
                      <Button
                        variant="contained"
                        color="secondary"
                        onClick={handleUpload}
                        disabled={
                          !validatedData ||
                          isUploading ||
                          (!isMOCRateRequired && !isVANRateRequired && !isMRPRateRequired) ||
                          invalidRows.length > 0 ||
                          duplicateRows.length > 0 ||
                          rateErrorRows.length > 0
                        }
                        fullWidth
                        sx={{
                          py: 1.5,
                          background: validatedData && !isUploading && invalidRows.length === 0 && duplicateRows.length === 0 && rateErrorRows.length === 0 ?
                            'linear-gradient(45deg, #FF5722 30%, #FF9800 90%)' : '',
                          boxShadow: validatedData && !isUploading && invalidRows.length === 0 && duplicateRows.length === 0 && rateErrorRows.length === 0 ?
                            '0 3px 5px 2px rgba(255, 87, 34, .3)' : '',
                          '&:hover': {
                            background: validatedData && !isUploading && invalidRows.length === 0 && duplicateRows.length === 0 && rateErrorRows.length === 0 ?
                              'linear-gradient(45deg, #E64A19 30%, #F57C00 90%)' : ''
                          }
                        }}
                      >
                        {isUploading ? (
                          <Box sx={{ display: 'flex', alignItems: 'center' }}>
                            <CircularProgress size={24} color="inherit" sx={{ mr: 1 }} />
                            Uploading...
                          </Box>
                        ) : (
                          <>
                            <SendIcon sx={{ mr: 1 }} /> Submit
                          </>
                        )}
                      </Button>
                    </Grid>
                  </Grid>
                </Box>

                {(invalidRows.length > 0 || duplicateRows.length > 0 || rateErrorRows.length > 0) && (
                  <Alert
                    severity="warning"
                    sx={{ mb: 3 }}
                    action={
                      <Tooltip title="Rows with errors are highlighted in red">
                        <IconButton size="small">
                          <InfoIcon />
                        </IconButton>
                      </Tooltip>
                    }
                  >
                    <Typography variant="subtitle2">Validation Errors Found:</Typography>
                    <Box component="ul" sx={{ mt: 1, pl: 2 }}>
                      {invalidRowsList && invalidRowsList.length > 0 ? (
                        <li>
                          Data validation errors:
                          <Box component="ul" sx={{ pl: 2 }}>
                            {invalidRowsList.map((item, idx) => (
                              <li key={idx}>
                                Row {item.rowNumber}: {item.errors && Array.isArray(item.errors) ? item.errors.map(err => {
                                  switch (err) {
                                    case 'missing_identifier': return 'Missing AreaId or ItemCode';
                                    case 'missing_rate': return 'Missing rate value';
                                    case 'negative_rate': return 'Negative rate value';
                                    case 'invalid_decimals': return 'More than 2 decimal places';
                                    case 'special_chars': return 'Special characters in AreaId/ItemCode';
                                    case 'double_decimal': return 'Double decimal point';
                                    case 'non_numeric_rate': return 'Non-numeric rate value';
                                    default: return err;
                                  }
                                }).join(', ') : 'Unknown error'}
                              </li>
                            ))}
                          </Box>
                        </li>
                      ) : (
                        invalidRows.length > 0 && <li>Invalid data format in rows: {invalidRows.join(', ')}</li>
                      )}
                      {rateErrorRows.length > 0 && (
                        <li>
                          Rate errors (VANRate or MOCRate greater than MRPRate) in rows: {rateErrorRows.join(', ')}
                        </li>
                      )}
                      {duplicateRows.length > 0 && (
                        <li>
                          Duplicate AreaId+ItemCode combinations in rows: {duplicateRows.join(', ')}
                        </li>
                      )}
                    </Box>
                  </Alert>
                )}

                <Divider sx={{ my: 1 }} />

                <Box sx={{ mt: 1 }}>
                  <Typography variant="h6" sx={{ mb: 2, display: 'flex', alignItems: 'center' }}>
                    <TableChartIcon sx={{ mr: 1, fontSize: 20 }} /> Data Preview
                  </Typography>

                  {excelData.length > 0 ? (
                    <Fade in={excelData.length > 0} timeout={800}>
                      <TableContainer component={Paper} sx={{
                        mt: 1,
                         boxShadow: '0 2px 10px rgba(0,0,0,0.08)',
                         borderRadius: 2,
                        maxHeight: '150px', // Set a fixed height
                        overflowY: 'auto'   // Enable vertical scrolling
                       }}>
                        <Table aria-label="excel data table" stickyHeader>
                          <TableHead>
                            <TableRow>
                              <TableCell sx={{ fontWeight: 'bold' }}>Row</TableCell>
                              <TableCell sx={{ fontWeight: 'bold' }}>Area ID</TableCell>
                              <TableCell sx={{ fontWeight: 'bold' }}>Item Code</TableCell>
                              {isVANRateRequired && (
                                <TableCell align="right" sx={{ fontWeight: 'bold' }}>VAN Rate</TableCell>
                              )}
                              {isMOCRateRequired && (
                                <TableCell align="right" sx={{ fontWeight: 'bold' }}>MOC Rate</TableCell>
                              )}
                              {isMRPRateRequired && (
                                <TableCell align="right" sx={{ fontWeight: 'bold' }}>MRP Rate</TableCell>
                              )}
                              <TableCell align="center" sx={{ fontWeight: 'bold' }}>Status</TableCell>
                            </TableRow>
                          </TableHead>

                          <TableBody>
                            {excelData.map((row, index) => {
                              const rowNum = index + 1;
                              const hasError = invalidRows.includes(rowNum) ||
                                duplicateRows.includes(rowNum) ||
                                rateErrorRows.includes(rowNum);
                              const errorMsg = getRowErrorMessage(index);

                              return (
                                <TableRow
                                  key={index}
                                  sx={getRowStyle(index)}
                                >
                                  <TableCell>{rowNum}</TableCell>
                                  <TableCell>{row.AreaId}</TableCell>
                                  <TableCell>{row.ItemCode}</TableCell>
                                  {isVANRateRequired && (
                                    <TableCell
                                      align="right"
                                      sx={rateErrorRows.includes(rowNum) && row.VANRate > row.MRPRate ? { color: 'error.main' } : {}}
                                    >
                                      {typeof row.VANRate === 'number'
                                        ? `${row.VANRate.toFixed(2)}`
                                        : row.VANRate}
                                    </TableCell>
                                  )}
                                  {isMOCRateRequired && (
                                    <TableCell
                                      align="right"
                                      sx={rateErrorRows.includes(rowNum) && row.MOCRate > row.MRPRate ? { color: 'error.main' } : {}}
                                    >
                                      {typeof row.MOCRate === 'number'
                                        ? `${row.MOCRate.toFixed(2)}`
                                        : row.MOCRate}
                                    </TableCell>
                                  )}
                                  {isMRPRateRequired && (
                                    <TableCell align="right">
                                      {typeof row.MRPRate === 'number'
                                        ? `${row.MRPRate.toFixed(2)}`
                                        : row.MRPRate}
                                    </TableCell>
                                  )}
                                  <TableCell align="center">
                                    {hasError ? (
                                      <Tooltip title={errorMsg}>
                                        <ErrorOutlineIcon color="error" />
                                      </Tooltip>
                                    ) : (
                                      <Chip
                                        label="Valid"
                                        size="small"
                                        color="success"
                                        variant="outlined"
                                        sx={{ fontSize: '0.7rem' }}
                                      />
                                    )}
                                  </TableCell>
                                </TableRow>
                              );
                            })}
                          </TableBody>
                        </Table>
                      </TableContainer>
                    </Fade>
                  ) : (
                    <Fade in={!excelData.length} timeout={800}>
                      <Box
                        sx={{
                          p: 5,
                          textAlign: 'center',
                          bgcolor: '#fafafa',
                          borderRadius: 2,
                          border: '2px dashed #e0e0e0',
                          display: 'flex',
                          flexDirection: 'column',
                          alignItems: 'center',
                          justifyContent: 'center'
                        }}
                      >
                        <CloudUploadIcon sx={{ fontSize: 64, color: '#bdbdbd', mb: 2 }} />
                        <Typography variant="h6" color="text.secondary" sx={{ mb: 1 }}>
                          No Data Available
                        </Typography>
                        <Typography variant="body2" color="text.secondary">
                          Upload an Excel file to view your data here
                        </Typography>
                      </Box>
                    </Fade>
                  )}
                </Box>

                {validatedData && validatedData.length > 0 && (
                  <Box sx={{ mt: 1, p: 2, bgcolor: '#e8f5e9', borderRadius: 2, border: '1px solid #c8e6c9' }}>
                    <Typography variant="subtitle1" sx={{ color: '#2e7d32', fontWeight: 500, display: 'flex', alignItems: 'center' }}>
                      <InfoIcon sx={{ mr: 1, fontSize: 20 }} />
                      Data validated successfully. {validatedData.length} valid records ready to upload.
                      {invalidRows.length > 0 || duplicateRows.length > 0 || rateErrorRows.length > 0 ?
                        ` (${invalidRows.length + duplicateRows.length + rateErrorRows.length} invalid records will be skipped)` :
                        ''}
                    </Typography>
                  </Box>
                )}

                {apiErrors.length > 0 && (
                  <Box sx={{ mt: 1, p: 2, bgcolor: '#fff3e0', borderRadius: 2, border: '1px solid #ffe0b2' }}>
                    <Typography variant="subtitle1" sx={{ color: '#e65100', fontWeight: 500, display: 'flex', alignItems: 'center' }}>
                      <ErrorOutlineIcon sx={{ mr: 1, fontSize: 20 }} />
                      {apiErrors.length} items failed validation during upload.
                      <Button
                        color="warning"
                        variant="outlined"
                        size="small"
                        onClick={() => setShowApiErrorsDialog(true)}
                        sx={{ ml: 2 }}
                      >
                        View Errors
                      </Button>
                    </Typography>
                  </Box>
                )}
              </Paper>
            </Grow>

            <Snackbar
              open={notification.open}
              autoHideDuration={6000}
              onClose={handleCloseNotification}
              anchorOrigin={{ vertical: 'bottom', horizontal: 'right' }}
            >
              <Alert
                onClose={handleCloseNotification}
                severity={notification.severity}
                variant="filled"
                sx={{ width: '100%' }}
              >
                {notification.message}
              </Alert>
            </Snackbar>
          </Container>
        </Box>
        <ColumnMismatchDialog />
        <ApiErrorsDialog />
      </ThemeProvider>
    </>
  );
};

export default RateUpload;





































































// import React, { useState, useRef } from 'react';
// import {
//   Button,
//   Box,
//   Typography,
//   Paper,
//   Table,
//   TableBody,
//   TableCell,
//   TableContainer,
//   TableHead,
//   TableRow,
//   Container,
//   Grid,
//   CircularProgress,
//   Chip,
//   Divider,
//   Fade,
//   Grow,
//   Tooltip,
//   IconButton,
//   Alert,
//   Snackbar
// } from '@mui/material';
// import {
//   Dialog,
//   DialogActions,
//   DialogContent,
//   DialogTitle
// } from '@mui/material';
// import CloudUploadIcon from '@mui/icons-material/CloudUpload';
// import DeleteIcon from '@mui/icons-material/Delete';
// import FileOpenIcon from '@mui/icons-material/FileOpen';
// import InfoIcon from '@mui/icons-material/Info';
// import TableChartIcon from '@mui/icons-material/TableChart';
// import SendIcon from '@mui/icons-material/Send';
// import ErrorOutlineIcon from '@mui/icons-material/ErrorOutline';
// import * as XLSX from 'xlsx';
// import { createTheme, ThemeProvider } from '@mui/material/styles';
// import Header from '../Header';

// const theme = createTheme({
//   palette: {
//     primary: {
//       main: '#1976d2',
//     },
//     secondary: {
//       main: '#f50057',
//     },
//     background: {
//       default: '#f5f7fa',
//     },
//   },
//   typography: {
//     h4: {
//       fontWeight: 600,
//     },
//     button: {
//       fontWeight: 500,
//     },
//   },
//   components: {
//     MuiPaper: {
//       styleOverrides: {
//         root: {
//           borderRadius: 12,
//           boxShadow: '0 4px 20px 0 rgba(0,0,0,0.1)',
//         },
//       },
//     },
//     MuiButton: {
//       styleOverrides: {
//         root: {
//           borderRadius: 8,
//           textTransform: 'none',
//           padding: '10px 24px',
//         },
//       },
//     },
//     MuiTableCell: {
//       styleOverrides: {
//         head: {
//           backgroundColor: '#f0f5ff',
//           fontWeight: 'bold',
//         },
//       },
//     },
//   },
// });

// export const RateUpload = () => {
//   const [file, setFile] = useState(null);
//   const [fileName, setFileName] = useState('');
//   const [isLoading, setIsLoading] = useState(false);
//   const [isUploading, setIsUploading] = useState(false);
//   const [excelData, setExcelData] = useState([]);
//   const [notification, setNotification] = useState({ open: false, message: '', severity: 'info' });
//   const [validatedData, setValidatedData] = useState(null);
//   const [invalidRows, setInvalidRows] = useState([]);
//   const [duplicateRows, setDuplicateRows] = useState([]);
//   const [rateErrorRows, setRateErrorRows] = useState([]);
//   const token = localStorage.getItem('AuthorizationToken');
//   const fileInputRef = useRef(null);
//   const [invalidRowsList, setInvalidRowsList] = useState([]);
//   const [apiErrors, setApiErrors] = useState([]);
//   const [showApiErrorsDialog, setShowApiErrorsDialog] = useState(false);
//   const [showConfirmDialog, setShowConfirmDialog] = useState(false);
//   const [excelColumns, setExcelColumns] = useState([]);
  
//   const handleFileChange = (event) => {
//     const selectedFile = event.target.files[0];
//     if (selectedFile) {
//       setFile(selectedFile);
//       setFileName(selectedFile.name);
//       setValidatedData(null);
//       setInvalidRows([]);
//       setDuplicateRows([]);
//       setRateErrorRows([]);
//       setNotification({
//         open: true,
//         message: `File "${selectedFile.name}" selected successfully`,
//         severity: 'success'
//       });
//     }
//   };

//   const handleImport = () => {
//     if (!file) {
//       setNotification({
//         open: true,
//         message: 'Please select a file first',
//         severity: 'warning'
//       });
//       return;
//     }
  
//     setIsLoading(true);
//     setInvalidRows([]);
//     setDuplicateRows([]);
//     setRateErrorRows([]);
//     console.log('Import button pressed. File:', file.name);
  
//     // Read the Excel file
//     const reader = new FileReader();
//     reader.onload = (e) => {
//       try {
//         const data = new Uint8Array(e.target.result);
//         const workbook = XLSX.read(data, { type: 'array' });
//         const firstSheetName = workbook.SheetNames[0];
//         const worksheet = workbook.Sheets[firstSheetName];
  
//         // Convert Excel data to JSON
//         const jsonData = XLSX.utils.sheet_to_json(worksheet);
  
//         // Check if data exists
//         if (jsonData.length === 0) {
//           setNotification({
//             open: true,
//             message: 'No data found in the Excel file',
//             severity: 'error'
//           });
//           setIsLoading(false);
//           return;
//         }
  
//         // Extract headers from the first row
//         const headers = Object.keys(jsonData[0]);
//         setExcelColumns(headers);
  
//         // Check for required columns
//         const requiredColumns = ['ItemCode', 'Rate', 'QualifyQty'];
//         const missingBasicColumns = requiredColumns.filter(col =>
//           !headers.some(header => header.toLowerCase() === col.toLowerCase())
//         );
  
//         if (missingBasicColumns.length > 0) {
//           setNotification({
//             open: true,
//             message: `Missing required columns: ${missingBasicColumns.join(', ')}`,
//             severity: 'error'
//           });
//           setIsLoading(false);
//           return;
//         }
  
//         // If we reach here, proceed with validation
//         processExcelData(jsonData);
  
//       } catch (error) {
//         console.error('Error parsing Excel file:', error);
//         setNotification({
//           open: true,
//           message: 'Error parsing the Excel file. Please make sure it is a valid Excel file.',
//           severity: 'error'
//         });
//         setIsLoading(false);
//       }
//     };
  
//     reader.onerror = () => {
//       setIsLoading(false);
//       setNotification({
//         open: true,
//         message: 'Error reading file',
//         severity: 'error'
//       });
//     };
  
//     reader.readAsArrayBuffer(file);
//   };

//   const processExcelData = (jsonData) => {
//     setIsLoading(true);
    
//     // Track invalid rows and duplicate ItemCode combinations
//     const invalidRowsList = [];
//     const rateErrorRowsList = [];
//     const itemCodeCombinations = new Map();
//     const duplicateRowsList = [];
  
//     // Validate data types and business rules
//     const validData = jsonData.map((row, index) => {
//       // Define specific error types for more detailed reporting
//       const errors = [];
  
//       // Check for empty values
//       if (!row.ItemCode || row.ItemCode === '') {
//         errors.push('missing_identifier');
//       }
  
//       if (row.Rate === undefined || row.Rate === null || row.Rate === '' ||
//           row.QualifyQty === undefined || row.QualifyQty === null || row.QualifyQty === '') {
//         errors.push('missing_rate');
//       }
  
//       // Check for negative values
//       const rate = Number(row.Rate);
//       const qualifyQty = Number(row.QualifyQty);
  
//       if (rate < 0 || qualifyQty < 0) {
//         errors.push('negative_value');
//       }
  
//       // Check for more than two decimal places in Rate
//       if (String(row.Rate).includes('.') && String(row.Rate).split('.')[1].length > 2) {
//         errors.push('invalid_decimals');
//       }
  
//       // Check for double decimal points
//       if (String(row.Rate).split('.').length > 2) {
//         errors.push('double_decimal');
//       }
  
//       // Check for non-numeric rates or quantities
//       if (isNaN(rate) || isNaN(qualifyQty)) {
//         errors.push('non_numeric_value');
//       }
  
//       // Check for special characters in ItemCode
//       if (row.ItemCode && /[^a-zA-Z0-9-_]/.test(row.ItemCode)) {
//         errors.push('special_chars');
//       }
  
//       // Store error information for this row
//       if (errors.length > 0) {
//         invalidRowsList.push({
//           rowNumber: index + 1,
//           errors: errors
//         });
//       }
  
//       // Check for duplicate ItemCode combinations
//       const key = row.ItemCode;
//       if (itemCodeCombinations.has(key)) {
//         duplicateRowsList.push(index + 1);
//       } else {
//         itemCodeCombinations.set(key, index + 1);
//       }
  
//       return {
//         ItemCode: String(row.ItemCode || ''),
//         QualifyQty: qualifyQty,
//         Rate: rate,
//         DML: "I" // Default to Insert
//       };
//     });
  
//     // Set the validated rows and errors
//     setInvalidRowsList(invalidRowsList);
//     setInvalidRows(invalidRowsList.map(item => item.rowNumber));
//     setRateErrorRows(rateErrorRowsList);
//     setDuplicateRows(duplicateRowsList);
  
//     // Calculate all error rows
//     const allErrorsRows = [...new Set([...invalidRowsList.map(item => item.rowNumber), ...rateErrorRowsList, ...duplicateRowsList])];
  
//     if (allErrorsRows.length > 0) {
//       let errorMessage = '';
  
//       if (invalidRowsList.length > 0) {
//         // Group rows by error type for more specific feedback
//         const errorsByType = {
//           missing_identifier: [],
//           missing_rate: [],
//           negative_value: [],
//           invalid_decimals: [],
//           special_chars: [],
//           double_decimal: [],
//           non_numeric_value: [],
//         };
  
//         invalidRowsList.forEach(item => {
//           item.errors.forEach(errorType => {
//             errorsByType[errorType].push(item.rowNumber);
//           });
//         });
  
//         errorMessage += 'Data validation errors found: ';
  
//         if (errorsByType.missing_identifier.length > 0) {
//           errorMessage += `Missing ItemCode values in rows: ${errorsByType.missing_identifier.join(', ')}. `;
//         }
//         if (errorsByType.missing_rate.length > 0) {
//           errorMessage += `Missing Rate or QualifyQty values in rows: ${errorsByType.missing_rate.join(', ')}. `;
//         }
//         if (errorsByType.negative_value.length > 0) {
//           errorMessage += `Negative values in rows: ${errorsByType.negative_value.join(', ')}. `;
//         }
//         if (errorsByType.invalid_decimals.length > 0) {
//           errorMessage += `More than 2 decimal places in Rate in rows: ${errorsByType.invalid_decimals.join(', ')}. `;
//         }
//         if (errorsByType.special_chars.length > 0) {
//           errorMessage += `Special characters in ItemCode in rows: ${errorsByType.special_chars.join(', ')}. `;
//         }
//         if (errorsByType.double_decimal.length > 0) {
//           errorMessage += `Double decimal points in rows: ${errorsByType.double_decimal.join(', ')}. `;
//         }
//         if (errorsByType.non_numeric_value.length > 0) {
//           errorMessage += `Non-numeric values in rows: ${errorsByType.non_numeric_value.join(', ')}. `;
//         }
//       }
  
//       if (duplicateRowsList.length > 0) {
//         errorMessage += `Duplicate ItemCode combinations in rows: ${duplicateRowsList.join(', ')}. `;
//       }
  
//       setNotification({
//         open: true,
//         message: errorMessage,
//         severity: 'error'
//       });
  
//       // Still set data for display but don't validate for upload
//       setExcelData(jsonData);
//       if (allErrorsRows.length === jsonData.length) {
//         setValidatedData(null); // No valid data to upload
//       } else {
//         // Filter out invalid entries for upload
//         const validatedEntries = validData.filter((_, index) =>
//           !allErrorsRows.includes(index + 1)
//         );
//         setValidatedData(validatedEntries);
//       }
//     } else {
//       setExcelData(jsonData);
//       setValidatedData(validData);
//       setNotification({
//         open: true,
//         message: `Successfully imported ${jsonData.length} items. Ready to upload.`,
//         severity: 'success'
//       });
//     }
    
//     setIsLoading(false);
//   };

//   const handleUpload = async () => {
//     // Check for validation errors before proceeding
//     if (!validatedData || validatedData.length === 0) {
//       setNotification({
//         open: true,
//         message: 'Please import and validate data before uploading',
//         severity: 'warning'
//       });
//       return;
//     }
  
//     // Check if there are any validation errors
//     if (invalidRows.length > 0 || duplicateRows.length > 0 || rateErrorRows.length > 0) {
//       setNotification({
//         open: true,
//         message: 'Please fix all validation errors before uploading',
//         severity: 'error'
//       });
//       return;
//     }
  
//     setIsUploading(true);
  
//     try {
//       const currentDate = new Date().toISOString(); // Get current date in ISO format
//       const userId = localStorage.getItem('userId') || 'UnknownUser'; // Get userId from localStorage
  
//       const payload = {
//         UniqueId: "",
//         DateOfEntry: currentDate,
//         CreatedUserCode: userId,
//         details: validatedData
//       };
  
//       console.log('Sending payload:', payload);
  
//       const response = await fetch(`https://retailuat.abisibg.com/api/v1/insertschemerate`, {
//         method: 'POST',
//         headers: {
//           'Authorization': `Bearer ${token}`,
//           'Content-Type': 'application/json',
//         },
//         body: JSON.stringify(payload)
//       });
      
//       if (!response.ok) {
//         throw new Error(`API response error: ${response.status} ${response.statusText}`);
//       }

//       const result = await response.json();

//       // Check if the API response contains error descriptions
//       if (result.errdescr && Array.isArray(result.errdescr) && result.errdescr.length > 0) {
//         // Set state to store the API errors
//         setApiErrors(result.errdescr);

//         // Create an error message showing the API errors
//         const errorCount = result.errdescr.length;
//         const itemsWithErrors = result.errdescr.map(item => `${item.itemCode}`).join(', ');
//         const errorMessage = `Upload completed with ${errorCount} errors. Items not found: ${itemsWithErrors}`;

//         setNotification({
//           open: true,
//           message: errorMessage,
//           severity: 'warning'
//         });

//         // Show the API errors in the UI
//         setShowApiErrorsDialog(true);
//       }

//       // Check for success status (this happens regardless of whether there are errors)
//       if (result.res && Array.isArray(result.res) && result.res.length > 0) {
//         const uniqueId = result.res[0].UniqueId;
        
//         setNotification({
//           open: true,
//           message: `Data uploaded successfully! Reference ID: ${uniqueId}`,
//           severity: 'success'
//         });
      
//         // Only clear the file if there are no errors
//         if (!result.errdescr || !Array.isArray(result.errdescr) || result.errdescr.length === 0) {
//           clearFile();
//         }
//       }

//     } catch (error) {
//       console.error('Error uploading data:', error);
//       setNotification({
//         open: true,
//         message: `Error uploading data: ${error.message}`,
//         severity: 'error'
//       });
//     } finally {
//       setIsUploading(false);
//     }
//   };
  
//   const ApiErrorsDialog = () => {
//     return (
//       <Dialog
//         open={showApiErrorsDialog}
//         onClose={() => setShowApiErrorsDialog(false)}
//         maxWidth="md"
//         fullWidth
//       >
//         <DialogTitle>
//           <Box display="flex" alignItems="center">
//             <ErrorOutlineIcon color="error" sx={{ mr: 1 }} />
//             API Validation Errors
//           </Box>
//         </DialogTitle>
//         <DialogContent>
//           <TableContainer>
//             <Table>
//               <TableHead>
//                 <TableRow>
//                   <TableCell>Item Code</TableCell>
//                   <TableCell>Error Description</TableCell>
//                 </TableRow>
//               </TableHead>
//               <TableBody>
//                 {apiErrors.map((error, index) => (
//                   <TableRow key={index}>
//                     <TableCell>{error.itemCode}</TableCell>
//                     <TableCell>{error.ErrorDescr}</TableCell>
//                   </TableRow>
//                 ))}
//               </TableBody>
//             </Table>
//           </TableContainer>
//         </DialogContent>
//         <DialogActions>
//           <Button
//             onClick={() => setShowApiErrorsDialog(false)}
//             color="primary"
//             variant="contained"
//           >
//             Close
//           </Button>
//         </DialogActions>
//       </Dialog>
//     );
//   };

//   const clearFile = () => {
//     setFile(null);
//     setFileName('');
//     setExcelData([]);
//     setValidatedData(null);
//     setInvalidRows([]);
//     setDuplicateRows([]);
//     setRateErrorRows([]);

//     // Reset the file input value if the ref is available
//     if (fileInputRef.current) {
//       fileInputRef.current.value = '';
//     }
//   };

//   const handleCloseNotification = () => {
//     setNotification({ ...notification, open: false });
//   };

//   // Helper function to determine row styling based on validation errors
//   const getRowStyle = (index) => {
//     const rowNum = index + 1;
//     const isInvalidFormat = invalidRows.includes(rowNum);
//     const isDuplicate = duplicateRows.includes(rowNum);
//     const hasRateError = rateErrorRows.includes(rowNum);

//     if (isInvalidFormat || isDuplicate || hasRateError) {
//       return {
//         backgroundColor: '#ffebee',
//         '&:hover': { backgroundColor: '#ffcdd2' }
//       };
//     }

//     return {
//       '&:nth-of-type(odd)': { backgroundColor: '#fafafa' },
//       '&:hover': { backgroundColor: '#f5f5f5' }
//     };
//   };

//   // Helper function to get error tooltip message for a row
//   const getRowErrorMessage = (index) => {
//     const rowNum = index + 1;
//     const errors = [];

//     // Find specific error types for this row
//     const invalidRow = invalidRowsList.find(item => item.rowNumber === rowNum);
//     if (invalidRow) {
//       if (invalidRow.errors.includes('missing_identifier')) errors.push("Missing ItemCode");
//       if (invalidRow.errors.includes('missing_rate')) errors.push("Missing Rate or QualifyQty");
//       if (invalidRow.errors.includes('negative_value')) errors.push("Negative value");
//       if (invalidRow.errors.includes('invalid_decimals')) errors.push("More than 2 decimal places in Rate");
//       if (invalidRow.errors.includes('special_chars')) errors.push("Special characters in ItemCode");
//       if (invalidRow.errors.includes('double_decimal')) errors.push("Double decimal point");
//       if (invalidRow.errors.includes('non_numeric_value')) errors.push("Non-numeric value");
//     }

//     if (duplicateRows.includes(rowNum)) {
//       errors.push("Duplicate ItemCode");
//     }

//     return errors.join(", ");
//   };

//   return (
//     <>
//       <Header />
//       <ThemeProvider theme={theme}>
//         <Box sx={{
//           minHeight: '10vh',
//           backgroundColor: 'background.default',
//           pt: 1,
//           pb: 1
//         }}>
//           <Container maxWidth="lg">
//             <Grow in={true} timeout={800}>
//               <Paper elevation={3} sx={{ p: 4, borderRadius: 3, overflow: 'hidden' }}>
//                 <Box sx={{
//                   display: 'flex',
//                   alignItems: 'center',
//                   mb: 1,
//                   borderBottom: '1px solid #e0e0e0',
//                   pb: 2
//                 }}>
//                   <TableChartIcon sx={{ fontSize: 32, mr: 2, color: 'primary.main' }} />
//                   <Typography variant="h4" component="h1">
//                     HoReCa Rate Upload
//                   </Typography>
//                   <Tooltip title="Upload Excel files with ItemCode, Rate, and QualifyQty columns">
//                     <IconButton sx={{ ml: 2 }}>
//                       <InfoIcon color="action" />
//                     </IconButton>
//                   </Tooltip>
//                 </Box>

//                 <Box sx={{
//                   backgroundColor: '#f8faff',
//                   p: 3,
//                   borderRadius: 2,
//                   mb: 1,
//                   border: '1px solid #e3f2fd'
//                 }}>
//                   <Typography variant="subtitle1" sx={{ mb: 1, fontWeight: 500 }}>
//                     Upload Excel Data
//                   </Typography>

//                   <Grid container spacing={3} alignItems="center">
//                     <Grid item xs={12} md={4}>
//                       <Box sx={{ display: 'flex', alignItems: 'center' }}>
//                         <Button
//                           variant="contained"
//                           component="label"
//                           startIcon={<FileOpenIcon />}
//                           sx={{
//                             mr: 2,
//                             background: 'linear-gradient(45deg, #2196F3 30%, #21CBF3 90%)',
//                             boxShadow: '0 3px 5px 2px rgba(33, 203, 243, .3)',
//                             color: 'white',
//                             '&:hover': {
//                               background: 'linear-gradient(45deg, #1976d2 30%, #21a6f3 90%)',
//                             }
//                           }}
//                         >
//                           Choose File
//                           <input
//                             ref={fileInputRef}
//                             type="file"
//                             accept=".xlsx, .xls"
//                             hidden
//                             onChange={handleFileChange}
//                           />
//                         </Button>

//                         {fileName && (
//                           <Fade in={!!fileName}>
//                             <Box sx={{ display: 'flex', alignItems: 'center' }}>
//                               <Chip
//                                 label={fileName}
//                                 variant="outlined"
//                                 color="primary"
//                                 onDelete={clearFile}
//                                 deleteIcon={<DeleteIcon />}
//                                 sx={{ maxWidth: '250px' }}
//                               />
//                             </Box>
//                           </Fade>
//                         )}
//                       </Box>
//                     </Grid>

//                     <Grid item xs={12} md={4}>
//                       <Button
//                         variant="contained"
//                         color="primary"
//                         onClick={handleImport}
//                         disabled={!file || isLoading}
//                         fullWidth
//                         sx={{
//                           py: 1.5,
//                           background: file && !isLoading ? 'linear-gradient(45deg, #4CAF50 30%, #8BC34A 90%)' : '',
//                           boxShadow: file && !isLoading ? '0 3px 5px 2px rgba(76, 175, 80, .3)' : '',
//                           '&:hover': {
//                             background: file && !isLoading ? 'linear-gradient(45deg, #43A047 30%, #7CB342 90%)' : ''
//                           }
//                         }}
//                       >
//                         {isLoading ? (
//                           <Box sx={{ display: 'flex', alignItems: 'center' }}>
//                             <CircularProgress size={24} color="inherit" sx={{ mr: 1 }} />
//                             Processing...
//                           </Box>
//                         ) : (
//                           <>
//                             <CloudUploadIcon sx={{ mr: 1 }} /> Validate Data
//                           </>
//                         )}
//                       </Button>
//                     </Grid>

//                     <Grid item xs={12} md={4}>
//                       <Button
//                         variant="contained"
//                         color="secondary"
//                         onClick={handleUpload}
//                         disabled={
//                           !validatedData ||
//                           isUploading ||
//                           invalidRows.length > 0 ||
//                           duplicateRows.length > 0 ||
//                           rateErrorRows.length > 0
//                         }
//                         fullWidth
//                         sx={{
//                           py: 1.5,
//                           background: validatedData && !isUploading && invalidRows.length === 0 && duplicateRows.length === 0 && rateErrorRows.length === 0 ?
//                             'linear-gradient(45deg, #FF5722 30%, #FF9800 90%)' : '',
//                           boxShadow: validatedData && !isUploading && invalidRows.length === 0 && duplicateRows.length === 0 && rateErrorRows.length === 0 ?
//                             '0 3px 5px 2px rgba(255, 87, 34, .3)' : '',
//                           '&:hover': {
//                             background: validatedData && !isUploading && invalidRows.length === 0 && duplicateRows.length === 0 && rateErrorRows.length === 0 ?
//                               'linear-gradient(45deg, #E64A19 30%, #F57C00 90%)' : ''
//                           }
//                         }}
//                       >
//                         {isUploading ? (
//                           <Box sx={{ display: 'flex', alignItems: 'center' }}>
//                             <CircularProgress size={24} color="inherit" sx={{ mr: 1 }} />
//                             Uploading...
//                           </Box>
//                         ) : (
//                           <>
//                             <SendIcon sx={{ mr: 1 }} /> Submit
//                           </>
//                         )}
//                       </Button>
//                     </Grid>
//                   </Grid>
//                 </Box>

//                 {(invalidRows.length > 0 || duplicateRows.length > 0 || rateErrorRows.length > 0) && (
//                   <Alert
//                     severity="warning"
//                     sx={{ mb: 1 }}
//                     action={
//                       <Tooltip title="Rows with errors are highlighted in red">
//                         <IconButton size="small">
//                           <InfoIcon />
//                         </IconButton>
//                       </Tooltip>
//                     }
//                   >
//                    <Typography variant="subtitle2">Validation Errors Found:</Typography>
//                     <Box component="ul" sx={{ mt: 1, pl: 2 }}>
//                       {invalidRowsList && invalidRowsList.length > 0 ? (
//                         <li>
//                           Data validation errors:
//                           <Box component="ul" sx={{ pl: 2 }}>
//                             {invalidRowsList.map((item, idx) => (
//                               <li key={idx}>
//                                 Row {item.rowNumber}: {item.errors && Array.isArray(item.errors) ? item.errors.map(err => {
//                                   switch (err) {
//                                     case 'missing_identifier': return 'Missing ItemCode';
//                                     case 'missing_rate': return 'Missing Rate or QualifyQty value';
//                                     case 'negative_value': return 'Negative value';
//                                     case 'invalid_decimals': return 'More than 2 decimal places in Rate';
//                                     case 'special_chars': return 'Special characters in ItemCode';
//                                     case 'double_decimal': return 'Double decimal point';
//                                     case 'non_numeric_value': return 'Non-numeric value';
//                                     default: return err;
//                                   }
//                                 }).join(', ') : 'Unknown error'}
//                               </li>
//                             ))}
//                           </Box>
//                         </li>
//                       ) : (
//                         invalidRows.length > 0 && <li>Invalid data format in rows: {invalidRows.join(', ')}</li>
//                       )}
//                       {duplicateRows.length > 0 && (
//                         <li>
//                           Duplicate ItemCode combinations in rows: {duplicateRows.join(', ')}
//                         </li>
//                       )}
//                     </Box>
//                   </Alert>
//                 )}

//                 <Divider sx={{ my: 3 }} />

//                 <Box sx={{ mt: 2 }}>
//                   <Typography variant="h6" sx={{ mb: 2, display: 'flex', alignItems: 'center' }}>
//                     <TableChartIcon sx={{ mr: 1, fontSize: 20 }} /> Data Preview
//                   </Typography>

//                   {excelData.length > 0 ? (
//                     <Fade in={excelData.length > 0} timeout={800}>
//                       <TableContainer component={Paper} sx={{
//                         mt: 2,
//                         boxShadow: '0 2px 10px rgba(0,0,0,0.08)',
//                         borderRadius: 2,
//                         maxHeight: 400,
//                         overflow: 'auto'
//                       }}>
//                         <Table aria-label="excel data table" stickyHeader>
//                           <TableHead>
//                             <TableRow>
//                               <TableCell sx={{ fontWeight: 'bold' }}>Row</TableCell>
//                               <TableCell sx={{ fontWeight: 'bold' }}>Item Code</TableCell>
//                               <TableCell align="right" sx={{ fontWeight: 'bold' }}>Rate</TableCell>
//                               <TableCell align="right" sx={{ fontWeight: 'bold' }}>Qualify Qty</TableCell>
//                               <TableCell align="center" sx={{ fontWeight: 'bold' }}>Status</TableCell>
//                             </TableRow>
//                           </TableHead>

//                           <TableBody>
//                             {excelData.map((row, index) => {
//                               const rowNum = index + 1;
//                               const hasError = invalidRows.includes(rowNum) ||
//                                 duplicateRows.includes(rowNum);
//                               const errorMsg = getRowErrorMessage(index);

//                               return (
//                                 <TableRow
//                                   key={index}
//                                   sx={getRowStyle(index)}
//                                 >
//                                   <TableCell>{rowNum}</TableCell>
//                                   <TableCell>{row.ItemCode}</TableCell>
//                                   <TableCell align="right">
//                                     {typeof row.Rate === 'number'
//                                       ? `${row.Rate.toFixed(2)}`
//                                       : row.Rate}
//                                   </TableCell>
//                                   <TableCell align="right">
//                                     {typeof row.QualifyQty === 'number'
//                                       ? `${row.QualifyQty}`
//                                       : row.QualifyQty}
//                                   </TableCell>
//                                   <TableCell align="center">
//                                     {hasError ? (
//                                       <Tooltip title={errorMsg}>
//                                         <ErrorOutlineIcon color="error" />
//                                       </Tooltip>
//                                     ) : (
//                                       <Chip
//                                         label="Valid"
//                                         size="small"
//                                         color="success"
//                                         variant="outlined"
//                                         sx={{ fontSize: '0.7rem' }}
//                                       />
//                                     )}
//                                   </TableCell>
//                                 </TableRow>
//                               );
//                             })}
//                           </TableBody>
//                         </Table>
//                       </TableContainer>
//                     </Fade>
//                   ) : (
//                     <Fade in={!excelData.length} timeout={800}>
//                       <Box
//                         sx={{
//                           p: 5,
//                           textAlign: 'center',
//                           bgcolor: '#fafafa',
//                           borderRadius: 2,
//                           border: '2px dashed #e0e0e0',
//                           display: 'flex',
//                           flexDirection: 'column',
//                           alignItems: 'center',
//                           justifyContent: 'center'
//                         }}
//                       >
//                         <CloudUploadIcon sx={{ fontSize: 64, color: '#bdbdbd', mb: 2 }} />
//                         <Typography variant="h6" color="text.secondary" sx={{ mb: 1 }}>
//                           No Data Available
//                         </Typography>
//                         <Typography variant="body2" color="text.secondary">
//                           Upload an Excel file to view your data here
//                         </Typography>
//                       </Box>
//                     </Fade>
//                   )}
//                 </Box>

//                 {validatedData && validatedData.length > 0 && (
//                   <Box sx={{ mt: 3, p: 2, bgcolor: '#e8f5e9', borderRadius: 2, border: '1px solid #c8e6c9' }}>
//                     <Typography variant="subtitle1" sx={{ color: '#2e7d32', fontWeight: 500, display: 'flex', alignItems: 'center' }}>
//                       <InfoIcon sx={{ mr: 1, fontSize: 20 }} />
//                       Data validated successfully. {validatedData.length} valid records ready to upload.
//                       {invalidRows.length > 0 || duplicateRows.length > 0 ?
//                         ` (${invalidRows.length + duplicateRows.length} invalid records will be skipped)` :
//                         ''}
//                     </Typography>
//                   </Box>
//                 )}

//                 {apiErrors.length > 0 && (
//                   <Box sx={{ mt: 3, p: 2, bgcolor: '#fff3e0', borderRadius: 2, border: '1px solid #ffe0b2' }}>
//                     <Typography variant="subtitle1" sx={{ color: '#e65100', fontWeight: 500, display: 'flex', alignItems: 'center' }}>
//                       <ErrorOutlineIcon sx={{ mr: 1, fontSize: 20 }} />
//                       {apiErrors.length} items failed validation during upload.
//                       <Button
//                         color="warning"
//                         variant="outlined"
//                         size="small"
//                         onClick={() => setShowApiErrorsDialog(true)}
//                         sx={{ ml: 2 }}
//                       >
//                         View Errors
//                       </Button>
//                     </Typography>
//                   </Box>
//                 )}
//               </Paper>
//             </Grow>

//             <Snackbar
//               open={notification.open}
//               autoHideDuration={6000}
//               onClose={handleCloseNotification}
//               anchorOrigin={{ vertical: 'bottom', horizontal: 'right' }}
//             >
//               <Alert
//                 onClose={handleCloseNotification}
//                 severity={notification.severity}
//                 variant="filled"
//                 sx={{ width: '100%' }}
//               >
//                 {notification.message}
//               </Alert>
//             </Snackbar>
//           </Container>
//         </Box>
        
//         {/* ColumnMismatchDialog component */}
//         <Dialog
//           open={showConfirmDialog}
//           onClose={() => setShowConfirmDialog(false)}
//           maxWidth="sm"
//           fullWidth
//         >
//           <DialogTitle>
//             <Box display="flex" alignItems="center">
//               <InfoIcon color="primary" sx={{ mr: 1 }} />
//               Confirm Upload
//             </Box>
//           </DialogTitle>
//           <DialogContent>
//             <Typography variant="body1">
//               You are about to upload {validatedData ? validatedData.length : 0} HORECA rate records.
//               {invalidRows.length > 0 || duplicateRows.length > 0 ? 
//                 ` ${invalidRows.length + duplicateRows.length} invalid records will be skipped.` : ''}
//             </Typography>
//             <Typography variant="body1" sx={{ mt: 2 }}>
//               Do you want to proceed?
//             </Typography>
//           </DialogContent>
//           <DialogActions>
//             <Button onClick={() => setShowConfirmDialog(false)} color="primary">
//               Cancel
//             </Button>
//             <Button
//               onClick={() => {
//                 setShowConfirmDialog(false);
//                 handleUpload();
//               }}
//               color="primary"
//               variant="contained"
//               startIcon={<SendIcon />}
//             >
//               Proceed
//             </Button>
//           </DialogActions>
//         </Dialog>
        
//         <ApiErrorsDialog />
//       </ThemeProvider>
//     </>
//   );
// };

// export default RateUpload;
